"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48285,11083,36256,21572,94336,72047,13325],{

/***/ 72830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getLevelDisplayInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);



var getLevelDisplayInfo = function() {
    return "v1/users/educator-levels-display-config/";
};
var useLevelDisplayInfo = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        selector: null,
        fallbackData: undefined
    };
    var key = getLevelDisplayInfo();
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key, {}, {
        fallbackData: options.fallbackData
    }), levelsDisplayInfo = _ref.data, isValidating = _ref.isValidating, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") return options.selector(levelsDisplayInfo || []);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        key: key,
        levelsDisplayInfo: levelsDisplayInfo,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLevelDisplayInfo);


/***/ }),

/***/ 66029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_updaetQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78162);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);








var StyledAvatar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("img", {
    target: "ecs7e9v0",
    label: "StyledAvatar"
})("border-radius:", function(param) {
    var $circular = param.$circular;
    return $circular ? "50%" : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw;
}, ";width:", function(param) {
    var size = param.size;
    return size;
}, ";height:", function(param) {
    var size = param.size;
    return size;
}, ";object-fit:cover;cursor:pointer;user-drag:none;user-select:none;");
var Avatar = function(props) {
    var src = props.src, className = props.className, circular = props.circular, size = props.size, alt = props.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "src",
        "className",
        "circular",
        "size",
        "alt"
    ]);
    var webp = (0,_utils_updaetQuery__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src, "fm", "webp");
    var imageType = (src === null || src === void 0 ? void 0 : src.includes("png")) ? "png" : "jpg";
    var isBase64 = src === null || src === void 0 ? void 0 : src.startsWith("data:image");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("picture", {
        children: [
            !isBase64 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("source", {
                        srcSet: webp,
                        type: "image/webp"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("source", {
                        srcSet: src,
                        type: "image/".concat(imageType)
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledAvatar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
                $circular: circular,
                visibleByDefault: true,
                src: src,
                className: className,
                height: size,
                width: size,
                decoding: "async",
                loading: "eager",
                alt: alt
            }))
        ]
    });
};
Avatar.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    circular: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
Avatar.defaultProps = {
    src: "/static/images/filler.png",
    height: "initial",
    width: "initial",
    size: null,
    className: "",
    circular: false,
    alt: "Avatar"
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 11326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80797);
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30553);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



/* eslint-disable react/jsx-props-no-spreading */ 




var fontGrey = "var(--color-text-primary)";
var StyledCheckbox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ed4smyk0",
    label: "StyledCheckbox"
})("&.MuiButtonBase-root{padding:0px;padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw, ";background:none;color:", function(param) {
    var disabled = param.disabled, color = param.color, checked = param.checked;
    if (disabled) {
        return "var(--color-text-secondary)";
    }
    if (checked && color) {
        return color;
    }
    return fontGrey;
}, ";.MuiIconButton-label{input{top:0;left:0;width:100%;cursor:inherit;height:100%;margin:0;opacity:0;padding:0;z-index:1;position:absolute;}}}");
var FormControlLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "ed4smyk1",
    label: "FormControlLabel"
})("color:", function(param) {
    var color = param.color;
    return color || fontGrey;
}, ";&.MuiFormControlLabel-root{margin-left:0px;}");
var MUICheckbox = function(props) {
    var checked = props.checked, className = props.className, label = props.label, color = props.color, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "checked",
        "className",
        "label",
        "color"
    ]);
    var checkbox = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledCheckbox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        disableFocusRipple: true,
        disableTouchRipple: true,
        disableRipple: true,
        size: "small",
        color: color || "var(--color-text-primary)",
        checked: checked
    }, data));
    if (label) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FormControlLabel, {
        control: checkbox,
        label: label,
        color: color,
        className: className
    });
    return checkbox;
};
/* harmony default export */ __webpack_exports__["Z"] = (MUICheckbox);
MUICheckbox.propTypes = {
    label: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
MUICheckbox.defaultProps = {
    label: null,
    checked: false,
    color: null,
    onChange: null,
    value: null
};


/***/ }),

/***/ 46736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55517);


var Divider = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1clqyiq0",
    label: "Divider"
})("background-color:var(--color-divider);");
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 15509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39636);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _icon_ArrowBack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93303);
/* harmony import */ var _icon_Close__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(112);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48821);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);








var fontGrey = "var(--color-text-primary)";
var StyledDrawer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
    target: "eqzpp0y0",
    label: "StyledDrawer"
})("&.MuiDrawer-root > .MuiPaper-root{background-color:", function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor || "var(--color-base-0)";
}, ";display:grid;grid-template-columns:repeat(10,", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ");grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-auto-rows:max-content;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_12B */ .t8.SL, ";padding-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";padding-right:115px;overflow-x:hidden;background-image:", function(param) {
    var $imageURL = param.$imageURL;
    return $imageURL && "url(".concat((0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_3__/* .getImage */ .gJ)($imageURL), ")");
}, ";background-position:", function(param) {
    var $imagePosition = param.$imagePosition;
    return $imagePosition;
}, ";background-repeat:no-repeat;background-size:", function(param) {
    var $imageSize = param.$imageSize;
    return $imageSize;
}, ";background-attachment:", function(param) {
    var $backgroundAttachment = param.$backgroundAttachment;
    return $backgroundAttachment;
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";overflow-x:initial;grid-template-columns:repeat(10,1fr);}", function(param) {
    var $login = param.$login, $hideCloseButton = param.$hideCloseButton;
    return !$hideCloseButton && "grid-template-rows: 60px ".concat($login ? "1fr" : "", ";");
}, "}");
var CloseWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eqzpp0y1",
    label: "CloseWrapper"
})("grid-column:1/11;cursor:pointer;@media (max-width:47.95em){grid-column:1/2;width:24px;height:24px;}");
var Drawer = function(param) {
    var children = param.children, anchor = param.anchor, backgroundColor = param.backgroundColor, drawerState = param.drawerState, onClose = param.onClose, hideCloseButton = param.hideCloseButton, showBackButton = param.showBackButton, elevation = param.elevation, onPressBack = param.onPressBack, imageURL = param.imageURL, imagePosition = param.imagePosition, imageSize = param.imageSize, backgroundAttachment = param.backgroundAttachment, disableBackdropClick = param.disableBackdropClick, disableEscapeKeyDown = param.disableEscapeKeyDown, login = param.login, variant = param.variant, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(StyledDrawer, {
        anchor: anchor,
        $backgroundColor: backgroundColor,
        open: drawerState,
        onClose: onClose,
        PaperProps: {
            id: "DrawerPaper"
        },
        $imageURL: imageURL,
        $imagePosition: imagePosition,
        $imageSize: imageSize,
        $backgroundAttachment: backgroundAttachment,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disableBackdropClick: disableBackdropClick,
        $login: login,
        $hideCloseButton: hideCloseButton,
        variant: variant,
        className: className,
        elevation: elevation,
        children: [
            !hideCloseButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CloseWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_Close__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    size: "24px",
                    onClick: onClose,
                    color: fontGrey
                })
            }),
            showBackButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CloseWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    size: "24px",
                    onClick: onPressBack,
                    color: fontGrey
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Drawer);
Drawer.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
            null
        ]),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node)
    ]),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    anchor: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
        "left",
        "right",
        "top",
        "bottom"
    ]),
    drawerState: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    hideCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    showBackButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onPressBack: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    imageURL: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    imagePosition: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    imageSize: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    backgroundAttachment: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    disableEscapeKeyDown: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    disableBackdropClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    login: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    elevation: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number)
};
Drawer.defaultProps = {
    children: null,
    backgroundColor: null,
    anchor: "right",
    drawerState: false,
    hideCloseButton: false,
    showBackButton: false,
    onPressBack: null,
    imageURL: null,
    imagePosition: null,
    imageSize: null,
    backgroundAttachment: null,
    elevation: 16,
    disableEscapeKeyDown: false,
    disableBackdropClick: false,
    login: false,
    variant: "temporary",
    className: ""
};


/***/ }),

/***/ 80867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);
/* harmony import */ var _cont_ErrorBoundary_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65103);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18113);
/* harmony import */ var _utils_errorLogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72874);




/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/jsx-props-no-spreading */ 






/**
 * Extending styles (using @emotion/styled) will only
 * apply the styles to img element, but not to the outer image wrapper (div, next.js adds it) around it.
 *
 * So, can't add styles to the outer image wrapper.
 * Instead, we should create our own wrapper around it and apply styles to it.
 */ var StyledNextImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "e1pacfim0",
    label: "StyledNextImage"
})("-webkit-user-drag:none;user-select:none;");
var SourceImage = function(_param) {
    var src = _param.src, height = _param.height, width = _param.width, hasError = _param.hasError, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "height",
        "width",
        "hasError"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!hasError) {
            (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .validateImage */ .ap)({
                src: src,
                width: width,
                height: height,
                type: "LEGACY"
            });
        }
    }, [
        hasError,
        height,
        src,
        width
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(StyledNextImage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        height: height,
        width: width,
        src: src || _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .fillerImageURL */ .cE,
        loader: _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI
    }));
};
var Image = function(props) {
    return  true && (0,_utils_cookies__WEBPACK_IMPORTED_MODULE_5__/* .readCookie */ .vQ)(_utils_errorLogger__WEBPACK_IMPORTED_MODULE_6__/* .PROD_COOKIE_LOG_KEY */ .m) || "production" === "development" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cont_ErrorBoundary_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        allowRender: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(SourceImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(SourceImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["default"] = (Image);


/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55161);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10076);
/* harmony import */ var _icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21572);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2080);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98811);

/* eslint-disable react/display-name */ /* eslint-disable react/prop-types */ 









var DropDownButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("button", {
    target: "e1v4hctf0",
    label: "DropDownButton"
})("display:flex;justify-content:space-between;min-width:fit-content;align-self:center;align-items:center;line-height:150%;cursor:", function(param) {
    var $isDisabled = param.$isDisabled;
    return $isDisabled ? "not-allowed" : "pointer";
}, ";transition:all 400ms ease-in-out;border-width:1px;border-style:solid;font-weight:600;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";background-color:var(--color-base-1);grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_4B */ .t8.BM, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Fonts.SMALL */ .F3.HC, ";color:var(--color-text-primary);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), ";border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder, open = param.open;
    if (showSelectedBorder) return "var(--color-text-primary)";
    if (open) return "var(--color-divider)";
    return "var(--color-shadow)";
}, ";", function(param) {
    var buttonWidth = param.buttonWidth;
    return buttonWidth && "width: ".concat(buttonWidth, ";");
}, ":hover{background-color:var(--color-base-1);border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder;
    return showSelectedBorder ? "var(--color-text-primary)" : "var(--color-divider)";
}, ";box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw,
    blur: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw
}), ";}@media (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){font-size:12px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, ";white-space:nowrap;grid-column:", function(param) {
    var mwGridColumn = param.mwGridColumn;
    return mwGridColumn || "auto";
}, " !important;}");
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(param, ref) {
    var open = param.open, onClick = param.onClick, gridColumn = param.gridColumn, mwGridColumn = param.mwGridColumn, children = param.children, showSelectedBorder = param.showSelectedBorder, className = param.className, buttonWidth = param.buttonWidth, $isDisabled = param.$isDisabled;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DropDownButton, {
        open: open,
        onClick: onClick,
        gridColumn: gridColumn,
        mwGridColumn: mwGridColumn,
        ref: ref,
        showSelectedBorder: showSelectedBorder,
        className: className,
        type: "button",
        buttonWidth: buttonWidth,
        $isDisabled: $isDisabled,
        children: children
    });
});
var StyledArrowDown = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__["default"], {
    target: "e1v4hctf1",
    label: "StyledArrowDown"
})("transition:transform 400ms ease-in-out;transform:", function(param) {
    var open = param.open;
    return open ? "rotate(180deg)" : "rotate(0deg)";
}, ";@media only screen and (max-width:47.95em){margin-left:8px;}");
var IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1v4hctf2",
    label: "IconWrapper"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:flex;");
var getFavoriteKey = function(option) {
    return [
        "value",
        "code",
        "id",
        "uid"
    ].find(function(key) {
        return Object.keys(option || {}).some(function(k) {
            return k === key;
        });
    });
};
var selectedOptionHasValueOrId = function(selectedOption) {
    var favoriteKey = getFavoriteKey(selectedOption);
    return !lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default()(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]);
};
var isDefined = function(value) {
    return !(value === undefined || value === null);
};
var isSelected = function(selectedOption, option) {
    var favoriteKey = getFavoriteKey(selectedOption);
    if (isDefined(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) === (option === null || option === void 0 ? void 0 : option[favoriteKey])) return true;
    return false;
};
var Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    var _options = props.options, options = _options === void 0 ? [] : _options, selectedOption = props.selectedOption, onOptionClick = props.onOptionClick, onClick = props.onClick, displayCheck = props.displayCheck, children = props.children, gridColumn = props.gridColumn, mwGridColumn = props.mwGridColumn, links = props.links, isDisabled = props.isDisabled, stripLength = props.stripLength, showSelectedBorder = props.showSelectedBorder, className = props.className, openDropDown = props.openDropDown, closeDropdown = props.closeDropdown, state = props.state, useOuterState = props.useOuterState, displayIcon = props.displayIcon, menuWidth = props.menuWidth, menuHeight = props.menuHeight, buttonWidth = props.buttonWidth, placeholder = props.placeholder, menuColor = props.menuColor, topChildren = props.topChildren, showIcon = props.showIcon, textColor = props.textColor, getKey = props.getKey, disablePortal = props.disablePortal;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), anchorEl = _$ref[0], setAnchorEl = _$ref[1];
    var handleClick = function(event) {
        onClick();
        if (isDisabled) {
            return;
        }
        if (useOuterState) openDropDown(event.currentTarget);
        else setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        if (useOuterState) closeDropdown();
        else setAnchorEl(null);
    };
    var handleOptionClick = function(option) {
        onOptionClick(option);
        handleClose();
    };
    var stripLabel = function(label) {
        if (stripLength && (label === null || label === void 0 ? void 0 : label.length) > stripLength) return "".concat(label.substr(0, stripLength), " ...");
        return label;
    };
    var stateOrAnchor = state || anchorEl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Button, {
                open: stateOrAnchor,
                onClick: handleClick,
                gridColumn: gridColumn,
                mwGridColumn: mwGridColumn,
                ref: ref,
                showSelectedBorder: showSelectedBorder && selectedOptionHasValueOrId(selectedOption),
                className: className,
                buttonWidth: buttonWidth,
                $isDisabled: isDisabled,
                children: [
                    displayIcon ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(IconWrapper, {
                        className: "iconWrapper",
                        children: displayIcon
                    }) : null,
                    selectedOption ? stripLabel(selectedOption.label || selectedOption.name || selectedOption.display_name || "No preference") : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        color: textColor || "var(--color-text-secondary)",
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledArrowDown, {
                        open: stateOrAnchor,
                        size: "16px",
                        color: "var(--color-text-primary)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                anchorEl: stateOrAnchor,
                onClose: handleClose,
                width: menuWidth,
                height: menuHeight,
                disablePortal: disablePortal,
                children: [
                    topChildren,
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_MenuItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            displayCheck: displayCheck,
                            selected: isSelected(selectedOption, option),
                            option: option,
                            onClick: handleOptionClick,
                            links: links,
                            color: menuColor,
                            showIcon: showIcon
                        }, getKey(option) || index);
                    }),
                    children
                ]
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.propTypes = {
    selectedOption: prop_types__WEBPACK_IMPORTED_MODULE_10___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    options: prop_types__WEBPACK_IMPORTED_MODULE_10___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    onOptionClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    displayCheck: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    mwGridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    links: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    stripLength: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    showSelectedBorder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    displayIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    menuWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    menuHeight: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    buttonWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    showIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    getKey: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool)
};
Dropdown.defaultProps = {
    selectedOption: null,
    options: [],
    displayCheck: false,
    showIcon: false,
    children: null,
    gridColumn: "span 4",
    mwGridColumn: "auto",
    links: false,
    stripLength: null,
    showSelectedBorder: true,
    displayIcon: null,
    menuWidth: "233px",
    menuHeight: "276px",
    buttonWidth: null,
    onClick: function() {},
    placeholder: "",
    getKey: function(option) {
        return (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.id);
    },
    disablePortal: false
};


/***/ }),

/***/ 98811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76356);
/* harmony import */ var _icon_Check__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92542);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);






var StyledItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx60",
    label: "StyledItem"
})("display:flex;align-items:center;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_3B */ .t8.N, ";cursor:pointer;");
var LinkedLi = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx61",
    label: "LinkedLi"
})("cursor:pointer;");
var GoalImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("img", {
    target: "e10ouzx62",
    label: "GoalImage"
})("height:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";width:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";");
var Label = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("span", {
    target: "e10ouzx63",
    label: "Label"
})("font-size:14px;line-height:150%;color:", function(param) {
    var selected = param.selected;
    return selected ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";color:", function(param) {
    var color = param.color, selected = param.selected;
    return selected && color;
}, ";flex-grow:1;display:block;font-weight:", function(param) {
    var selected = param.selected;
    return selected ? "bold" : "initial";
}, ";");
var anchorStyle = "display: flex; align-items: center; padding: 8px 16px;";
var item = function(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon) {
    var _$ref = option || {}, selGoalIcon = _$ref.icon, selGoalName = _$ref.name, as = _$ref.as, href = _$ref.href, label = _$ref.label, name = _$ref.name, display_name = _$ref.display_name;
    var goalImage = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GoalImage, {
        src: selGoalIcon,
        alt: selGoalName
    });
    if (links) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkedLi, {
        onClick: onMenuClick,
        ref: ref,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            anchorStyle: anchorStyle,
            as: as,
            href: href,
            children: [
                showIcon && goalImage,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                    selected: selected,
                    color: color,
                    children: option.label || option.name || option.display_name
                }),
                selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    size: "24px",
                    color: "var(--color-i-green)"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledItem, {
        ref: ref,
        onClick: onMenuClick,
        children: [
            showIcon && goalImage,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                selected: selected,
                color: color,
                children: label || name || display_name || "No preference"
            }),
            selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: "24px",
                color: "var(--color-i-green)"
            })
        ]
    });
};
var MenuItem = function(param, ref) {
    var option = param.option, selected = param.selected, onClick = param.onClick, displayCheck = param.displayCheck, links = param.links, color = param.color, showIcon = param.showIcon;
    var onMenuClick = function() {
        return onClick(option);
    };
    return item(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon);
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(MenuItem));


/***/ }),

/***/ 13325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EducatorDetailedCard_EducatorDetailedCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/components/Container/EducatorProfile/EducatorAvatar.jsx
var EducatorAvatar = __webpack_require__(84852);
// EXTERNAL MODULE: ./node_modules/camelcase-keys/index.js
var camelcase_keys = __webpack_require__(12828);
var camelcase_keys_default = /*#__PURE__*/__webpack_require__.n(camelcase_keys);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
// EXTERNAL MODULE: ./src/components/Base/H5/H5.jsx
var H5 = __webpack_require__(43807);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/api/hooks/topology/useSelectedGoal.js
var useSelectedGoal = __webpack_require__(96487);
// EXTERNAL MODULE: ./src/components/Container/Batch/utils.js
var utils = __webpack_require__(73993);
;// CONCATENATED MODULE: ./src/components/Composite/EducatorDetailedCard/EducatorProperties.jsx






var AuthorPropertiesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1lt6esb0",
    label: "AuthorPropertiesWrapper"
})("flex-direction:column;display:flex;:first-child{margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}");
var Stats = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e1lt6esb1",
    label: "Stats"
})("@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){font-size:14px;margin-bottom:2px;}");
var EducatorProperties = function(param) {
    var stats = param.stats, label = param.label;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorPropertiesWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stats, {
                color: "var(--color-text-primary)",
                children: stats
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P2/* default */.Z, {
                color: "var(--color-text-secondary)",
                children: label
            })
        ]
    });
};
EducatorProperties.propTypes = {
    stats: (prop_types_default()).string.isRequired,
    label: (prop_types_default()).string.isRequired
};
/* harmony default export */ var EducatorDetailedCard_EducatorProperties = (EducatorProperties);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Icons/EducatorPhotoRevamp/EducatorCardThumbnail/EducatorShadow.jsx

var EducatorShadow = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "121",
        height: "160",
        viewBox: "0 0 121 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_312_14067)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        filter: "url(#filter0_f_312_14067)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                            cx: "85.022",
                            cy: "150",
                            r: "24",
                            fill: "#051414",
                            fillOpacity: "0.19"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        filter: "url(#filter1_f_312_14067)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                            cx: "46.022",
                            cy: "47",
                            r: "24",
                            fill: "#051414",
                            fillOpacity: "0.19"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        filter: "url(#filter2_f_312_14067)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M43.022 74C50.2017 74 56.022 60.1208 56.022 43C56.022 25.8792 50.2017 12 43.022 12C35.8423 12 30.022 25.8792 30.022 43C30.022 49.8839 30.9629 56.2437 32.5548 61.388C30.3209 59.8329 27.9614 59 25.522 59C11.4387 59 0.0219727 86.7583 0.0219727 121C0.0219727 155.242 11.4387 183 25.522 183C39.6052 183 51.022 155.242 51.022 121C51.022 102.168 47.5688 85.2971 42.1179 73.9262C42.4166 73.9751 42.7181 74 43.022 74Z",
                            fill: "#051414",
                            fillOpacity: "0.19"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                        id: "filter0_f_312_14067",
                        x: "48.022",
                        y: "113",
                        width: "74",
                        height: "74",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                                stdDeviation: "6.5",
                                result: "effect1_foregroundBlur_312_14067"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                        id: "filter1_f_312_14067",
                        x: "9.02197",
                        y: "10",
                        width: "74",
                        height: "74",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                                stdDeviation: "6.5",
                                result: "effect1_foregroundBlur_312_14067"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("filter", {
                        id: "filter2_f_312_14067",
                        x: "-12.978",
                        y: "-1",
                        width: "82",
                        height: "197",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("feGaussianBlur", {
                                stdDeviation: "6.5",
                                result: "effect1_foregroundBlur_312_14067"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        id: "clip0_312_14067",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            width: "120",
                            height: "160",
                            fill: "white",
                            transform: "translate(0.0219727)"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EducatorCardThumbnail_EducatorShadow = (EducatorShadow);

// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/api/hooks/profile/useLevelDisplayInfo.js
var useLevelDisplayInfo = __webpack_require__(72830);
// EXTERNAL MODULE: ./src/components/Container/EducatorProfile/constants.jsx
var EducatorProfile_constants = __webpack_require__(88775);
;// CONCATENATED MODULE: ./src/components/Composite/EducatorDetailedCard/EducatorPhoto.tsx








var EducatorImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Image["default"], {
    target: "e17chmsk0",
    label: "EducatorImage"
})("height:150px;width:", styleConstants/* Spacings.SPACING_30B */.t8.hg, ";margin:0 auto;object-fit:cover;");
var NewEducatorImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Image["default"], {
    target: "e17chmsk1",
    label: "NewEducatorImage"
})("&{height:150px;width:auto;max-height:100%;margin:0 auto;object-fit:contain;}");
var FallbackAvatar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Image["default"], {
    target: "e17chmsk2",
    label: "FallbackAvatar"
})("object-fit:cover;");
var UnacademyLogoTopWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e17chmsk3",
    label: "UnacademyLogoTopWrapper"
})("position:absolute;top:30px;height:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";width:", styleConstants/* Spacings.SPACING_40B */.t8.XM, ";border-bottom-left-radius:", styleConstants/* Spacings.SPACING_40B */.t8.XM, ";border-bottom-right-radius:", styleConstants/* Spacings.SPACING_40B */.t8.XM, ";border-top-right-radius:14px;border:", styleConstants/* Spacings.SPACING_1B */.t8.MK, " solid var(--color-i-gray-26);right:10px;");
var UnacademyLogoBottomWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e17chmsk4",
    label: "UnacademyLogoBottomWrapper"
})("position:absolute;bottom:0;left:-12.78px;height:42.94px;width:83.01px;border-top-left-radius:83.01px;border-top-right-radius:83.01px;border-bottom-right-radius:14px;border:", styleConstants/* Spacings.SPACING_1B */.t8.MK, " solid var(--color-i-gray-26);");
var EducatorMedalWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e17chmsk5",
    label: "EducatorMedalWrapper"
})("width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";position:absolute;bottom:-", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";background:var(--color-base-1);border-radius:50%;right:-", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";display:flex;justify-content:center;align-items:center;");
var ShadowWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e17chmsk6",
    label: "ShadowWrapper"
})("position:absolute;bottom:-5px;");
var ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e17chmsk7",
    label: "ImageWrapper"
})("position:absolute;bottom:-", styleConstants/* Spacings.SPACING_5B */.t8.zj, ";width:", styleConstants/* Spacings.SPACING_30B */.t8.hg, ";display:flex;justify-content:center;height:", styleConstants/* Spacings.SPACING_40B */.t8.XM, ";");
var FallbackWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(ImageWrapper, {
    target: "e17chmsk8",
    label: "FallbackWrapper"
})("bottom:0;");
var EducatorPhoto = function(param) {
    var levelInfo = param.levelInfo, newThumbnail = param.newThumbnail, oldThumbnail = param.oldThumbnail, fallback = param.fallback, isPartnerEducator = param.isPartnerEducator;
    var ref;
    var ref1 = (0,useLevelDisplayInfo/* default */.Z)(), _levelsDisplayInfo = ref1.levelsDisplayInfo, levelsDisplayInfo = _levelsDisplayInfo === void 0 ? [] : _levelsDisplayInfo;
    var ref2 = (0,react.useState)(false), isNewImageLoaded = ref2[0], setIsNewImageLoaded = ref2[1];
    var onNewImageLoad = function() {
        setIsNewImageLoaded(true);
    };
    var currentLevelDisplayInfo = isPartnerEducator ? EducatorProfile_constants/* PARTNER_EDUCATOR_CONFIG */.BB : levelsDisplayInfo === null || levelsDisplayInfo === void 0 ? void 0 : (ref = levelsDisplayInfo.find) === null || ref === void 0 ? void 0 : ref.call(levelsDisplayInfo, function(levelDisplayInfo) {
        return levelDisplayInfo.levelId === ((levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.current_level_id) || (levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.currentLevelId));
    });
    var renderEducatorImage = function() {
        if (newThumbnail) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewEducatorImage, {
                src: newThumbnail,
                height: 150,
                width: 120,
                alt: "Unacademy",
                layout: "intrinsic",
                onLoadingComplete: onNewImageLoad
            })
        });
        if (oldThumbnail) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorImage, {
                src: oldThumbnail,
                alt: "Unacademy",
                height: 150,
                width: 120
            })
        });
        if (fallback) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FallbackWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FallbackAvatar, {
                src: fallback,
                alt: "Unacademy",
                height: styleConstants/* Spacings.SPACING_40B */.t8.XM,
                width: styleConstants/* Spacings.SPACING_30B */.t8.hg
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnacademyLogoTopWrapper, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnacademyLogoBottomWrapper, {}),
            newThumbnail && isNewImageLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShadowWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorCardThumbnail_EducatorShadow, {})
            }),
            renderEducatorImage(),
            currentLevelDisplayInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorMedalWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                    src: currentLevelDisplayInfo === null || currentLevelDisplayInfo === void 0 ? void 0 : currentLevelDisplayInfo.asset.badge,
                    alt: "badge",
                    width: 24,
                    height: 24
                })
            })
        ]
    });
};
/* harmony default export */ var EducatorDetailedCard_EducatorPhoto = (EducatorPhoto);

;// CONCATENATED MODULE: ./src/components/Composite/EducatorDetailedCard/EducatorDetailedCard.jsx


























var InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo10",
    label: "InfoWrapper"
})("display:flex;flex-direction:column;justify-content:space-between;margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";flex:1;@media only screen and (max-width:", styleConstants/* mobile.maxWidth */.ai.maxWidth, "){margin-left:", function(param) {
    var $isNewEducatorCard = param.$isNewEducatorCard;
    return $isNewEducatorCard ? "".concat(styleConstants/* Spacings.SPACING_4B */.t8.BM) : "".concat(styleConstants/* Spacings.SPACING_14B */.t8.zJ);
}, ";}");
var AuthorWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo11",
    label: "AuthorWrapper"
})("flex-direction:column;");
var AuthorNameWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo12",
    label: "AuthorNameWrapper"
})("margin-bottom:", function(param) {
    var $isExEducator = param.$isExEducator;
    return $isExEducator ? styleConstants/* Spacings.SPACING_4B */.t8.BM : styleConstants/* Spacings.SPACING_1B */.t8.MK;
}, ";@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){display:flex;flex-direction:column;align-items:flex-start;margin-left:", function(param) {
    var $marginLeft = param.$marginLeft;
    return $marginLeft;
}, ";}");
var AuthorName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo13",
    label: "AuthorName"
})("display:flex;align-items:center;");
var FooterWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo14",
    label: "FooterWrapper"
})("display:flex;justify-content:space-between;");
var AuthorDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e1on4jo15",
    label: "AuthorDetails"
})("margin-bottom:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";color:var(--color-text-secondary);text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{-webkit-line-clamp:3;}");
var EducatorPropertiesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo16",
    label: "EducatorPropertiesWrapper"
})("display:flex;");
var AuthorInfoOld = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1on4jo17",
    label: "AuthorInfoOld"
})(styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:flex;align-items:flex-start;}");
var AuthorInfoNew = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(AuthorInfoOld, {
    target: "e1on4jo18",
    label: "AuthorInfoNew"
})("position:relative;width:", styleConstants/* Spacings.SPACING_30B */.t8.hg, ";height:", styleConstants/* Spacings.SPACING_40B */.t8.XM, ";background:var(--color-i-gray-27);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";overflow:hidden;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){display:flex;align-items:flex-start;}");
var Name = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e1on4jo19",
    label: "Name"
})("@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){font-size:14px;}");
var StyH5 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H5/* default */.Z, {
    target: "e1on4jo110",
    label: "StyH5"
})("text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;max-width:250px;");
var EducatorDetailedCard = function(param) {
    var gridColumn = param.gridColumn, linkStyle = param.linkStyle, educator = param.educator, showFollow = param.showFollow, toggleFollow = param.toggleFollow, dataAnalytics = param.dataAnalytics, index = param.index, useLeaderboardMetaInfo = param.useLeaderboardMetaInfo, className = param.className, type = param.type, updateRecentSearchLog = param.updateRecentSearchLog, searchData = param.searchData, showBadge = param.showBadge, showNewEducatorCard = param.showNewEducatorCard;
    var ref;
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var ref1 = (0,useSelectedGoal/* default */.ZP)(), goalData = ref1.selectedGoal;
    var educatorLevelInfo = camelcase_keys_default()(educator === null || educator === void 0 ? void 0 : educator.levelInfo, {
        deep: true
    });
    var getLevelUid = function() {
        if (type === "search") {
            var ref;
            var currentGoal = educatorLevelInfo === null || educatorLevelInfo === void 0 ? void 0 : (ref = educatorLevelInfo.goalWise) === null || ref === void 0 ? void 0 : ref.find(function(goalObject) {
                return goalObject.goalId === goalData.uid;
            });
            return (currentGoal === null || currentGoal === void 0 ? void 0 : currentGoal.levelId) || (educatorLevelInfo === null || educatorLevelInfo === void 0 ? void 0 : educatorLevelInfo.maxLevelId);
        }
        return (educatorLevelInfo === null || educatorLevelInfo === void 0 ? void 0 : educatorLevelInfo.levelId) || (educator === null || educator === void 0 ? void 0 : educator.levelId);
    };
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalData.uid
    });
    var levelInfoData = {
        current_level_id: showBadge ? getLevelUid() : -1
    };
    var thumbnail = educator.thumbnail, avatar = educator.avatar, firstName = educator.firstName, lastName = educator.lastName, name = educator.name, isExEducator = educator.isExEducator, liveMinutes = educator.liveMinutes, followersCount = educator.followersCount, description = educator.description, stats = educator.stats, totalWatchMins = educator.totalWatchMins, _totalWatchTime = educator.totalWatchTime, totalWatchTime = _totalWatchTime === void 0 ? 0 : _totalWatchTime, username = educator.username, _leaderboardMetaInfo = educator.leaderboardMetaInfo, leaderboardMetaInfo = _leaderboardMetaInfo === void 0 ? {} : _leaderboardMetaInfo, uid = educator.uid, avatarV2 = educator.avatarV2, oldAvatar = educator.oldAvatar, fallbackAvatar = educator.fallbackAvatar, bio = educator.bio, educatorTypeV2 = educator.educatorTypeV2;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isFollowing = (0,es/* useSelector */.v9)(function(param) {
        var users = param.users;
        var ref;
        return ((ref = users.data[username]) === null || ref === void 0 ? void 0 : ref.isFollowing) || false;
    });
    var isPartnerEducator = educatorTypeV2 === utils/* EDUCATOR_TYPES.PARTNER */.MB.PARTNER;
    var watchMins = Math.round((stats === null || stats === void 0 ? void 0 : (ref = stats.statistics) === null || ref === void 0 ? void 0 : ref.TOTAL_WATCH_TIME_MINUTES) / 60) || Math.round(totalWatchTime / 60) || totalWatchMins || liveMinutes;
    var getProps = function() {
        var valueProps = [];
        if (watchMins > 0) valueProps.push({
            display_string: "Watch mins",
            value: watchMins,
            type: 1
        });
        if (!isExEducator) valueProps.push({
            display_string: "Followers",
            value: followersCount,
            type: 1
        });
        return valueProps;
    };
    var valueProps = [];
    if (useLeaderboardMetaInfo) {
        var ref2;
        valueProps = (leaderboardMetaInfo === null || leaderboardMetaInfo === void 0 ? void 0 : (ref2 = leaderboardMetaInfo.value_props) === null || ref2 === void 0 ? void 0 : ref2.length) ? leaderboardMetaInfo.value_props : getProps();
    } else {
        valueProps = getProps();
    }
    var anchorStyle = "\n    height: 196px;\n    background-color: var(--color-base-1);\n    grid-column: ".concat(gridColumn, ";\n    padding: ").concat(styleConstants/* Spacings.SPACING_4B */.t8.BM, " ").concat(styleConstants/* Spacings.SPACING_4B */.t8.BM, ";\n    display: flex;\n    box-shadow: ").concat((0,boxShadowGenerator/* default */.Z)(), ";\n    border-radius: ").concat(styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";\n    cursor: pointer;\n    flex: 1;\n    :hover {\n      box-shadow: ").concat((0,boxShadowGenerator/* default */.Z)({
        yOffset: styleConstants/* Spacings.SPACING_1B */.t8.MK,
        blur: styleConstants/* Spacings.SPACING_2B */.t8.Rw
    }), ";\n    }\n    transition: box-shadow 0.2s ease-in-out;\n    @media only screen and (max-width: ").concat(styleConstants/* mobile.maxWidth */.ai.maxWidth, ") {\n      flex-direction: ").concat(showNewEducatorCard ? "row" : "column", ";\n      height: auto;\n      &.last{\n        margin-bottom: 56px;\n      }\n    }\n  ");
    var handleAnalytics = function() {
        if (type === "search") {
            var nSearchData = (0,_object_spread/* default */.Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            analytics/* segment.track */.EX.track(segment/* SEARCH_RESULT_CLICKED */.dW7, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
                sub_position: index + 1,
                educator_uid: uid,
                educator_username: username,
                educator_name: name,
                last_primary_source: segment/* SEARCH_RESULT_PAGE */.jDH,
                last_primary_source_section: "Educator",
                search_section: "Global",
                current_screen: "Educator",
                eventName: segment/* SEARCH_RESULT_CLICKED */.dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.object_type, ":").concat(uid),
                userToken: uid
            }), nSearchData), {
                position: position
            }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY);
            dispatch(updateRecentSearchLog((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchData), {
                entity_id: "".concat(searchData.object_type, ":").concat(uid),
                goal_uid: goalData.uid
            })));
        }
    };
    var getName = function() {
        var fullName = "".concat(firstName, " ").concat(lastName);
        return name || fullName;
    };
    var renderAuthorInfo = function() {
        if (showNewEducatorCard) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorInfoNew, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorDetailedCard_EducatorPhoto, {
                    levelInfo: levelInfoData,
                    newThumbnail: avatarV2,
                    oldThumbnail: oldAvatar,
                    fallback: fallbackAvatar || avatar,
                    isPartnerEducator: isPartnerEducator
                })
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorInfoOld, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorAvatar/* default */.Z, {
                    src: thumbnail,
                    levelInfo: levelInfoData,
                    size: "S",
                    isPartnerEducator: isPartnerEducator
                }),
                isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorNameWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
                        color: "var(--color-text-primary)",
                        children: name
                    })
                }) : null
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
        href: "/[authorID]",
        as: "/@".concat(username),
        anchorStyle: anchorStyle + linkStyle,
        onClick: handleAnalytics,
        className: className,
        children: [
            renderAuthorInfo(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoWrapper, {
                "data-analytics": "".concat(dataAnalytics, "-educatorsCard"),
                $isNewEducatorCard: showNewEducatorCard,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorWrapper, {
                        children: [
                            isMobile && !showNewEducatorCard ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorNameWrapper, {
                                $isExEducator: isExEducator,
                                $marginLeft: showNewEducatorCard ? 0 : "12px",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorName, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH5, {
                                            color: "var(--color-text-primary)",
                                            as: "h4",
                                            children: getName()
                                        })
                                    }),
                                    isExEducator && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H7/* default */.Z, {
                                        color: "var(--color-text-secondary)",
                                        children: "Ex-educator"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorDetails, {
                                title: description,
                                children: isExEducator ? constants/* ExEducatorDescription */.R8 : description || bio
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorPropertiesWrapper, {
                                children: valueProps.slice(0, 3).map(function(valueProp) {
                                    var propLabel = valueProp.display_string, value = valueProp.value, nType = valueProp.type;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorDetailedCard_EducatorProperties, {
                                        label: propLabel,
                                        stats: nType === constants/* educatorValuePropsTypes.INTEGER */.SD.INTEGER ? (0,textHelper/* nFormatter */.pF)(value) : value
                                    }, propLabel);
                                })
                            }),
                            showFollow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                label: isFollowing ? "Following" : "Follow",
                                variant: isFollowing ? "hollow" : "filled",
                                color: isFollowing ? "black" : "green",
                                grid: 2,
                                onClick: toggleFollow(username, !isFollowing)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
EducatorDetailedCard.propTypes = {
    gridColumn: (prop_types_default()).string,
    linkStyle: (prop_types_default()).string,
    educator: prop_types_default().objectOf((prop_types_default()).any),
    showFollow: (prop_types_default()).bool,
    toggleFollow: (prop_types_default()).func,
    dataAnalytics: (prop_types_default()).string,
    index: (prop_types_default()).number.isRequired,
    useLeaderboardMetaInfo: (prop_types_default()).bool,
    showBadge: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    type: (prop_types_default()).string,
    updateRecentSearchLog: (prop_types_default()).func,
    showNewEducatorCard: (prop_types_default()).bool,
    searchData: prop_types_default().objectOf((prop_types_default()).any)
};
EducatorDetailedCard.defaultProps = {
    gridColumn: "span 6",
    educator: {},
    linkStyle: "",
    showFollow: false,
    toggleFollow: function() {},
    dataAnalytics: "",
    useLeaderboardMetaInfo: false,
    showBadge: false,
    className: "",
    type: "",
    updateRecentSearchLog: function() {},
    searchData: {},
    showNewEducatorCard: true
};
/* harmony default export */ var EducatorDetailedCard_EducatorDetailedCard = (EducatorDetailedCard);


/***/ }),

/***/ 73742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1ac2qzn0",
    label: "Wrapper"
})("& .bounce1{-webkit-animation-delay:-0.32s;animation-delay:-0.32s;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2 */ .t8.Jl, ";}& .bounce2{-webkit-animation-delay:-0.16s;animation-delay:-0.16s;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2 */ .t8.Jl, ";}");
var DotLoader = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1ac2qzn1",
    label: "DotLoader"
})("width:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_3B */ .t8.N, ";height:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_3B */ .t8.N, ";background-color:var(--color-text-primary);border-radius:100%;display:inline-block;-webkit-animation:sk-bouncedelay 1.4s infinite ease-in-out both;animation:sk-bouncedelay 1s infinite ease-in-out both;@-webkit-keyframes sk-bouncedelay{0%,80%,100%{-webkit-transform:scale(0.5);}40%{-webkit-transform:scale(1);}}@keyframes sk-bouncedelay{0%,80%,100%{-webkit-transform:scale(0.5);transform:scale(0.5);}40%{-webkit-transform:scale(1);transform:scale(1);}}");
var BounceLoader = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DotLoader, {
                className: "bounce1"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DotLoader, {
                className: "bounce2"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DotLoader, {
                className: "bounce3"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BounceLoader);


/***/ }),

/***/ 56013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var PreviewButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e19xvlnf0",
    label: "PreviewButton"
})("display:flex;width:auto;align-items:center;cursor:pointer;background-color:rgba(60,72,82,0.48);border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw, ";position:absolute;bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_3B */ .t8.N, ";left:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_3B */ .t8.N, ";backdrop-filter:blur(4px);transition:all 400ms ease;&:hover{background-color:rgba(60,72,82,1);}");
/* harmony default export */ __webpack_exports__["Z"] = (PreviewButton);
PreviewButton.propTypes = {
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func.isRequired)
};


/***/ }),

/***/ 74067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FB": function() { return /* binding */ FB; },
/* harmony export */   "LinkContainer": function() { return /* binding */ LinkContainer; },
/* harmony export */   "Tweet": function() { return /* binding */ Tweet; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _base_H3_H3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82034);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10076);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _icon_Facebook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42644);
/* harmony import */ var _icon_Twitter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78415);
/* harmony import */ var _useShare__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10505);









var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezq2yiq0",
    label: "Wrapper"
})("padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_10B */ .t8.FC, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_12B */ .t8.SL, ";text-align:center;@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mobile.maxWidth */ .ai.maxWidth, "){padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";}");
var ShareLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezq2yiq1",
    label: "ShareLink"
})("display:grid;grid-template:1fr / 1fr max-content;grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";width:464px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6B */ .t8.BY, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";border:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .PRIMARY_BORDER_WIDTH */ .UK, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .SOLID_BORDER_STYLE */ .T_, " var(--color-divider);@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mobile.maxWidth */ .ai.maxWidth, "){width:100%;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";}");
var Copy = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H6_H6__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ezq2yiq2",
    label: "Copy"
})("cursor:pointer;@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mobile.maxWidth */ .ai.maxWidth, "){font-size:12px;}");
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezq2yiq3",
    label: "Flex"
})("display:flex;margin:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6B */ .t8.BY, " auto;justify-content:center;");
var Link = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H6_H6__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ezq2yiq4",
    label: "Link"
})("color:var(--color-text-primary);@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mobile.maxWidth */ .ai.maxWidth, "){font-size:12px;white-space:nowrap;}");
var FB = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_icon_Facebook__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "ezq2yiq5",
    label: "FB"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";background:", function(param) {
    var $iconBackground = param.$iconBackground;
    return $iconBackground || "var(--color-divider)";
}, ";cursor:pointer;& path{fill:", function(param) {
    var $iconColor = param.$iconColor;
    return $iconColor;
}, ";}");
var Tweet = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_icon_Twitter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "ezq2yiq6",
    label: "Tweet"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";background:", function(param) {
    var $iconBackground = param.$iconBackground;
    return $iconBackground || "var(--color-divider)";
}, ";cursor:pointer;& path{fill:", function(param) {
    var $iconColor = param.$iconColor;
    return $iconColor;
}, ";}");
var LinkContainer = function(param) {
    var link = param.link, copied = param.copied, onCopy = param.onCopy, copyColor = param.copyColor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(ShareLink, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Link, {
                lineClamp: 1,
                children: link
            }),
            navigator.clipboard && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Copy, {
                color: copied ? "var(--color-text-primary)" : copyColor,
                onClick: onCopy,
                children: copied ? "Copied" : "COPY"
            })
        ]
    });
};
var ShareDialog = function(param) {
    var data = param.data, useDataLink = param.useDataLink, twitterText = param.twitterText, iconBackground = param.iconBackground, iconColor = param.iconColor, copyColor = param.copyColor;
    var ref = data || {}, _name = ref.name, name = _name === void 0 ? "" : _name;
    var link = useDataLink ? data.permalink : window.location.href;
    var ref1 = (0,_useShare__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        title: name,
        text: twitterText,
        link: link
    }), copied = ref1.copied, handleFBShare = ref1.handleFBShare, handleTwitterShare = ref1.handleTwitterShare, copyToClipboard = ref1.copyToClipboard;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_base_H3_H3__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                color: "var(--color-text-primary)",
                children: "Share via"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(Flex, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(FB, {
                        $iconBackground: iconBackground,
                        $iconColor: iconColor,
                        size: "40px",
                        onClick: handleFBShare
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Tweet, {
                        $iconBackground: iconBackground,
                        $iconColor: iconColor,
                        size: "40px",
                        onClick: handleTwitterShare
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(LinkContainer, {
                link: link,
                copied: copied,
                copyColor: copyColor,
                onCopy: copyToClipboard
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShareDialog);
ShareDialog.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_8___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_8___default().any)),
    useDataLink: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    twitterText: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    iconBackground: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    iconColor: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    copyColor: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
ShareDialog.defaultProps = {
    data: {},
    iconBackground: "var(--color-divider)",
    iconColor: "var(--color-base-fill)",
    useDataLink: false,
    twitterText: null,
    copyColor: "var(--color-i-green)"
};


/***/ }),

/***/ 10505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_socialShare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80572);


var useShare = function(param) {
    var title = param.title, text = param.text, link = param.link, _textToCopy = param.textToCopy, textToCopy = _textToCopy === void 0 ? null : _textToCopy;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), copied = ref[0], setCopied = ref[1];
    var updatedLink = link || window.location.href;
    var handleFBShare = function() {
        return _utils_socialShare__WEBPACK_IMPORTED_MODULE_1__/* ["default"].shareToFB */ .Z.shareToFB({
            url: updatedLink,
            title: title
        });
    };
    var handleTwitterShare = function() {
        return _utils_socialShare__WEBPACK_IMPORTED_MODULE_1__/* ["default"].shareToTwitter */ .Z.shareToTwitter({
            url: updatedLink,
            text: text
        });
    };
    var copyToClipboard = function() {
        var navigator = window.navigator.clipboard.writeText(textToCopy !== null && textToCopy !== void 0 ? textToCopy : link);
        return navigator === null || navigator === void 0 ? void 0 : navigator.then(function() {
            return setCopied(true);
        });
    };
    return {
        copied: copied,
        handleFBShare: handleFBShare,
        handleTwitterShare: handleTwitterShare,
        copyToClipboard: copyToClipboard
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useShare);


/***/ }),

/***/ 38245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StoryItem_StoryItem; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/redux/actions/courses.js
var courses = __webpack_require__(5861);
;// CONCATENATED MODULE: ./src/constants/modeltypes.js
var TEXT = 0;
var IMAGE = 1;
var COURSE = 4;
var CLASS = 5;
var QUIZ = 7;
var EDUCATOR = 10;
var DOCUMENT = 17;
var CLASS_RESCHEDULE = 18;
var LEADERBOARD = 19;
var PRACTICE_PUBLISHED = 20;
var COURSE_EDIT = 21;


// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/Avatar/Avatar.jsx
var Avatar = __webpack_require__(66029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 12 modules
var TextField = __webpack_require__(99943);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/Icons/Icon.jsx
var Icon = __webpack_require__(55447);
;// CONCATENATED MODULE: ./src/components/Icons/Send.jsx




var Send = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        path: "M69.133 40.167v-0.167c0.008-0.055 0.012-0.119 0.012-0.183s-0.004-0.128-0.013-0.191l0.001 0.007c0.007-0.030 0.011-0.065 0.011-0.1s-0.004-0.070-0.011-0.103l0.001 0.003c-0.003-0.050-0.004-0.108-0.004-0.167s0.001-0.117 0.005-0.175l-0 0.008c-0.097-0.179-0.197-0.331-0.307-0.476l0.007 0.009-0.233-0.267c-0.143-0.133-0.308-0.245-0.488-0.329l-0.012-0.005h-0.167l-53.567-24.7c-0.302-0.135-0.655-0.214-1.026-0.214-0.673 0-1.285 0.259-1.743 0.682l0.002-0.002c-0.492 0.474-0.797 1.138-0.797 1.873 0 0.358 0.073 0.7 0.204 1.010l-0.006-0.017 9.333 23.333-9.333 23.333c-0.1 0.257-0.157 0.555-0.157 0.867 0 1.362 1.104 2.467 2.467 2.467 0.008 0 0.017-0 0.025-0h-0.001c0.155 0.032 0.334 0.050 0.517 0.050s0.361-0.018 0.534-0.053l-0.017 0.003 53.333-24.267c0.178-0.086 0.331-0.186 0.47-0.303l-0.003 0.003 0.2-0.167c0.23-0.195 0.412-0.441 0.529-0.721l0.005-0.013s0 0 0-0.2c0.127-0.242 0.211-0.526 0.233-0.826l0-0.007zM55.133 37.5h-30.4l-6.667-16.9zM17.967 59.4l6.667-16.9h30.4z"
    }));
};
/* harmony default export */ var Icons_Send = (Send);

// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
;// CONCATENATED MODULE: ./src/components/Base/CommentField/CommentField.jsx









var StyledTextField = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(TextField/* default */.Z, {
    target: "eo9for0",
    label: "StyledTextField"
})("&.MuiFormControl-root{.MuiFilledInput-underline:before{border-bottom:none;}.MuiFilledInput-underline:after{border-bottom:none;}.MuiInputBase-root{background:var(--color-base-1);box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";border-radius:8px;.MuiInputBase-input{font-size:12px;color:var(--color-text-secondary);}.MuiInputBase-input::placeholder{font-size:12px;color:var(--color-text-secondary);}.MuiFilledInput-input{padding-top:12px;padding-bottom:14px;}}}");
var StyleSend = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Icons_Send, {
    target: "eo9for1",
    label: "StyleSend"
})("cursor:pointer;");
var CommentField = function(props) {
    var onClick = props.onClick, placeholder = props.placeholder, inputProps = (0,_object_without_properties/* default */.Z)(props, [
        "onClick",
        "placeholder"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextField, (0,_object_spread/* default */.Z)({
        placeholder: placeholder,
        fullWidth: true,
        InputProps: {
            endAdornment: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAdornment/* default */.Z, {
                onClick: onClick,
                position: "end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyleSend, {
                    size: "24px",
                    color: "var(--color-i-green)"
                })
            })
        },
        variant: "filled"
    }, inputProps));
};
CommentField.propTypes = {
    onClick: (prop_types_default()).func,
    placeholder: (prop_types_default()).string
};
CommentField.defaultProps = {
    onClick: function() {},
    placeholder: "Type your comment"
};
/* harmony default export */ var CommentField_CommentField = (CommentField);

// EXTERNAL MODULE: ./src/components/Base/Divider/Divider.jsx
var Divider = __webpack_require__(46736);
// EXTERNAL MODULE: ./src/components/Composite/InfiniteList/InfiniteList.jsx + 1 modules
var InfiniteList = __webpack_require__(88074);
// EXTERNAL MODULE: ./src/components/Base/P1/P1.jsx
var P1 = __webpack_require__(85620);
// EXTERNAL MODULE: ./src/utils/dates.js
var dates = __webpack_require__(97428);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/Card.jsx


var Card = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1smlkk20",
    label: "Card"
})("padding:16px;background:var(--color-base-1);box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";border-radius:8px;width:100%;");
/* harmony default export */ var StoryItem_Card = (Card);

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/CommentCard.jsx







var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wm6z7s0",
    label: "Container"
})("display:flex;margin-top:16px;");
var Comment = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1wm6z7s1",
    label: "Comment"
})("font-size:12px;line-height:150%;color:var(--color-text-primary);margin-top:8px;");
var InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wm6z7s2",
    label: "InfoWrapper"
})();
var Info = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1wm6z7s3",
    label: "Info"
})("font-size:10px;line-height:100%;color:var(--color-text-secondary);margin-right:2px;");
var StyledAvatar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Avatar/* default */.Z, {
    target: "e1wm6z7s4",
    label: "StyledAvatar"
})("margin-right:8px;min-width:40px;");
var CommentCard = function(param) {
    var comment = param.comment;
    var ref;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAvatar, {
                src: comment === null || comment === void 0 ? void 0 : (ref = comment.user) === null || ref === void 0 ? void 0 : ref.avatar,
                size: "40px"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StoryItem_Card, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Info, {
                                children: "".concat(comment.user.first_name, " ").concat(comment.user.last_name)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Info, {
                                children: "\u2022"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Info, {
                                children: (0,dates/* timeAgoSinceDate */.Kc)(comment.created_at)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Comment, {
                        children: comment.text
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_CommentCard = (CommentCard);
CommentCard.propTypes = {
    comment: prop_types_default().objectOf((prop_types_default()).any).isRequired
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/LikesAndReplies.jsx









var LikesAndReplies_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fvvtsy0",
    label: "Container"
})("margin-top:16px;margin-left:48px;");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fvvtsy1",
    label: "Wrapper"
})("display:flex;");
var EmojiWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fvvtsy2",
    label: "EmojiWrapper"
})("display:flex;padding:8px 12px 8px 12px;border:1px solid\n    ", function(param) {
    var isLiked = param.isLiked;
    return isLiked ? "var(--color-i-green)" : "var(--color-shadow)";
}, ";border-radius:8px;background-color:", function(param) {
    var isLiked = param.isLiked;
    return isLiked ? "rgba(8, 189, 128, 0.2)" : "auto";
}, ";cursor:pointer;margin-right:8px;");
var CommentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(EmojiWrapper, {
    target: "e1fvvtsy3",
    label: "CommentWrapper"
})("background-color:", function(param) {
    var selectedComment = param.selectedComment;
    return selectedComment ? "var(--color-shadow)" : "auto";
}, ";cursor:pointer;");
var Values = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1fvvtsy4",
    label: "Values"
})("color:", function(param) {
    var isLiked = param.isLiked;
    return isLiked ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";font-size:12px;line-height:150%;font-weight:600;");
var UNDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "e1fvvtsy5",
    label: "UNDivider"
})("margin-top:16px;margin-bottom:", function(param) {
    var $bottom = param.$bottom;
    return $bottom ? "24px" : "16px";
}, ";background-color:var(--color-shadow);border-radius:8px;");
var LikesAndReplies = function(param) {
    var comment = param.comment, storyId = param.storyId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var username = (0,es/* useSelector */.v9)(function(param) {
        var auth = param.auth;
        return auth.me.username.toLowerCase();
    });
    var upvoted = comment.upvoted, total_upvotes = comment.total_upvotes, comments = comment.comments, id = comment.id, user = comment.user;
    var updateLike = function() {
        return dispatch((0,courses/* toggleCommentLike */.og)(storyId, id, upvoted));
    };
    var likes = "Like";
    if (total_upvotes > 0) likes = "".concat(total_upvotes, " Like");
    if (total_upvotes > 1) likes = "".concat(total_upvotes, " Likes");
    var commentsNumber = "Reply";
    if (comments.count > 0) commentsNumber = "".concat(comments.count, " Reply");
    if (comments.count > 1) commentsNumber = "".concat(comments.count, " Replies");
    var ref = (0,react.useState)(null), selectedComment = ref[0], setSelectedComment = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var onCommentClick = function() {
        return setSelectedComment(selectedComment ? null : id);
    };
    var onChange = function(e) {
        return setValue(e.target.value);
    };
    var addComment = function() {
        if (value === "") return;
        dispatch((0,courses/* addReply */.Bn)(storyId, id, value));
        setValue("");
    };
    var renderSelectedComments = function() {
        if (!selectedComment) return null;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UNDivider, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentField_CommentField, {
                    placeholder: "Type your reply",
                    onChange: onChange,
                    value: value,
                    onClick: addComment
                }),
                comments.results.map(function(reply) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CommentCard, {
                        comment: reply
                    }, reply.id);
                }),
                comments.count > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UNDivider, {
                    $bottom: true
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CommentCard, {
                comment: comment
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LikesAndReplies_Container, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
                        children: [
                            username !== user.username.toLowerCase() && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmojiWrapper, {
                                isLiked: upvoted,
                                onClick: updateLike,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Values, {
                                    isLiked: upvoted,
                                    children: likes
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentWrapper, {
                                selectedComment: selectedComment === id,
                                onClick: onCommentClick,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Values, {
                                    children: commentsNumber
                                })
                            })
                        ]
                    }),
                    renderSelectedComments()
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_LikesAndReplies = (LikesAndReplies);
LikesAndReplies.propTypes = {
    comment: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    storyId: (prop_types_default()).string.isRequired
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/LikeComment.jsx










var LikeComment_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qxis3z0",
    label: "Container"
})();
var LikeComment_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qxis3z1",
    label: "Wrapper"
})("display:flex;margin-top:16px;");
var LikeComment_EmojiWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qxis3z2",
    label: "EmojiWrapper"
})("display:flex;align-items:center;padding:8px 12px 8px 12px;border:1px solid\n    ", function(param) {
    var isLiked = param.isLiked;
    return isLiked ? "var(--color-i-green)" : "var(--color-shadow)";
}, ";border-radius:8px;background-color:", function(param) {
    var isLiked = param.isLiked;
    return isLiked ? "rgba(8, 189, 128, 0.2)" : "auto";
}, ";cursor:pointer;margin-right:8px;");
var LikeComment_CommentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(LikeComment_EmojiWrapper, {
    target: "e1qxis3z3",
    label: "CommentWrapper"
})("background-color:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "var(--color-shadow)" : "auto";
}, ";display:flex;align-items:center;");
var User = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qxis3z4",
    label: "User"
})("margin-top:16px;display:flex;");
var LikeComment_Values = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1qxis3z5",
    label: "Values"
})("color:", function(param) {
    var isLiked = param.isLiked;
    return isLiked ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";font-size:12px;line-height:150%;font-weight:600;margin-left:2px;");
var LikeComment_StyledAvatar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Avatar/* default */.Z, {
    target: "e1qxis3z6",
    label: "StyledAvatar"
})("margin-right:8px;");
var LikeComment_UNDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "e1qxis3z7",
    label: "UNDivider"
})("margin-top:16px;background-color:var(--color-shadow);border-radius:8px;");
var LikeComment = function(param) {
    var toggleLike = param.toggleLike, postComment = param.postComment, getComments = param.getComments, selectedStory = param.selectedStory, story = param.story, loadMoreComments = param.loadMoreComments;
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var username = (0,es/* useSelector */.v9)(function(param) {
        var auth = param.auth;
        return auth.me.username.toLowerCase();
    });
    var thumbnail = (0,es/* useSelector */.v9)(function(param) {
        var auth = param.auth;
        return auth.me.thumbnail;
    });
    var is_liked = story.is_liked, comments_count = story.comments_count, reactions_count = story.reactions_count, uid = story.uid, author = story.author;
    var onChange = function(e) {
        return setValue(e.target.value);
    };
    var addComment = function() {
        if (value === "") return;
        postComment(uid, value);
        setValue("");
    };
    var onClick = function() {
        return toggleLike(uid, is_liked);
    };
    var updateComments = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.paginator.courseUpdateComments) === null || ref === void 0 ? void 0 : ref[uid];
    });
    var toggleCommentField = function() {
        return getComments(story);
    };
    var renderCommentCard = function(item) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_LikesAndReplies, {
            comment: item,
            storyId: uid
        }, item.id);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LikeComment_Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LikeComment_Wrapper, {
                children: [
                    username !== author.username.toLowerCase() && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LikeComment_EmojiWrapper, {
                        isLiked: is_liked,
                        onClick: onClick,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                "aria-label": "like",
                                role: "img",
                                children: "\uD83D\uDC4D"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LikeComment_Values, {
                                isLiked: is_liked,
                                children: reactions_count || "Like"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LikeComment_CommentWrapper, {
                        isSelected: (selectedStory === null || selectedStory === void 0 ? void 0 : selectedStory.uid) === story.uid,
                        onClick: toggleCommentField,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                "aria-label": "comment",
                                role: "img",
                                children: "\uD83D\uDCAC"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LikeComment_Values, {
                                children: comments_count || "Comment"
                            })
                        ]
                    })
                ]
            }),
            selectedStory && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LikeComment_UNDivider, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(User, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LikeComment_StyledAvatar, {
                                src: thumbnail,
                                size: "40px"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentField_CommentField, {
                                onChange: onChange,
                                value: value,
                                onClick: addComment
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteList["default"], {
                        data: updateComments,
                        loadMore: function() {
                            return loadMoreComments(story);
                        },
                        _renderItem: renderCommentCard,
                        scrollElement: document.getElementById("DrawerPaper")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_LikeComment = (LikeComment);
LikeComment.propTypes = {
    toggleLike: (prop_types_default()).func.isRequired,
    postComment: (prop_types_default()).func.isRequired,
    getComments: (prop_types_default()).func.isRequired,
    selectedStory: prop_types_default().objectOf((prop_types_default()).any),
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    loadMoreComments: (prop_types_default()).func.isRequired
};
LikeComment.defaultProps = {
    selectedStory: null
};

// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/utils/imageHelper.js
var imageHelper = __webpack_require__(48821);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/CardHeader.jsx

/* eslint-disable @next/next/no-img-element */ 




var CardHeader_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e19adsih0",
    label: "Wrapper"
})("display:flex;align-items:", function(param) {
    var isSubtitle = param.isSubtitle;
    return isSubtitle ? "normal" : "center";
}, ";");
var CardHeader_InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e19adsih1",
    label: "InfoWrapper"
})("padding-left:16px;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e19adsih2",
    label: "Title"
})("color:var(--color-text-primary);font-weight:600;font-size:14px;");
var CardHeader_Info = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e19adsih3",
    label: "Info"
})("font-size:12px;line-height:150%;color:var(--color-text-secondary);display:block;");
var Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e19adsih4",
    label: "Subtitle"
})("font-size:14px;line-height:150%;color:var(--color-text-secondary);");
var CardHeader = function(param) {
    var message = param.message, created_at = param.created_at, img = param.img, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardHeader_Wrapper, {
        isSubtitle: !!subtitle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                src: (0,imageHelper/* getImage */.gJ)(img),
                height: "48px",
                width: "48px",
                alt: "rescheduled"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardHeader_InfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: message
                    }),
                    subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                        lineClamp: 1,
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardHeader_Info, {
                        children: (0,dates/* dateWithTime */.tZ)(created_at)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_CardHeader = (CardHeader);
CardHeader.propTypes = {
    message: (prop_types_default()).string.isRequired,
    created_at: (prop_types_default()).string.isRequired,
    img: (prop_types_default()).string.isRequired,
    subtitle: (prop_types_default()).string
};
CardHeader.defaultProps = {
    subtitle: null
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/NewClass.jsx







var CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qt64p40",
    label: "CardWrapper"
})();
var StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "e1qt64p41",
    label: "StyledCard"
})("margin-top:16px;");
var CardInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qt64p42",
    label: "CardInfo"
})("display:flex;");
var SubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1qt64p43",
    label: "SubTitle"
})("font-size:12px;line-height:150%;color:var(--color-text-secondary);margin-top:8px;");
var WrappedDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qt64p44",
    label: "WrappedDiv"
})("margin-left:16px;");
var DateWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qt64p45",
    label: "DateWrapper"
})("width:40px;text-align:center;");
var Day = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1qt64p46",
    label: "Day"
})("font-weight:bold;font-size:20px;line-height:150%;color:var(--color-text-primary);");
var Month = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1qt64p47",
    label: "Month"
})("font-weight:600;font-size:12px;line-height:150%;color:var(--color-text-primary);text-transform:uppercase;display:block;");
var NewClass_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1qt64p48",
    label: "Title"
})("font-weight:600;font-size:14px;line-height:150%;color:var(--color-text-primary);");
var NewClass = function(param) {
    var story = param.story, batch = param.batch;
    var ref;
    var message = story.message, created_at = story.created_at, object = story.object;
    if (!object.title) return null;
    var pubDate = new Date(object.created_at);
    var day = pubDate.getDay();
    var month = pubDate.toLocaleString("default", {
        month: "long"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: message,
                created_at: created_at,
                img: "newclass.svg",
                subtitle: batch && (object === null || object === void 0 ? void 0 : (ref = object.collection) === null || ref === void 0 ? void 0 : ref.name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCard, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardInfo, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DateWrapper, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Month, {
                                    children: month.slice(0, 3)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Day, {
                                    children: day
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WrappedDiv, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewClass_Title, {
                                    children: object.title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, {
                                    children: (0,dates/* getTime */.hK)(object.created_at)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var StoryItem_NewClass = (NewClass);
NewClass.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    batch: (prop_types_default()).bool
};
NewClass.defaultProps = {
    batch: false
};

// EXTERNAL MODULE: ./src/components/Icons/ArrowBack.jsx
var ArrowBack = __webpack_require__(93303);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/ClassRescheduledCard.jsx










var ClassRescheduledCard_CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e3p2y1o0",
    label: "CardWrapper"
})();
var ClassRescheduledCard_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e3p2y1o1",
    label: "Title"
})("color:var(--color-text-primary);");
var ClassRescheduledCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "e3p2y1o2",
    label: "StyledCard"
})("margin-top:16px;");
var ClassRescheduledCard_CardInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e3p2y1o3",
    label: "CardInfo"
})("display:flex;");
var ClassRescheduledCard_SubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e3p2y1o4",
    label: "SubTitle"
})("font-size:12px;line-height:150%;color:var(--color-text-secondary);margin-top:4px;");
var ClassRescheduledCard_UNDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "e3p2y1o5",
    label: "UNDivider"
})("margin:16px 0;");
var Time = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e3p2y1o6",
    label: "Time"
})("font-size:16px;line-height:150%;color:var(--color-text-primary);margin-left:8px;");
var SlashedTime = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Time, {
    target: "e3p2y1o7",
    label: "SlashedTime"
})("text-decoration:line-through;color:var(--color-text-secondary);font-weight:600;margin-right:8px;");
var Arrow = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(ArrowBack/* default */.Z, {
    target: "e3p2y1o8",
    label: "Arrow"
})("transform:rotate(180deg);");
var ClassRescheduledCard_WrappedDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e3p2y1o9",
    label: "WrappedDiv"
})("margin-left:16px;");
var ArrowWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e3p2y1o10",
    label: "ArrowWrapper"
})("display:flex;align-items:center;");
var ClassRescheduledCard = function(param) {
    var story = param.story, batch = param.batch;
    var ref, ref1;
    var message = story.message, created_at = story.created_at, object = story.object;
    if (!object.value) return null;
    var lesson = "Lesson ".concat(object === null || object === void 0 ? void 0 : object.rank);
    var avatar = object.value.author.avatar_v1 || object.value.author.avatar;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ClassRescheduledCard_CardWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: message,
                img: "rescheduledclass.svg",
                created_at: created_at,
                subtitle: batch && ((ref = object.value) === null || ref === void 0 ? void 0 : (ref1 = ref.collection) === null || ref1 === void 0 ? void 0 : ref1.name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ClassRescheduledCard_StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ClassRescheduledCard_CardInfo, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
                                src: avatar,
                                size: "48px"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ClassRescheduledCard_WrappedDiv, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassRescheduledCard_Title, {
                                        children: object.value.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassRescheduledCard_SubTitle, {
                                        children: lesson
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassRescheduledCard_UNDivider, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ArrowWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlashedTime, {
                                children: (0,dates/* dateWithTime */.tZ)(object.value.old_time)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
                                size: "24px",
                                color: "var(--color-text-primary)"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Time, {
                                children: (0,dates/* dateWithTime */.tZ)(object.value.new_time)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_ClassRescheduledCard = (ClassRescheduledCard);
ClassRescheduledCard.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    batch: (prop_types_default()).bool
};
ClassRescheduledCard.defaultProps = {
    batch: false
};

// EXTERNAL MODULE: ./src/components/Icons/Download.jsx
var Download = __webpack_require__(83583);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/MessageDivider.jsx





var MessageDivider_UNDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "eyndzc70",
    label: "UNDivider"
})("margin:16px 0;background-color:var(--color-shadow);");
var MessageDivider = function(param) {
    var message = param.message;
    if (!message) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P2/* default */.Z, {
                color: "var(--color-text-primary)",
                children: message
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MessageDivider_UNDivider, {})
        ]
    });
};
/* harmony default export */ var StoryItem_MessageDivider = (MessageDivider);
MessageDivider.propTypes = {
    message: (prop_types_default()).string
};
MessageDivider.defaultProps = {
    message: null
};

// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/components/Icons/CheckBig.jsx
var CheckBig = __webpack_require__(17192);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/AuthorHeader.jsx









var UserInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e11beufs0",
    label: "UserInfo"
})("display:flex;align-items:", function(param) {
    var isSubtitle = param.isSubtitle;
    return isSubtitle ? "normal" : "center";
}, ";");
var AuthorNameWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e11beufs1",
    label: "AuthorNameWrapper"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";display:flex;align-items:center;");
var VerifiedIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CheckBig/* default */.Z, {
    target: "e11beufs2",
    label: "VerifiedIcon"
})("margin-left:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";");
var Posted = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e11beufs3",
    label: "Posted"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";color:var(--color-text-primary);");
var AuthorHeader_StyledAvatar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Avatar/* default */.Z, {
    target: "e11beufs4",
    label: "StyledAvatar"
})("cursor:auto;");
var AuthorHeader_Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e11beufs5",
    label: "Subtitle"
})("font-size:14px;line-height:150%;color:var(--color-text-primary);margin-left:16px;");
var AuthorHeader = function(param) {
    var author = param.author, created_at = param.created_at, subtitle = param.subtitle;
    var fullName = "".concat(author === null || author === void 0 ? void 0 : author.first_name, " ").concat(author === null || author === void 0 ? void 0 : author.last_name);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UserInfo, {
        isSubtitle: !!subtitle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorHeader_StyledAvatar, {
                src: (author === null || author === void 0 ? void 0 : author.avatar_v1) || (author === null || author === void 0 ? void 0 : author.avatar),
                size: "48px"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AuthorNameWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6/* default */.Z, {
                                color: "var(--color-text-primary)",
                                children: fullName
                            }),
                            author.is_verified_educator && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifiedIcon, {
                                color: "var(--color-i-blue)"
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorHeader_Subtitle, {
                        lineClamp: 1,
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Posted, {
                        color: "var(--color-text-secondary)",
                        children: (0,dates/* dateWithTime */.tZ)(created_at)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_AuthorHeader = (AuthorHeader);
AuthorHeader.propTypes = {
    author: prop_types_default().objectOf((prop_types_default()).any),
    subtitle: (prop_types_default()).string,
    created_at: (prop_types_default()).string.isRequired
};
AuthorHeader.defaultProps = {
    subtitle: null,
    author: {}
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/DocumentCard.jsx

/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 









var DocumentCard_CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "elp3tty0",
    label: "CardWrapper"
})("display:flex;align-items:center;cursor:pointer;");
var DocumentName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "elp3tty1",
    label: "DocumentName"
})("flex:1;margin:0px 16px;color:var(--color-text-primary);font-weight:600;font-size:12px;line-height:150%;");
var DocumentCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "elp3tty2",
    label: "StyledCard"
})("margin-top:16px;");
var isPGN = function(name) {
    return name.substr("-4") === ".pgn";
};
var getImageName = function(name) {
    return isPGN(name) ? "pgn.png" : "pdf.svg";
};
var onClick = function(url, segmentData, isTestSeries, isBatch) {
    return function() {
        var eventName = isTestSeries ? segment/* TEST_SERIES_UPDATES_FILE_DOWNLOAD */.rmR : segment/* COURSE_UPDATES_FILE_DOWNLOAD */.ORd;
        var eventKeys = isTestSeries ? segment/* TEST_SERIES_KEYS */.g$8 : segment/* COURSE_KEYS */.$1X;
        if (isBatch) {
            eventName = segment/* BATCH_UPDATE_FILE_DOWNLOAD */.ltM;
            eventKeys = segment/* BATCH_KEYS */.A8$;
        }
        analytics/* segment.track */.EX.track(eventName, segmentData, constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true, eventKeys);
        window.open(url, "_blank");
    };
};
var DocumentCard = function(param) {
    var story = param.story, batch = param.batch, segmentData = param.segmentData, isTestSeries = param.isTestSeries;
    var ref;
    var author = story.author, object = story.object, message = story.message, created_at = story.created_at;
    if (!object.url) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_AuthorHeader, {
                author: author,
                created_at: created_at,
                subtitle: batch && (object === null || object === void 0 ? void 0 : (ref = object.collection) === null || ref === void 0 ? void 0 : ref.name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DocumentCard_StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_MessageDivider, {
                        message: message
                    }),
                    object.name && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DocumentCard_CardWrapper, {
                        onClick: onClick(object.url, segmentData, isTestSeries, batch),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                src: (0,imageHelper/* getImage */.gJ)(getImageName(object.name)),
                                width: "40px",
                                alt: "Pdf"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocumentName, {
                                children: object.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Download/* default */.Z, {
                                size: "24px",
                                color: "var(--color-text-primary)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_DocumentCard = (DocumentCard);

// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/components/Composite/EducatorDetailedCard/EducatorDetailedCard.jsx + 3 modules
var EducatorDetailedCard = __webpack_require__(13325);
// EXTERNAL MODULE: ./node_modules/camelcase-keys/index.js
var camelcase_keys = __webpack_require__(12828);
var camelcase_keys_default = /*#__PURE__*/__webpack_require__.n(camelcase_keys);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/NewEducatorCard.jsx

/* eslint-disable react/prop-types */ 




var linkStyle = "\n  margin-top: ".concat(styleConstants/* Spacings.SPACING_3B */.t8.N, ";\n  margin-bottom: ").concat(styleConstants/* Spacings.SPACING_3B */.t8.N, ";\n");
var NewEducatorCard = function(param) {
    var story = param.story;
    var message = story.message, created_at = story.created_at, object = story.object;
    if (!object) return;
    var educator = camelcase_keys_default()(object, {
        deep: true
    });
    var href = "/[authorID]";
    var as = "/@".concat(educator.username);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
        as: as,
        href: href,
        newTab: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: message,
                img: "newclass.svg",
                created_at: created_at
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorDetailedCard/* default */.Z, {
                gridColumn: "span 10",
                educator: educator,
                showBadge: true,
                linkStyle: linkStyle
            }, 1)
        ]
    });
};
/* harmony default export */ var StoryItem_NewEducatorCard = (NewEducatorCard);

// EXTERNAL MODULE: ./src/components/Base/Tags/Tags.jsx
var Tags = __webpack_require__(52236);
// EXTERNAL MODULE: ./src/components/Base/Thumbnail/Thumbnail.tsx
var Thumbnail = __webpack_require__(75591);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/constants/getTopicGroupAssetObj.js
var getTopicGroupAssetObj = __webpack_require__(77608);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/models/Course.js
var Course = __webpack_require__(56046);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/NewCourseCard.jsx


/* eslint-disable react/prop-types */ 














var NewCourseCard_CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "etr5iha0",
    label: "CardWrapper"
})();
var NewCourseCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "etr5iha1",
    label: "StyledCard"
})("margin-top:16px;");
var CourseCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "etr5iha2",
    label: "CourseCard"
})("display:flex;");
var NewCourseCard_CardInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "etr5iha3",
    label: "CardInfo"
})("margin-left:16px;max-width:250px;");
var BreadCrumbs = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "etr5iha4",
    label: "BreadCrumbs"
})("padding-bottom:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";display:flex;align-items:center;");
var CourseThumbnail = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Thumbnail/* default */.Z, {
    target: "etr5iha5",
    label: "CourseThumbnail"
})("width:144px;height:80px;border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){min-width:44px;width:44px;height:44px;border-radius:8px;}");
var CourseTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "etr5iha6",
    label: "CourseTitle"
})("color:var(--color-text-primary);");
var EducatorName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "etr5iha7",
    label: "EducatorName"
})("color:var(--color-text-primary);");
var CourseTime = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "etr5iha8",
    label: "CourseTime"
})("font-size:12px;line-height:150%;color:var(--color-text-secondary);margin:8px 0px;");
var TopicGroupTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "etr5iha9",
    label: "TopicGroupTag"
})("margin-left:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";cursor:pointer;color:", function(param) {
    var $color = param.$color;
    return $color;
}, ";");
var NewCourseCard = function(param) {
    var story = param.story;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var message = story.message, created_at = story.created_at, object = story.object, author = story.author, sub_type = story.sub_type;
    var courseData = Course/* default.getEntityData */.ZP.getEntityData((0,_object_spread/* default */.Z)({}, object, object.programme));
    var getCourseInfo = function() {
        var ref, ref1;
        var isOngoing = courseData.isOngoing, isCompleted = courseData.isCompleted, isUpcoming = courseData.isUpcoming, isLive = courseData.isLive, nextTrack = courseData.nextTrack;
        if (!nextTrack || !nextTrack.item) return "";
        var liveLessonRank = nextTrack === null || nextTrack === void 0 ? void 0 : (ref = nextTrack.item) === null || ref === void 0 ? void 0 : ref.rank;
        var liveAt = nextTrack === null || nextTrack === void 0 ? void 0 : (ref1 = nextTrack.item) === null || ref1 === void 0 ? void 0 : ref1.live_at;
        var liveLessonStartTime = new Date(liveAt);
        if (isLive) {
            return "Lesson ".concat(liveLessonRank, " \u2022 Started at ").concat((0,dates/* getTime */.hK)(liveAt));
        }
        if (isOngoing) {
            var isToday = (0,dates/* isSameDay */.KC)(liveLessonStartTime, new Date());
            if (isToday) return "Lesson ".concat(liveLessonRank, " \u2022 Today, ").concat((0,dates/* getTime */.hK)(liveAt));
            return "Lesson ".concat(liveLessonRank, " \u2022 ").concat((0,dates/* getFullDate */.xE)(liveAt), " ").concat((0,dates/* getTime */.hK)(liveAt));
        }
        if (isUpcoming) {
            var totalLessons = courseData.itemCount, liveClassCount = courseData.liveClassCount, startsAt = courseData.startsAt, isSpecial = courseData.isSpecial;
            if (isSpecial) return "Starts on ".concat((0,dates/* getFullDate */.xE)(startsAt));
            return "Starts on ".concat((0,dates/* getFullDate */.xE)(startsAt), " \u2022 ").concat(totalLessons || liveClassCount || 0, " lessons");
        }
        if (isCompleted) {
            var totalLessons1 = courseData.itemCount, liveClassCount1 = courseData.liveClassCount, endsAt = courseData.endsAt, isSpecial1 = courseData.isSpecial;
            if (isSpecial1) return "Ended on ".concat((0,dates/* getFullDate */.xE)(endsAt));
            return "Ended on ".concat((0,dates/* getFullDate */.xE)(endsAt), " \u2022 ").concat(totalLessons1 || liveClassCount1 || 0, " lessons");
        }
    };
    var CardHead = function() {
        if (sub_type === 1) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: message,
                created_at: created_at,
                img: "newclass.svg"
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_AuthorHeader, {
            author: author,
            created_at: created_at,
            subtitle: courseData.name
        });
    };
    var color = (0,getTopicGroupAssetObj/* default */.Z)((ref = courseData.topicGroups[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.topology) === null || ref1 === void 0 ? void 0 : ref1.name).color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewCourseCard_CardWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardHead, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewCourseCard_StyledCard, {
                children: [
                    sub_type !== 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_MessageDivider, {
                        message: message
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseCard, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseThumbnail, {
                                imgUrl: courseData.thumbnail
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewCourseCard_CardInfo, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BreadCrumbs, {
                                        children: [
                                            courseData.language ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tags/* default */.Z, {
                                                type: "hollow",
                                                children: courseData.language
                                            }) : null,
                                            ((ref2 = courseData.topicGroups) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.topology) === null || ref4 === void 0 ? void 0 : ref4.uid) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                                href: "/goal/[goalSlug]/[goalUID]/topic/[topicUid]",
                                                as: "/goal/".concat(courseData === null || courseData === void 0 ? void 0 : (ref5 = courseData.goal) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.topology) === null || ref6 === void 0 ? void 0 : ref6.slug, "/").concat(courseData === null || courseData === void 0 ? void 0 : (ref7 = courseData.goal) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.topology) === null || ref8 === void 0 ? void 0 : ref8.uid, "/topic/").concat((ref9 = courseData.topicGroups[0]) === null || ref9 === void 0 ? void 0 : ref9.topology.uid),
                                                anchorStyle: "display: inline-block;max-width: 75%;line-height: 1;",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicGroupTag, {
                                                    type: "transparent",
                                                    $color: color,
                                                    children: (0,textHelper/* textTruncate */.Th)(((ref10 = courseData.topicGroups[0]) === null || ref10 === void 0 ? void 0 : ref10.topology.name) || "", 24)
                                                })
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: (0,Course/* getLinkPath */.bc)(courseData),
                                        as: (0,Course/* getLink */.Rg)(courseData),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseTitle, {
                                            lineClamp: 2,
                                            children: courseData.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseTime, {
                                        children: getCourseInfo()
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "/[authorID]",
                                        as: "/@".concat((ref11 = courseData.authors) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.user) === null || ref13 === void 0 ? void 0 : ref13.username),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorName, {
                                            children: "".concat((ref14 = courseData.authors) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.user) === null || ref16 === void 0 ? void 0 : ref16.first_name, " ").concat((ref17 = courseData.authors) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[0]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.user) === null || ref19 === void 0 ? void 0 : ref19.last_name)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_NewCourseCard = (NewCourseCard);

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/Leaderboard.jsx








var Leaderboard_CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco0",
    label: "CardWrapper"
})();
var Leaderboard_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e105nuco1",
    label: "Title"
})("font-weight:600;font-size:14px;line-height:150%;color:var(--color-text-primary);");
var Leaderboard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "e105nuco2",
    label: "StyledCard"
})("margin-top:16px;");
var Leaderboard_CardInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco3",
    label: "CardInfo"
})("display:flex;align-items:center;");
var Leaderboard_SubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e105nuco4",
    label: "SubTitle"
})("font-size:12px;line-height:150%;color:var(--color-text-secondary);margin-top:4px;");
var Leaderboard_UNDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "e105nuco5",
    label: "UNDivider"
})("margin:16px 0;background-color:var(--color-shadow);");
var Leaderboard_WrappedDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco6",
    label: "WrappedDiv"
})("margin-left:16px;");
var CardDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco7",
    label: "CardDetails"
})();
var ToppersWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco8",
    label: "ToppersWrapper"
})("display:flex;width:100%;flex-wrap:wrap;background:radial-gradient(\n    51.51% 132.57% at 48.61% 143.75%,var(--color-shadow) 0%,var(--color-base-1) 100%\n  );padding:24px;justify-content:space-between;align-items:flex-end;");
var AvatarWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco9",
    label: "AvatarWrapper"
})("position:relative;width:min-content;");
var posColor = {
    0: "var(--color-i-yellow-1)",
    1: "var(--color-i-orange-2)",
    2: "var(--color-i-turquoise-1)"
};
var Position = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco10",
    label: "Position"
})("background-color:", function(param) {
    var pos = param.pos;
    return posColor[pos];
}, ";border:2px solid var(--color-i-white);border-radius:9px;font-size:12px;line-height:14px;color:var(--color-i-white);text-shadow:0px 0px 8px rgba(0,0,0,0.32);text-align:center;position:absolute;width:30px;height:18px;left:calc(50% - 15px);bottom:-5px;");
var Name = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e105nuco11",
    label: "Name"
})("font-weight:600;font-size:14px;line-height:150%;color:var(--color-text-primary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;width:100%;margin-top:4px;");
var TopperWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco12",
    label: "TopperWrapper"
})("display:flex;flex-direction:column;align-items:center;flex-grow:1;flex-basis:0;min-width:0;");
var MarksInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco13",
    label: "MarksInfo"
})("display:flex;");
var TotalMarks = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e105nuco14",
    label: "TotalMarks"
})("color:var(--color-text-secondary);font-size:14px;line-height:150%;");
var Correct = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e105nuco15",
    label: "Correct"
})("font-weight:bold;font-size:14px;line-height:150%;color:var(--color-i-green);");
var TimeTaken = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e105nuco16",
    label: "TimeTaken"
})("font-size:10px;line-height:12px;color:var(--color-text-primary);opacity:0.5;background:var(--color-shadow);border-radius:8px;padding:0 4px;margin-left:8px;display:inline-flex;align-items:center;");
var OthersWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco17",
    label: "OthersWrapper"
})("padding-top:8px;padding-bottom:16px;");
var OtherWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e105nuco18",
    label: "OtherWrapper"
})("display:flex;align-items:center;margin-top:16px;");
var Rank = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e105nuco19",
    label: "Rank"
})("margin-right:8px;font-size:14px;line-height:150%;color:var(--color-text-primary);");
var OtherName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e105nuco20",
    label: "OtherName"
})("margin:0 8px;font-size:14px;line-height:150%;color:var(--color-text-primary);");
var Marks = function(param) {
    var learner = param.learner;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarksInfo, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Correct, {
                children: learner.correct_answer_count
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TotalMarks, {
                children: "/"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TotalMarks, {
                children: learner.total_questions_count
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimeTaken, {
                children: "".concat(learner.total_time_taken, "s")
            })
        ]
    });
};
var Leaderboard_StyledAvatar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Avatar/* default */.Z, {
    target: "e105nuco21",
    label: "StyledAvatar"
})("cursor:auto;");
var Topper = function(param) {
    var topper = param.topper, size = param.size, pos = param.pos;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopperWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AvatarWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_StyledAvatar, {
                        circular: true,
                        src: topper.avatar,
                        size: size || "48px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Position, {
                        pos: pos,
                        children: topper === null || topper === void 0 ? void 0 : topper.rank
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
                children: "".concat(topper.first_name, " ").concat(topper.last_name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marks, {
                learner: topper
            })
        ]
    });
};
var Toppers = function(param) {
    var toppers = param.toppers;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToppersWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Topper, {
                pos: 1,
                topper: toppers === null || toppers === void 0 ? void 0 : toppers[1]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Topper, {
                pos: 0,
                size: "64px",
                topper: toppers === null || toppers === void 0 ? void 0 : toppers[0]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Topper, {
                pos: 2,
                topper: toppers === null || toppers === void 0 ? void 0 : toppers[2]
            })
        ]
    });
};
var Other = function(param) {
    var other = param.other;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rank, {
                children: "".concat(other === null || other === void 0 ? void 0 : other.rank, ".")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_StyledAvatar, {
                circular: true,
                src: other.avatar,
                size: "24px"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherName, {
                children: "".concat(other.first_name, " ").concat(other.last_name, " -")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marks, {
                learner: other
            })
        ]
    });
};
var Others = function(param) {
    var others = param.others;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OthersWrapper, {
        children: others.map(function(other) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Other, {
                other: other
            }, other.uid);
        })
    });
};
var Leaderboard = function(param) {
    var story = param.story, batch = param.batch;
    var created_at = story.created_at, object = story.object, author = story.author;
    if (!object.poll_leaderboard) return null;
    var lesson = "Lesson ".concat(object === null || object === void 0 ? void 0 : object.rank);
    var toppers = object.poll_leaderboard.slice(0, 3);
    var others = object.poll_leaderboard.slice(3);
    var avatar = author.avatar_v1 || author.avatar;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Leaderboard_CardWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: "Poll Leaderboards",
                created_at: created_at,
                img: "poll.svg",
                subtitle: batch && object.programme.name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Leaderboard_StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Leaderboard_CardInfo, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_StyledAvatar, {
                                src: avatar,
                                size: "48px"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Leaderboard_WrappedDiv, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_Title, {
                                        lineClamp: 1,
                                        children: object.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_SubTitle, {
                                        children: lesson
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_UNDivider, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardDetails, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toppers, {
                                toppers: toppers
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Others, {
                                others: others
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_Leaderboard = (Leaderboard);
Leaderboard.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    batch: (prop_types_default()).bool
};
Leaderboard.defaultProps = {
    batch: false
};
Others.propTypes = {
    others: prop_types_default().arrayOf((prop_types_default()).any).isRequired
};
Other.propTypes = {
    other: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
Topper.propTypes = {
    topper: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    size: (prop_types_default()).string,
    pos: (prop_types_default()).number.isRequired
};
Topper.defaultProps = {
    size: null
};
Toppers.propTypes = {
    toppers: prop_types_default().arrayOf((prop_types_default()).any).isRequired
};
Marks.propTypes = {
    learner: prop_types_default().objectOf((prop_types_default()).any).isRequired
};

// EXTERNAL MODULE: ./src/components/Composite/Dialog/Dialog.tsx + 1 modules
var Dialog = __webpack_require__(76920);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/ImageCard.jsx








var ImageCard_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e19itmnx0",
    label: "Container"
})("width:100%;height:auto;");
var Message = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e19itmnx1",
    label: "Message"
})("color:var(--color-text-primary);font-size:12px;line-height:150%;margin-bottom:12px;");
var Image = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "e19itmnx2",
    label: "Image"
})("border:1px solid var(--color-divider);border-radius:4px;cursor:", function(param) {
    var pointer = param.pointer;
    return pointer;
}, ";");
var ImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e19itmnx3",
    label: "ImageWrapper"
})("background-color:var(--color-base-0);padding:24px;");
var ImageCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "e19itmnx4",
    label: "StyledCard"
})("margin-top:16px;");
var ImageCard = function(param) {
    var story = param.story, batch = param.batch;
    var ref;
    var ref1 = (0,react.useState)(false), openImg = ref1[0], setOpenImg = ref1[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageCard_Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_AuthorHeader, {
                subtitle: batch && (story === null || story === void 0 ? void 0 : (ref = story.object) === null || ref === void 0 ? void 0 : ref.collection_name),
                author: story.author,
                created_at: story.created_at
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageCard_StyledCard, {
                children: [
                    !!story.message && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Message, {
                        children: story.message
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                        width: "100%",
                        src: story.object_meta,
                        onClick: function() {
                            return setOpenImg(true);
                        },
                        pointer: "pointer",
                        alt: story.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog["default"], {
                center: true,
                onClose: function() {
                    return setOpenImg(false);
                },
                dialogState: openImg,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                        width: "100%",
                        src: story.object_meta,
                        onClick: function() {
                            return setOpenImg(true);
                        },
                        pointer: "auto",
                        alt: story.message
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var StoryItem_ImageCard = (ImageCard);
ImageCard.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    batch: (prop_types_default()).bool
};
ImageCard.defaultProps = {
    batch: false
};

// EXTERNAL MODULE: ./src/models/Item.js
var Item = __webpack_require__(46571);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/NewEmbeddedClassCard.jsx


/* eslint-disable react/prop-types */ 











var Flex = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eijb0950",
    label: "Flex"
})("display:flex;");
var NewEmbeddedClassCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "eijb0951",
    label: "StyledCard"
})("margin-top:16px;");
var TimeTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "eijb0952",
    label: "TimeTag"
})("color:var(--color-text-secondary);margin-bottom:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, ";");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eijb0953",
    label: "Content"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";display:flex;flex-direction:column;");
var LessonInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "eijb0954",
    label: "LessonInfo"
})("margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var AuthorName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "eijb0955",
    label: "AuthorName"
})("margin-top:auto;color:var(--color-text-primary);");
var NewEmbeddedClassCard = function(param) {
    var story = param.story, batch = param.batch;
    var ref, ref1;
    var message = story.message, created_at = story.created_at, author = story.author, object = story.object;
    var classData = Item/* default.getEntityData */.ZP.getEntityData((0,_object_spread/* default */.Z)({}, object, object.live_class));
    var liveAtString = classData.liveAtString, name = classData.name, specialInfoString = classData.specialInfoString, relativeLink = classData.relativeLink;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_AuthorHeader, {
                author: author,
                created_at: created_at,
                subtitle: batch && (object === null || object === void 0 ? void 0 : (ref = object.collection) === null || ref === void 0 ? void 0 : ref.name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewEmbeddedClassCard_StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_MessageDivider, {
                        message: message
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        as: relativeLink,
                        href: "/class/[slug]/[uid]",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
                                    src: object === null || object === void 0 ? void 0 : (ref1 = object.collection) === null || ref1 === void 0 ? void 0 : ref1.thumbnail,
                                    size: "120px"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimeTag, {
                                            type: "transparent",
                                            children: (0,dates/* dateWithTime */.tZ)(liveAtString)
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6/* default */.Z, {
                                            color: "var(--color-text-primary)",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonInfo, {
                                            color: "var(--color-text-secondary)",
                                            children: specialInfoString || (0,Item/* getLessonInfoString */.NT)(classData, true)
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorName, {
                                            children: "".concat(author.first_name, " ").concat(author.last_name)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_NewEmbeddedClassCard = (NewEmbeddedClassCard);

;// CONCATENATED MODULE: ./src/components/Base/TestThumbnail/TestThumbnail.jsx


var TestThumbnail = function(param) {
    var color = param.color, className = param.className;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "120",
        height: "120",
        viewBox: "0 0 120 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                id: "mask0",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "120",
                height: "120",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    width: "120",
                    height: "120",
                    rx: "8",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                mask: "url(#mask0)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "120",
                        height: "120",
                        rx: "8",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            width: "120",
                            height: "120",
                            rx: "8",
                            fill: color
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 0C3.58172 0 0 3.58172 0 8V54.5882C15.4349 39.3828 36.6217 30 60 30C83.3783 30 104.565 39.3828 120 54.5882V8C120 3.58172 116.418 0 112 0H8Z",
                        fill: color
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M89.2457 73.6677C89.4781 73.9024 89.6642 74.1779 89.7943 74.48C89.931 74.7896 90.001 75.1238 90 75.4615V119.462C89.9911 120.132 89.7173 120.773 89.237 121.247C88.7567 121.721 88.1078 121.991 87.4286 122H32.5714C31.8922 121.991 31.2433 121.721 30.763 121.247C30.2826 120.773 30.0089 120.132 30 119.462V58.5385C30.0089 57.868 30.2826 57.2274 30.763 56.7532C31.2433 56.279 31.8922 56.0088 32.5714 56H70.2857C70.6278 55.999 70.9664 56.0681 71.28 56.2031C71.586 56.3315 71.865 56.5152 72.1028 56.7446L89.2457 73.6677ZM38.9074 72.7901C38.9074 69.0516 41.9381 66.0209 45.6767 66.0209H45.8525C49.591 66.0209 52.6217 69.0516 52.6217 72.7901C52.6217 76.5287 49.591 79.5594 45.8525 79.5594H45.6766C41.9381 79.5594 38.9074 76.5287 38.9074 72.7901ZM69.0364 64.5788L82.7507 78.1172H69.0364V64.5788ZM72.2082 91.5299H41.3511C40.6691 91.5299 40.0151 91.7973 39.5328 92.2734C39.0506 92.7494 38.7797 93.3951 38.7797 94.0683C38.7797 94.7416 39.0506 95.3872 39.5328 95.8633C40.0151 96.3394 40.6691 96.6068 41.3511 96.6068H72.2082C72.8902 96.6068 73.5443 96.3394 74.0265 95.8633C74.5087 95.3872 74.7797 94.7416 74.7797 94.0683C74.7797 93.3951 74.5087 92.7494 74.0265 92.2734C73.5443 91.7973 72.8902 91.5299 72.2082 91.5299ZM41.3511 105.069H61.9225C62.6045 105.069 63.2586 105.336 63.7408 105.812C64.223 106.288 64.4939 106.934 64.4939 107.607C64.4939 108.28 64.223 108.926 63.7408 109.402C63.2586 109.878 62.6045 110.146 61.9225 110.146H41.3511C40.6691 110.146 40.0151 109.878 39.5328 109.402C39.0506 108.926 38.7797 108.28 38.7797 107.607C38.7797 106.934 39.0506 106.288 39.5328 105.812C40.0151 105.336 40.6691 105.069 41.3511 105.069Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                        id: "mask1",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "84",
                        y: "20",
                        width: "48",
                        height: "48",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                            cx: "108",
                            cy: "44",
                            r: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        mask: "url(#mask1)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "71.1484",
                                y1: "61.2067",
                                x2: "101.893",
                                y2: "3.0393",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "72.3439",
                                y1: "61.8385",
                                x2: "103.089",
                                y2: "3.67114",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "73.5397",
                                y1: "62.4703",
                                x2: "104.284",
                                y2: "4.30297",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "74.7355",
                                y1: "63.1032",
                                x2: "105.48",
                                y2: "4.93578",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "75.9314",
                                y1: "63.735",
                                x2: "106.676",
                                y2: "5.56762",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "77.1273",
                                y1: "64.3678",
                                x2: "107.872",
                                y2: "6.20043",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "78.3231",
                                y1: "64.9987",
                                x2: "109.068",
                                y2: "6.83129",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "79.5188",
                                y1: "65.6315",
                                x2: "110.263",
                                y2: "7.4641",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "80.7147",
                                y1: "66.2633",
                                x2: "111.459",
                                y2: "8.09594",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "81.9105",
                                y1: "66.8961",
                                x2: "112.655",
                                y2: "8.72875",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "83.1064",
                                y1: "67.528",
                                x2: "113.851",
                                y2: "9.36059",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "84.3022",
                                y1: "68.1588",
                                x2: "115.047",
                                y2: "9.99145",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "85.498",
                                y1: "68.7916",
                                x2: "116.243",
                                y2: "10.6243",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "86.6939",
                                y1: "69.4235",
                                x2: "117.439",
                                y2: "11.2561",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "87.8898",
                                y1: "70.0553",
                                x2: "118.634",
                                y2: "11.8879",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "89.0856",
                                y1: "70.6881",
                                x2: "119.83",
                                y2: "12.5207",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "90.2814",
                                y1: "71.32",
                                x2: "121.026",
                                y2: "13.1526",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "91.4774",
                                y1: "71.9508",
                                x2: "122.222",
                                y2: "13.7834",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "92.673",
                                y1: "72.5836",
                                x2: "123.418",
                                y2: "14.4163",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "93.8688",
                                y1: "73.2164",
                                x2: "124.613",
                                y2: "15.0491",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "95.0647",
                                y1: "73.8483",
                                x2: "125.809",
                                y2: "15.6809",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "96.2605",
                                y1: "74.4791",
                                x2: "127.005",
                                y2: "16.3118",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "97.4565",
                                y1: "75.111",
                                x2: "128.201",
                                y2: "16.9436",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "98.6522",
                                y1: "75.7448",
                                x2: "129.397",
                                y2: "17.5774",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "99.848",
                                y1: "76.3766",
                                x2: "130.593",
                                y2: "18.2092",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "101.044",
                                y1: "77.0084",
                                x2: "131.788",
                                y2: "18.8411",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "102.24",
                                y1: "77.6403",
                                x2: "132.985",
                                y2: "19.4729",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "103.436",
                                y1: "78.2711",
                                x2: "134.18",
                                y2: "20.1038",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "104.631",
                                y1: "78.9049",
                                x2: "135.376",
                                y2: "20.7375",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "105.827",
                                y1: "79.5367",
                                x2: "136.572",
                                y2: "21.3694",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "107.023",
                                y1: "80.1696",
                                x2: "137.768",
                                y2: "22.0022",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "108.218",
                                y1: "80.7994",
                                x2: "138.963",
                                y2: "22.6321",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "109.414",
                                y1: "81.4313",
                                x2: "140.158",
                                y2: "23.2639",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "110.61",
                                y1: "82.0641",
                                x2: "141.354",
                                y2: "23.8967",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "111.806",
                                y1: "82.6969",
                                x2: "142.55",
                                y2: "24.5295",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "113.001",
                                y1: "83.3297",
                                x2: "143.746",
                                y2: "25.1623",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "114.197",
                                y1: "83.9596",
                                x2: "144.942",
                                y2: "25.7922",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
                                x1: "115.393",
                                y1: "84.5934",
                                x2: "146.137",
                                y2: "26.426",
                                stroke: "white",
                                strokeWidth: "0.444588"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M10.0739 11.1241C10.6104 14.5496 13.5597 17.1693 17.1176 17.1693C20.6395 17.1693 23.5651 14.6023 24.1443 11.2278C24.2185 10.911 24.2492 10.658 24.2398 10.4412C24.2398 10.1928 24.0628 10 23.8174 10H23.4194H10.8828H10.424C10.1788 10 10.0019 10.1925 10.0016 10.4406C10.0011 10.4406 10.0005 10.4406 10 10.4406C10.0003 10.4461 10.0007 10.4517 10.001 10.4572C9.99462 10.646 10.0182 10.8624 10.0739 11.1241L10.0739 11.1241Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M20.6178 21.5581C20.3496 19.8453 18.8749 18.5355 17.0959 18.5355C15.335 18.5355 13.8722 19.819 13.5826 21.5062C13.5455 21.6646 13.5301 21.7911 13.5348 21.8995C13.5348 22.0237 13.6233 22.1201 13.746 22.1201H13.945H20.2134H20.4428C20.5654 22.1201 20.6538 22.0239 20.654 21.8998C20.6542 21.8998 20.6545 21.8998 20.6548 21.8998C20.6546 21.8971 20.6544 21.8943 20.6543 21.8915C20.6575 21.7971 20.6457 21.6889 20.6178 21.5581Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M39.3714 16.9514C39.3714 17.755 39.7464 18.438 40.6839 18.438C41.6214 18.438 41.9964 17.755 41.9964 16.9514L41.9964 13.1211L43.55 13.1211L43.55 17.2327C43.55 18.6791 42.2375 19.8309 40.6839 19.8309C39.1304 19.8309 37.8179 18.6791 37.8179 17.2327L37.8179 13.1211L39.3714 13.1211L39.3714 16.9514Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M44.4966 17.8616C44.5769 18.5982 45.3001 19.8303 47.1885 19.8303C48.8492 19.8303 49.6528 18.7321 49.6528 17.741C49.6528 16.7768 49.0099 16.0268 47.7778 15.7589L46.7867 15.558C46.385 15.4777 46.1305 15.2232 46.1305 14.875C46.1305 14.4732 46.5189 14.125 47.068 14.125C47.9385 14.125 48.2198 14.7277 48.2733 15.1027L49.5858 14.7277C49.4787 14.0848 48.8894 12.9063 47.068 12.9063C45.7153 12.9063 44.6707 13.8705 44.6707 15.0089C44.6707 15.9062 45.2734 16.6562 46.4251 16.9107L47.3894 17.125C47.9117 17.2321 48.1528 17.5 48.1528 17.8482C48.1528 18.25 47.818 18.5982 47.1751 18.5982C46.3448 18.5982 45.9028 18.0759 45.8492 17.4866L44.4966 17.8616Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M28.3843 22.1205L28.3843 18.8392C28.7191 19.3348 29.4289 19.7366 30.3664 19.7366C32.2414 19.7366 33.4333 18.2634 33.4333 16.308C33.4333 14.3795 32.3485 12.9063 30.42 12.9063C29.4155 12.9063 28.6655 13.375 28.3441 13.9375L28.3441 13.0536L26.8441 13.0536L26.8441 22.1205L28.3843 22.1205ZM31.8798 16.308C31.8798 17.5535 31.1566 18.3571 30.1253 18.3571C29.1075 18.3571 28.3709 17.5535 28.3709 16.308C28.3709 15.0893 29.1075 14.2857 30.1253 14.2857C31.17 14.2857 31.8798 15.0893 31.8798 16.308Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M34.8188 19.7767L34.8188 10L36.3599 10L36.3599 19.7767L34.8188 19.7767Z",
                        fill: "white"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TestThumbnail_TestThumbnail = (TestThumbnail);
TestThumbnail.propTypes = {
    className: (prop_types_default()).string,
    color: (prop_types_default()).string
};
TestThumbnail.defaultProps = {
    className: "",
    color: "var(--color-i-orange-1)"
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/EmbeddedQuizCard.jsx














var EmbeddedQuizCard_Flex = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1g83x9u0",
    label: "Flex"
})("display:flex;");
var EmbeddedQuizCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "e1g83x9u1",
    label: "StyledCard"
})("margin-top:16px;display:flex;flex-direction:column;");
var EmbeddedQuizCard_TimeTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "e1g83x9u2",
    label: "TimeTag"
})("color:var(--color-text-secondary);margin-bottom:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, ";");
var EmbeddedQuizCard_Content = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1g83x9u3",
    label: "Content"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";display:flex;flex-direction:column;");
var EmbeddedQuizCard_LessonInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e1g83x9u4",
    label: "LessonInfo"
})("margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var EmbeddedQuizCard = function(param) {
    var story = param.story, batch = param.batch;
    var ref, ref1, ref2;
    var message = story.message, created_at = story.created_at, author = story.author, object = story.object;
    var classData = Item/* default.getEntityData */.ZP.getEntityData(object);
    var liveAtString = classData.liveAtString, name = classData.name, specialInfoString = classData.specialInfoString, relativeLink = classData.relativeLink;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_AuthorHeader, {
                subtitle: batch && object.collection_name,
                author: author,
                created_at: created_at
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmbeddedQuizCard_StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_MessageDivider, {
                        message: message
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        as: relativeLink,
                        href: "/quiz/[quizSlug]/[quizUID]",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmbeddedQuizCard_Flex, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestThumbnail_TestThumbnail, {
                                    color: object === null || object === void 0 ? void 0 : (ref = object.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.programme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.goal) === null || ref2 === void 0 ? void 0 : ref2.color
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmbeddedQuizCard_Content, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedQuizCard_TimeTag, {
                                            type: "transparent",
                                            children: (0,dates/* dateWithTime */.tZ)(liveAtString)
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6/* default */.Z, {
                                            color: "var(--color-text-primary)",
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbeddedQuizCard_LessonInfo, {
                                            color: "var(--color-text-secondary)",
                                            children: specialInfoString || (0,Item/* getQuizInfoString */.Kc)(classData, true)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_EmbeddedQuizCard = (EmbeddedQuizCard);
EmbeddedQuizCard.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    batch: (prop_types_default()).bool
};
EmbeddedQuizCard.defaultProps = {
    batch: false
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/MessageCard.jsx






var MessageCard_Message = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e19ningj0",
    label: "Message"
})("color:var(--color-text-primary);font-size:12px;line-height:150%;");
var MessageCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "e19ningj1",
    label: "StyledCard"
})("margin-top:16px;");
var MessageCard = function(param) {
    var story = param.story, batch = param.batch;
    var message = story.message, author = story.author, created_at = story.created_at, object = story.object;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_AuthorHeader, {
                author: author,
                created_at: created_at,
                subtitle: batch && (object === null || object === void 0 ? void 0 : object.collection_name)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MessageCard_StyledCard, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MessageCard_Message, {
                    children: message
                })
            })
        ]
    });
};
/* harmony default export */ var StoryItem_MessageCard = (MessageCard);
MessageCard.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    batch: (prop_types_default()).bool
};
MessageCard.defaultProps = {
    batch: false
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/components/Container/Practice/constants.js
var Practice_constants = __webpack_require__(88322);
// EXTERNAL MODULE: ./src/components/Container/Practice/usePracticeSegmentAnalytics.js
var usePracticeSegmentAnalytics = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/stores/selectors/darkModeStatusSelectors.js
var darkModeStatusSelectors = __webpack_require__(57054);
// EXTERNAL MODULE: ./src/stores/useDarkModeStatus.js
var useDarkModeStatus = __webpack_require__(3458);
// EXTERNAL MODULE: ./src/redux/actions/practiceSession.js
var practiceSession = __webpack_require__(70261);
// EXTERNAL MODULE: ./src/stores/auto-dpp/dppFinishSummaryStore.js
var dppFinishSummaryStore = __webpack_require__(77729);
// EXTERNAL MODULE: ./src/stores/planner/practiceStore.js
var practiceStore = __webpack_require__(20647);
;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/PracticeCard.jsx




















var OuterWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "enu0gy90",
    label: "OuterWrapper"
})("background-color:var(--color-base-1);margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "enu0gy91",
    label: "StyledButton"
})("border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";font-size:", styleConstants/* Fonts.SMALL */.F3.HC, ";height:36px;color:", function(param) {
    var $isDarkModeOn = param.$isDarkModeOn, $textColor = param.$textColor;
    return $isDarkModeOn ? $textColor : "";
}, ";");
var ActionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "enu0gy92",
    label: "ActionWrapper"
})("display:flex;justify-content:space-between;align-items:center;padding-top:", styleConstants/* Spacings.SPACING_5B */.t8.zj, ";height:", styleConstants/* Spacings.SPACING_14B */.t8.zJ, ";margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";border-top:solid 1px var(--color-divider);");
var PracticeCard_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "enu0gy93",
    label: "Title"
})("color:var(--color-text-primary);font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";line-height:16px;");
var PracticeCard_SubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "enu0gy94",
    label: "SubTitle"
})("font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";line-height:14px;color:var(--color-text-secondary);margin-top:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";");
var PracticeInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "enu0gy95",
    label: "PracticeInfo"
})("font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";line-height:14px;color:var(--color-text-secondary);margin-top:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var practiceStatus = {
    COMPLETED: 1,
    NOT_COMPLETED: 0
};
var PracticeCard = function(param) {
    var story = param.story, onCloseUpdates = param.onCloseUpdates;
    var message = story.message, createdAt = story.created_at, object = story.object;
    var quizUID = object.uid, _author = object.author, author = _author === void 0 ? {} : _author, goal = object.goal, numOfQuestions = object.num_questions, tmp = object.class_details, classDetails = tmp === void 0 ? {} : tmp, status = object.status, topicGroupUID = object.topic_group, sessionUID = object.session_uid;
    var name = classDetails.name, rank = classDetails.rank, liveAt = classDetails.live_at;
    var tmp1 = author.first_name, firstName = tmp1 === void 0 ? "" : tmp1, tmp2 = author.last_name, lastName = tmp2 === void 0 ? "" : tmp2;
    var COMPLETED = practiceStatus.COMPLETED, NOT_COMPLETED = practiceStatus.NOT_COMPLETED;
    var toggleShowSummary = (0,dppFinishSummaryStore/* default */.Z)().toggleShowSummary;
    var isCompleted = status === COMPLETED;
    var segmentAnalytics = (0,usePracticeSegmentAnalytics/* default */.Z)(goal.uid);
    var isDarkModeOn = (0,useDarkModeStatus/* default */.Z)(darkModeStatusSelectors/* getIsDarkModeOn */.q1);
    var dispatch = (0,es/* useDispatch */.I0)();
    var setFinishSummary = (0,dppFinishSummaryStore/* default */.Z)().setFinishSummary;
    var finishPlannerPracticeSession = (0,practiceStore/* default */.Z)().finishPlannerPracticeSession;
    var handleButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(isCompleted && sessionUID)) {
                            _ctx.next = 7;
                            break;
                        }
                        finishPlannerPracticeSession({}, false);
                        _ctx.next = 4;
                        return dispatch((0,practiceSession/* finishPracticeSession */.GF)(sessionUID));
                    case 4:
                        onCloseUpdates();
                        setFinishSummary({
                            goalSlug: goal.slug,
                            goalUID: goal.uid,
                            sessionId: sessionUID,
                            topicType: Practice_constants/* PRACTICE_TYPE.EACH_TOPIC */.Ws.EACH_TOPIC,
                            type: Practice_constants/* PRACTICE_FLOW_TYPE.AUTO_DPP */.nI.AUTO_DPP,
                            topicGroup: topicGroupUID,
                            topicUID: topicGroupUID,
                            quizUID: quizUID,
                            educatorName: "".concat(firstName, " ").concat(lastName)
                        });
                        return _ctx.abrupt("return", toggleShowSummary());
                    case 7:
                        if (!(quizUID && topicGroupUID && goal)) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", (0,pushRoute/* default */.Z)({
                            pathname: "/goal/[goalSlug]/[goalUID]/practice/[topicUID]",
                            query: {
                                goalSlug: goal.slug,
                                goalUID: goal.uid,
                                topic_type: Practice_constants/* PRACTICE_TYPE.EACH_TOPIC */.Ws.EACH_TOPIC,
                                type: Practice_constants/* PRACTICE_FLOW_TYPE.AUTO_DPP */.nI.AUTO_DPP,
                                topic_group: topicGroupUID,
                                topicUID: topicGroupUID,
                                quiz_uid: quizUID,
                                educator_name: "".concat(firstName, " ").concat(lastName),
                                source: "course updates"
                            }
                        }).then(function() {
                            return segmentAnalytics(segment/* PRACTICE_STARTED */.k6n, {
                                topic_uid: null,
                                practice_questions: numOfQuestions,
                                topology_id: topicGroupUID,
                                topology_name: "NA",
                                topology_level: "NA",
                                last_primary_source_section: "course updates",
                                language: "NA",
                                practice_type: "Educator Led Practice",
                                is_completed: isCompleted ? "Yes" : "No"
                            });
                        }));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: message,
                img: "new-practice.svg",
                created_at: createdAt
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OuterWrapper, {
                padding: styleConstants/* Spacings.SPACING_5B */.t8.zj,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PracticeCard_Title, {
                                children: name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PracticeCard_SubTitle, {
                                children: [
                                    "Lesson ",
                                    rank,
                                    " \u2022 ",
                                    (0,dates/* getDateMonthString */.$s)(liveAt, false, false)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PracticeInfo, {
                                children: [
                                    numOfQuestions,
                                    " questions by ",
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                            variant: status === NOT_COMPLETED ? "filled" : "hollow",
                            color: "black",
                            label: status === NOT_COMPLETED ? "Start practice" : "View completed practice",
                            width: status === NOT_COMPLETED ? "128px" : "220px",
                            maxHeight: "sm",
                            $isDarkModeOn: isDarkModeOn,
                            $textColor: status === NOT_COMPLETED ? "var(--color-i-black)" : "var(--color-i-gray-9)",
                            onClick: handleButtonClick
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_PracticeCard = (PracticeCard);

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/CourseEditCard.jsx








var CourseEditCard_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StoryItem_Card, {
    target: "egj98sg0",
    label: "StyledCard"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyledP2 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "egj98sg1",
    label: "StyledP2"
})("font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";");
var NewTitleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "egj98sg2",
    label: "NewTitleWrapper"
})("margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var CourseEditCard = function(param) {
    var story = param.story;
    var message = story.message, created_at = story.created_at, object = story.object;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CardHeader, {
                message: message,
                img: "course-edit-icon.svg",
                created_at: created_at
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseEditCard_StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP2, {
                                children: "OLD TITLE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P1/* default */.Z, {
                                children: object.old_title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewTitleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP2, {
                                children: "NEW TITLE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P1/* default */.Z, {
                                children: object.new_title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StoryItem_CourseEditCard = (CourseEditCard);
CourseEditCard.propTypes = {
    story: prop_types_default().objectOf((prop_types_default()).any).isRequired
};

;// CONCATENATED MODULE: ./src/components/Composite/StoryItem/StoryItem.jsx

/* eslint-disable react/prop-types */ 

















var Story = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e154fres0",
    label: "Story"
})("display:flex;flex-direction:column;grid-column:span 10;margin-top:", styleConstants/* Spacings.SPACING_14B */.t8.zJ, ";&:last-of-type{padding-bottom:24px;}");
var StoryItem = function(param) {
    var story = param.story, selectedStory = param.selectedStory, channelId = param.channelId, setSelectedStory = param.setSelectedStory, batch = param.batch, segmentData = param.segmentData, onCloseUpdates = param.onCloseUpdates;
    var dispatch = (0,es/* useDispatch */.I0)();
    var object_type = story.object_type, sub_type = story.sub_type;
    if (![
        CLASS,
        CLASS_RESCHEDULE,
        DOCUMENT,
        COURSE_EDIT,
        TEXT,
        EDUCATOR,
        COURSE,
        LEADERBOARD,
        IMAGE,
        QUIZ,
        PRACTICE_PUBLISHED
    ].includes(object_type)) return null;
    if (!story.object.uid && object_type !== TEXT && object_type !== DOCUMENT && object_type !== CLASS_RESCHEDULE && object_type !== IMAGE && object_type !== COURSE_EDIT) return null;
    var loadMoreComments = function() {
        return dispatch((0,courses/* fetchComments */.tH)(story.uid, true));
    };
    var updateLike = function(uid, isLiked) {
        return dispatch((0,courses/* toggleLike */.VO)(channelId, uid, isLiked));
    };
    var postComment = function(uid, text) {
        dispatch((0,courses/* addComment */.Ir)(uid, text)).then(function() {
            dispatch((0,courses/* adjustCommentNumber */.Ux)(channelId, uid));
        });
    };
    var getComments = function() {
        dispatch((0,courses/* fetchComments */.tH)(story.uid));
        setSelectedStory(story);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Story, {
        children: [
            object_type === PRACTICE_PUBLISHED && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_PracticeCard, {
                story: story,
                onCloseUpdates: onCloseUpdates
            }),
            object_type === TEXT && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_MessageCard, {
                batch: batch,
                story: story
            }),
            object_type === QUIZ && sub_type === 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_NewClass, {
                batch: batch,
                story: story
            }),
            object_type === QUIZ && sub_type !== 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_EmbeddedQuizCard, {
                batch: batch,
                story: story
            }),
            object_type === CLASS && sub_type === 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_NewClass, {
                batch: batch,
                story: story
            }),
            object_type === CLASS && sub_type !== 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_NewEmbeddedClassCard, {
                batch: batch,
                story: story
            }),
            object_type === CLASS_RESCHEDULE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_ClassRescheduledCard, {
                batch: batch,
                story: story
            }),
            object_type === COURSE_EDIT && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_CourseEditCard, {
                story: story
            }),
            object_type === DOCUMENT && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_DocumentCard, {
                batch: batch,
                story: story,
                segmentData: segmentData
            }),
            object_type === EDUCATOR && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_NewEducatorCard, {
                batch: batch,
                story: story
            }),
            object_type === COURSE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_NewCourseCard, {
                batch: batch,
                story: story
            }),
            object_type === LEADERBOARD && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_Leaderboard, {
                batch: batch,
                story: story
            }),
            object_type === IMAGE && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_ImageCard, {
                batch: batch,
                story: story
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryItem_LikeComment, {
                toggleLike: updateLike,
                postComment: postComment,
                getComments: getComments,
                selectedStory: selectedStory,
                story: story,
                loadMoreComments: loadMoreComments
            })
        ]
    });
};
/* harmony default export */ var StoryItem_StoryItem = (StoryItem);


/***/ }),

/***/ 14233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76356);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);




var anchorStyle = function(color) {
    return "\n  display: inline-block;\n  border-bottom-width: ".concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .PRIMARY_BORDER_WIDTH */ .UK, ";\n  border-top-width: 0;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-style: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .DASHED_BORDER_STYLE */ .wF, ";\n  border-color: ").concat(color, ";\n  padding-bottom: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1B */ .t8.MK, ";\n  cursor: pointer;\n  @media(max-width:70.95em){\n    padding-bottom:8px;\n  }\n  ");
};
var UnderlineLink = function(param) {
    var href = param.href, as = param.as, color = param.color, onClick = param.onClick, disabled = param.disabled, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        anchorStyle: anchorStyle(color),
        href: href,
        as: as,
        onClick: onClick,
        disabled: disabled,
        className: className,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UnderlineLink);
UnderlineLink.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    as: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node)
};
UnderlineLink.defaultProps = {
    as: null,
    onClick: null,
    disabled: false,
    color: "BLACK",
    className: "",
    children: null
};


/***/ }),

/***/ 281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35415);
/* harmony import */ var _base_H3_H3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82034);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85620);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core_Slide__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82285);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);











var Transition = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.forwardRef)(function Transition(props, ref) {
    //  @ts-ignore
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_material_ui_core_Slide__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        direction: "up",
        ref: ref
    }, props));
});
var ButtonsWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])("div", {
    target: "e1u0k7wm0",
    label: "ButtonsWrapper"
})("display:flex;justify-content:center;button{&:not(:first-child){margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";}}");
var StyButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    target: "e1u0k7wm1",
    label: "StyButton"
})("height:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_12B */ .t8.SL, ";");
var StyledDialog = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    target: "e1u0k7wm2",
    label: "StyledDialog"
})("&.MuiDialog-root .MuiDialog-container .MuiPaper-root{position:absolute;bottom:0px;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .mobile.maxWidth */ .ai.maxWidth, "){width:95%;margin:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";}}");
var StyP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e1u0k7wm3",
    label: "StyP1"
})("color:var(--color-text-secondary);max-width:464px;margin:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, " auto ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, " auto;text-align:center;");
var MsgWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__["default"])("div", {
    target: "e1u0k7wm4",
    label: "MsgWrapper"
})("width:560px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_10B */ .t8.FC, " ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_12B */ .t8.SL, ";text-align:center;background-color:var(--color-base-1);@media (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .breakpoints.mobile */ .AV.mobile, "){width:100%;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";}");
var LiteUpgradeDialog = function(param) {
    var message = param.message, onClose = param.onClose, upgradeSubscription = param.upgradeSubscription;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledDialog, {
        open: true,
        // @ts-ignore
        TransitionComponent: Transition,
        onClose: onClose,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(MsgWrapper, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_base_H3_H3__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    children: "Upgrade for full access"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyP1, {
                    children: message
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(ButtonsWrapper, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyButton, {
                            // @ts-ignore
                            label: "Maybe later",
                            variant: "hollow",
                            color: "black",
                            onClick: onClose,
                            grid: 2,
                            width: "216px"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyButton, {
                            // @ts-ignore
                            label: "Upgrade subscription",
                            variant: "filled",
                            color: "green",
                            onClick: upgradeSubscription,
                            grid: 2,
                            width: "216px"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LiteUpgradeDialog);
LiteUpgradeDialog.defaultProps = {
    message: "Plus & Iconic learners can enroll into courses and batches. Also get access to notes and more self-study features."
};


/***/ }),

/***/ 84852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80867);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _utils_isEmptyObject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9759);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_profile_useLevelDisplayInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72830);
/* harmony import */ var _cont_MeDashboard_NextImageAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72391);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88775);









// do we need to make different mapping for avatar size config
var avatarSizeConfig = {
    S: {
        totalWidth: "48px",
        avatarWidth: "40px",
        badgeWidth: "14px",
        avatarBorder: "2px solid var(--color-base-1)",
        badgeContainerPadding: "1.5px 0",
        badgePositionLeft: "30px"
    },
    M: {
        totalWidth: "80px",
        avatarWidth: "66.67px",
        badgeWidth: "20px",
        avatarBorder: "3px solid var(--color-base-1)",
        badgeContainerPadding: "2.5px 0",
        badgePositionLeft: "50px"
    },
    L: {
        totalWidth: "128px",
        avatarWidth: "106.67px",
        badgeWidth: "36px",
        avatarBorder: "4px solid var(--color-base-1)",
        badgeContainerPadding: "3px 0",
        badgePositionLeft: "80px"
    },
    XL: {
        totalWidth: "160px",
        avatarWidth: "133.33px",
        badgeWidth: "53.33px",
        avatarBorder: "5px solid var(--color-base-1)",
        badgeContainerPadding: "4px 0",
        badgePositionLeft: "113.33px"
    }
};
var platinumAvatarSizeConfig = {
    L: {
        totalWidth: "128px",
        avatarWidth: "128px",
        badgeWidth: "0px",
        avatarBorder: "4px solid var(--color-base-1)",
        badgeContainerPadding: "3px 0",
        badgePositionLeft: "80px"
    }
};
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "epymaz30",
    label: "Flex"
})("display:flex;justify-content:center;align-items:center;");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(Flex, {
    target: "epymaz31",
    label: "Wrapper"
})("box-sizing:content-box;width:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";height:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";position:relative;padding:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].wrapperPadding;
}, ";border-radius:50%;flex:0 0 auto;background:", function(param) {
    var $badgeColor = param.$badgeColor;
    return "linear-gradient(rgba(255,255,255,0) 0 40%, ".concat($badgeColor, ")");
}, ";");
var PlatinumWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(Flex, {
    target: "epymaz32",
    label: "PlatinumWrapper"
})("box-sizing:content-box;width:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";height:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";position:relative;padding:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].wrapperPadding;
}, ";flex:0 0 auto;border:1px solid var(--color-i-gray-v2);border-radius:8px;");
var BadgeContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "epymaz33",
    label: "BadgeContainer"
})("position:absolute;display:flex;left:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].badgePositionLeft;
}, ";bottom:0%;clip-path:polygon(0px 26%,51% 0px,100% 25%,100% 75%,50% 100%,0px 75%);background:", function(param) {
    var $badgeBgColor = param.$badgeBgColor;
    return $badgeBgColor || "var(--color-base-1)";
}, ";justify-content:center;align-items:center;padding:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].badgeContainerPadding;
}, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2 */ .t8.Jl, ";");
var StyledAvatar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_cont_MeDashboard_NextImageAvatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "epymaz34",
    label: "StyledAvatar"
})("border:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].avatarBorder;
}, ";");
var EducatorAvatar = function(param) {
    var size = param.size, src = param.src, levelInfo = param.levelInfo, isPlatinumEducator = param.isPlatinumEducator, badgeBgColor = param.badgeBgColor, isPartnerEducator = param.isPartnerEducator;
    var ref;
    var ref1 = (0,_api_hooks_profile_useLevelDisplayInfo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), _levelsDisplayInfo = ref1.levelsDisplayInfo, levelsDisplayInfo = _levelsDisplayInfo === void 0 ? [] : _levelsDisplayInfo;
    var currentLevelDisplayInfo = levelsDisplayInfo === null || levelsDisplayInfo === void 0 ? void 0 : (ref = levelsDisplayInfo.find) === null || ref === void 0 ? void 0 : ref.call(levelsDisplayInfo, function(levelDisplayInfo) {
        return levelDisplayInfo.levelId === ((levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.currentLevelId) || (levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.current_level_id));
    });
    currentLevelDisplayInfo = isPartnerEducator ? _constants__WEBPACK_IMPORTED_MODULE_5__/* .PARTNER_EDUCATOR_CONFIG */ .BB : currentLevelDisplayInfo;
    if (!isPlatinumEducator && !isPartnerEducator && ((0,_utils_isEmptyObject__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(levelInfo) || !currentLevelDisplayInfo)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_cont_MeDashboard_NextImageAvatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            size: avatarSizeConfig[size].totalWidth,
            src: src
        });
    }
    var CurrentWrapper = isPlatinumEducator ? PlatinumWrapper : Wrapper;
    var CurrentAvatarConfig = avatarSizeConfig;
    if (isPlatinumEducator) {
        CurrentAvatarConfig.L = platinumAvatarSizeConfig.L;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(CurrentWrapper, {
        $size: size,
        $badgeColor: currentLevelDisplayInfo === null || currentLevelDisplayInfo === void 0 ? void 0 : currentLevelDisplayInfo.color.primary,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(StyledAvatar, {
                size: CurrentAvatarConfig[size].avatarWidth,
                src: src,
                circular: !isPlatinumEducator,
                $size: size
            }),
            !isPlatinumEducator && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BadgeContainer, {
                $size: size,
                $badgeBgColor: badgeBgColor,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    src: currentLevelDisplayInfo === null || currentLevelDisplayInfo === void 0 ? void 0 : currentLevelDisplayInfo.asset.badge,
                    width: avatarSizeConfig[size].badgeWidth,
                    height: avatarSizeConfig[size].badgeWidth,
                    alt: "badge"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EducatorAvatar);
EducatorAvatar.propTypes = {
    size: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        "S",
        "M",
        "L",
        "XL"
    ]).isRequired,
    src: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    levelInfo: prop_types__WEBPACK_IMPORTED_MODULE_8___default().shape((prop_types__WEBPACK_IMPORTED_MODULE_8___default().any))
};
EducatorAvatar.defaultProps = {
    src: "",
    levelInfo: {}
};


/***/ }),

/***/ 88775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ PARTNER_EDUCATOR_CONFIG; },
/* harmony export */   "If": function() { return /* binding */ EDUCATOR_PROFILE_VIEWED; },
/* harmony export */   "Nl": function() { return /* binding */ TOPICS; },
/* harmony export */   "Ru": function() { return /* binding */ BATCH; },
/* harmony export */   "X7": function() { return /* binding */ DPPS; },
/* harmony export */   "YD": function() { return /* binding */ BANNER_CLICKED; },
/* harmony export */   "hR": function() { return /* binding */ BATCH_GROUPS; },
/* harmony export */   "k6": function() { return /* binding */ PRACTICE_STARTED; },
/* harmony export */   "qF": function() { return /* binding */ MIN_QUIZ_ATTEMPTS; },
/* harmony export */   "v8": function() { return /* binding */ FREE; },
/* harmony export */   "yL": function() { return /* binding */ stripLength; }
/* harmony export */ });
/* unused harmony exports BATCH_GROUP, TOPICS_TAB_CLICKED */
var BATCH_GROUP = "batch_group";
var FREE = "free";
var BATCH = "batch";
var BATCH_GROUPS = "batch_groups";
var TOPICS = "topics";
var DPPS = "educator_dpp";
// Events Constants
var BANNER_CLICKED = "Banner - Banner Clicked";
var TOPICS_TAB_CLICKED = "Educator - Profile Tab Clicked";
var EDUCATOR_PROFILE_VIEWED = "Educator Profile Viewed";
var PRACTICE_STARTED = "Practice - Practice Started";
var stripLength = {
    goal: 11,
    topic: 13
};
var MIN_QUIZ_ATTEMPTS = 10;
var PARTNER_EDUCATOR_CONFIG = {
    color: {
        primary: "#6496BC"
    },
    asset: {
        badge: "https://static.uacdn.net/web-cms/Partner_badge_2_4a9f6a1b22.png"
    },
    name: "Partner Educator"
};


/***/ }),

/***/ 72391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80867);








var StyledAvatar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Image__WEBPACK_IMPORTED_MODULE_2__["default"], {
    target: "e1j9ated0",
    label: "StyledAvatar"
})("border-radius:", function(param) {
    var $circular = param.$circular;
    return $circular ? "50%" : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw;
}, ";width:", function(param) {
    var size = param.size;
    return size;
}, ";height:", function(param) {
    var size = param.size;
    return size;
}, ";object-fit:cover;cursor:pointer;user-drag:none;user-select:none;");
var NextImageAvatar = function(props) {
    var src = props.src, className = props.className, circular = props.circular, size = props.size, alt = props.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "src",
        "className",
        "circular",
        "size",
        "alt"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledAvatar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        $circular: circular,
        src: src,
        className: className,
        height: size,
        width: size,
        decoding: "async",
        loading: "eager",
        alt: alt
    }));
};
NextImageAvatar.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    circular: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
NextImageAvatar.defaultProps = {
    height: "initial",
    width: "initial",
    size: null,
    className: "",
    circular: false,
    alt: "Avatar"
};
/* harmony default export */ __webpack_exports__["Z"] = (NextImageAvatar);


/***/ }),

/***/ 91202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var AddToList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M16.668 25.832h46.667c0.663 0 1.299-0.263 1.768-0.732s0.732-1.105 0.732-1.768c0-0.663-0.264-1.299-0.732-1.768s-1.105-0.732-1.768-0.732h-46.667c-0.663 0-1.299 0.263-1.768 0.732s-0.732 1.105-0.732 1.768c0 0.663 0.263 1.299 0.732 1.768s1.105 0.732 1.768 0.732zM35.001 54.168h-18.333c-0.663 0-1.299 0.263-1.768 0.732s-0.732 1.105-0.732 1.768 0.263 1.299 0.732 1.768c0.469 0.469 1.105 0.732 1.768 0.732h18.333c0.663 0 1.299-0.264 1.768-0.732s0.732-1.104 0.732-1.768c0-0.663-0.263-1.299-0.732-1.768s-1.105-0.732-1.768-0.732zM35.001 37.5h-18.333c-0.663 0-1.299 0.263-1.768 0.732s-0.732 1.105-0.732 1.768c0 0.663 0.263 1.299 0.732 1.768s1.105 0.732 1.768 0.732h18.333c0.663 0 1.299-0.263 1.768-0.732s0.732-1.104 0.732-1.768c0-0.663-0.263-1.299-0.732-1.768s-1.105-0.732-1.768-0.732zM63.335 45.534h-6.133v-6.167c0-0.663-0.264-1.299-0.732-1.768s-1.105-0.732-1.768-0.732c-0.663 0-1.299 0.263-1.768 0.732s-0.732 1.105-0.732 1.768v6.167h-6.167c-0.663 0-1.299 0.263-1.768 0.732s-0.732 1.105-0.732 1.768c0 0.663 0.263 1.299 0.732 1.768s1.105 0.732 1.768 0.732h6.167v6.133c0 0.663 0.263 1.299 0.732 1.768s1.105 0.732 1.768 0.732c0.663 0 1.299-0.264 1.768-0.732s0.732-1.104 0.732-1.768v-6.133h6.133c0.663 0 1.299-0.264 1.768-0.732s0.732-1.105 0.732-1.768c0-0.663-0.264-1.299-0.732-1.768s-1.105-0.732-1.768-0.732z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AddToList);


/***/ }),

/***/ 12460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var AddedToList = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M63.335 25.832h-46.667c-0.663 0-1.299-0.263-1.768-0.732s-0.732-1.105-0.732-1.768c0-0.663 0.263-1.299 0.732-1.768s1.105-0.732 1.768-0.732h46.667c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768c0 0.663-0.264 1.299-0.732 1.768s-1.105 0.732-1.768 0.732zM35.001 59.168h-18.333c-0.663 0-1.299-0.264-1.768-0.732s-0.732-1.104-0.732-1.768c0-0.663 0.263-1.299 0.732-1.768s1.105-0.732 1.768-0.732h18.333c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768-0.263 1.299-0.732 1.768c-0.469 0.469-1.105 0.732-1.768 0.732zM35.001 42.5h-18.333c-0.663 0-1.299-0.263-1.768-0.732s-0.732-1.104-0.732-1.768c0-0.663 0.263-1.299 0.732-1.768s1.105-0.732 1.768-0.732h18.333c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768c0 0.663-0.263 1.299-0.732 1.768s-1.105 0.732-1.768 0.732zM48.998 59.165c-0.328 0.002-0.654-0.062-0.957-0.188s-0.578-0.311-0.809-0.545l-6.667-6.667c-0.246-0.229-0.443-0.505-0.579-0.812s-0.21-0.638-0.216-0.973 0.056-0.669 0.182-0.98c0.126-0.311 0.313-0.594 0.55-0.832s0.52-0.424 0.832-0.55c0.311-0.126 0.645-0.187 0.98-0.182s0.667 0.080 0.974 0.216c0.306 0.136 0.582 0.334 0.811 0.579l5 5 12.667-12.667c0.229-0.246 0.505-0.443 0.812-0.579s0.638-0.21 0.973-0.216c0.336-0.006 0.669 0.056 0.98 0.182s0.594 0.313 0.832 0.55c0.238 0.238 0.424 0.52 0.55 0.832s0.187 0.645 0.182 0.98c-0.006 0.336-0.080 0.667-0.216 0.974s-0.334 0.582-0.58 0.811l-14.433 14.434c-0.251 0.228-0.546 0.402-0.867 0.511s-0.662 0.15-1 0.122z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AddedToList);


/***/ }),

/***/ 93303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var ArrowBack = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M66.9 37.5h-47.267l15.7-15.833c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0c-0.452-0.452-1.077-0.731-1.767-0.731s-1.314 0.279-1.767 0.731v0l-20 20.2c-0.433 0.424-0.702 1.015-0.702 1.668 0 0.035 0.001 0.069 0.002 0.103l-0-0.005c0.001 0.69 0.281 1.315 0.733 1.767v0l20.2 20c0.442 0.453 1.059 0.733 1.741 0.733 0.009 0 0.018-0 0.027-0h-0.001c1.365-0.020 2.465-1.131 2.465-2.5 0-0.69-0.279-1.315-0.731-1.767v0l-16-15.833h47.367c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5v0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowBack);


/***/ }),

/***/ 92542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Check = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M32.767 56.1c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-12.767-12.767c-0.416-0.445-0.671-1.045-0.671-1.704 0-1.381 1.119-2.5 2.5-2.5 0.659 0 1.259 0.255 1.706 0.672l-0.001-0.001 11 10.933 25.467-25.433c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0l-27.233 27.2c-0.434 0.49-1.064 0.798-1.766 0.8h-0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 91656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var ChevronRight = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M27.967 59.8c0-0.003 0-0.008 0-0.012 0-0.687 0.28-1.308 0.733-1.755l18.234-18.234-18.233-18.233c-0.416-0.445-0.671-1.045-0.671-1.704 0-1.381 1.119-2.5 2.5-2.5 0.659 0 1.259 0.255 1.706 0.672l-0.001-0.001 20 20c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0l-20 20c-0.452 0.452-1.077 0.731-1.767 0.731s-1.314-0.279-1.767-0.731v0c-0.453-0.447-0.733-1.068-0.733-1.755 0-0.004 0-0.008 0-0.012v0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronRight);


/***/ }),

/***/ 112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Close = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M43.533 40l21.567-21.567c0.416-0.445 0.671-1.045 0.671-1.704 0-1.381-1.119-2.5-2.5-2.5-0.659 0-1.259 0.255-1.706 0.672l0.001-0.001-21.567 21.567-21.567-21.567c-0.445-0.416-1.045-0.671-1.704-0.671-1.381 0-2.5 1.119-2.5 2.5 0 0.659 0.255 1.259 0.672 1.706l-0.001-0.001 21.567 21.567-21.567 21.567c-0.452 0.452-0.731 1.077-0.731 1.767s0.279 1.314 0.731 1.767v0c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0l21.567-21.567 21.567 21.567c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Close);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var KeyboardArrowDown = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M39.8 52.033c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-20-20c-0.49-0.458-0.796-1.108-0.796-1.829 0-1.381 1.119-2.5 2.5-2.5 0.721 0 1.371 0.306 1.828 0.794l0.001 0.001 18.233 18.233 18.233-18.233c0.445-0.416 1.045-0.671 1.704-0.671 1.381 0 2.5 1.119 2.5 2.5 0 0.659-0.255 1.259-0.672 1.706l0.001-0.001-20 20c-0.447 0.453-1.068 0.733-1.755 0.733-0.004 0-0.008 0-0.012 0h0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (KeyboardArrowDown);


/***/ }),

/***/ 59556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var NotificationBell = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M65.766 49.999c-1.913-1.95-3.182-4.44-3.633-7.133l-3.333-18.067c-0.79-4.402-3.103-8.386-6.534-11.256s-7.761-4.442-12.233-4.442c-4.473 0-8.803 1.572-12.233 4.442s-5.743 6.854-6.533 11.256l-3.333 18.133c-0.483 2.678-1.774 5.144-3.7 7.067-1.333 1.299-2.1 3.072-2.133 4.933v2.6c0.009 1.933 0.781 3.785 2.148 5.152s3.219 2.139 5.152 2.148h9.167c0.567 2.611 2.011 4.949 4.091 6.625s4.671 2.591 7.343 2.591 5.263-0.914 7.343-2.591c2.080-1.677 3.523-4.015 4.091-6.625h9.167c1.933-0.009 3.785-0.781 5.152-2.148s2.139-3.219 2.148-5.152v-2.6c-0.034-1.861-0.8-3.634-2.133-4.933zM40 69.166c-1.345 0.005-2.66-0.396-3.772-1.152s-1.971-1.83-2.461-3.082h12.5c-0.493 1.257-1.356 2.335-2.475 3.091s-2.441 1.154-3.792 1.142zM62.9 57.633c0 0.61-0.242 1.195-0.674 1.626s-1.016 0.674-1.626 0.674h-41.2c-0.61 0-1.195-0.242-1.626-0.674s-0.674-1.016-0.674-1.626v-2.6c0.050-0.557 0.298-1.078 0.7-1.467 2.635-2.648 4.382-6.049 5-9.733l3.333-18.1c0.597-3.242 2.311-6.172 4.845-8.281s5.726-3.264 9.022-3.264c3.296 0 6.489 1.155 9.022 3.264s4.247 5.039 4.845 8.281l3.333 18.067c0.618 3.694 2.365 7.105 5 9.767 0.401 0.389 0.65 0.91 0.7 1.467v2.6z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (NotificationBell);


/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Share = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M9 62.333c-1-0.333-1.667-1.667-1.333-2.667 4.333-21.667 17.667-35.667 37.333-39v-3.333c0-1.333 0.667-3 1.667-4 2.333-2.333 6-2.333 8.333-0.333l15.667 15.667c2.333 2.333 2.333 6 0 8.333l-15.667 15.667c-1.667 1.667-4.333 2.333-6.333 1.333-2.333-1-3.667-3-3.667-5.333v-3.333c-15 0.667-25.333 5.667-33 16.333-0.333 0.667-1.333 1-2 1-0.333 0-0.667 0-1-0.333zM47.667 40c1.333 0 2.333 1.333 2.333 2.667v5.667c0 0.333 0.333 0.667 0.667 0.667s0.667 0 1-0.333l15.667-15.667c0 0 0 0 0 0 0.333-0.333 0.333-1 0-1.333l-15.667-15.667c-0.333-0.333-0.667-0.333-1-0.333-0.333 0.667-0.667 1-0.667 1.333v5.333c0 1.333-1 2.333-2 2.333-14.667 1.667-27.333 11.333-32.333 25.333 8-6.667 18.333-10 32-10 0 0 0 0 0 0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Share);


/***/ }),

/***/ 32984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useLiteUpgradeDialog = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), showLiteUpgradeDialog = ref[0], setShowLiteUpgradeDialog = ref[1];
    var closeLiteUpgradeDialog = function() {
        return setShowLiteUpgradeDialog(false);
    };
    var openLiteUpgradeDialog = function() {
        return setShowLiteUpgradeDialog(true);
    };
    return {
        showLiteUpgradeDialog: showLiteUpgradeDialog,
        closeLiteUpgradeDialog: closeLiteUpgradeDialog,
        openLiteUpgradeDialog: openLiteUpgradeDialog
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLiteUpgradeDialog);


/***/ }),

/***/ 44566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var useOneLinkSmartScriptV2 = function(options) {
    var baseLink = "https://unacademy.onelink.me/RICs/";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), oneLinkURL = ref[0], setoneLinkURL = ref[1];
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!window.AF_SMART_SCRIPT) return;
        var mediaSource = {
            keys: [],
            defaultValue: [
                "Mweb_download"
            ]
        };
        var campaign = {
            keys: [],
            defaultValue: [
                (options === null || options === void 0 ? void 0 : options.campaign) || "Mweb"
            ]
        };
        var deepLinkValue = {
            keys: [],
            defaultValue: asPath.slice(1)
        };
        var deep_link_sub1 = {
            paramKey: "deep_link_sub1",
            keys: [],
            defaultValue: "app_deeplink"
        };
        var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
            oneLinkURL: baseLink,
            afParameters: {
                mediaSource: mediaSource,
                campaign: campaign,
                deepLinkValue: deepLinkValue,
                afCustom: [
                    deep_link_sub1
                ]
            }
        });
        if (result) {
            setoneLinkURL(result.clickURL);
        }
    }, [
        asPath,
        baseLink,
        options
    ]);
    return oneLinkURL;
};
/* harmony default export */ __webpack_exports__["Z"] = (useOneLinkSmartScriptV2);


/***/ }),

/***/ 45872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96487);
/* harmony import */ var _layout_PaymentLayout_usePendingPaymentStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62588);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);



var usePurchaseCTAHandler = function(goalUID) {
    var selectedGoalUID = (0,_api_hooks_topology_useSelectedGoal__WEBPACK_IMPORTED_MODULE_0__/* .useSelectedGoalUID */ .Xm)();
    var pendingPaymentStatus = (0,_layout_PaymentLayout_usePendingPaymentStatus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(goalUID || selectedGoalUID).pendingPaymentStatus;
    var CTA = !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(pendingPaymentStatus) ? "Complete payment" : "Get subscription";
    return CTA;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePurchaseCTAHandler);


/***/ }),

/***/ 11083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useTimeout = function(callback, delay) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (delay !== null) {
            var timer = setTimeout(function() {
                callback();
            }, delay);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useTimeout);


/***/ }),

/***/ 40101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var HeaderContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("header", {
    target: "esrd3a60",
    label: "HeaderContainer"
})("height:72px;width:100%;position:sticky;top:0;z-index:3;");
/* harmony default export */ __webpack_exports__["Z"] = (HeaderContainer);


/***/ }),

/***/ 47731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


var HeaderParent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "euhzmok0",
    label: "HeaderParent"
})("width:1136px;margin:auto;height:100%;position:relative;display:flex;align-items:center;", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{width:728px;}");
/* harmony default export */ __webpack_exports__["Z"] = (HeaderParent);


/***/ }),

/***/ 32078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Composite/Logo/Logo.jsx + 1 modules
var Logo = __webpack_require__(50648);
// EXTERNAL MODULE: ./src/components/Base/Divider/Divider.jsx
var Divider = __webpack_require__(46736);
// EXTERNAL MODULE: ./src/hooks/useTimeout.js
var useTimeout = __webpack_require__(11083);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/components/Base/Dynamic/Dynamic.js + 2 modules
var Dynamic = __webpack_require__(28066);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./src/hooks/useEducatorContext.js
var useEducatorContext = __webpack_require__(49465);
// EXTERNAL MODULE: ./src/hooks/useLayoutOptions.js
var useLayoutOptions = __webpack_require__(73946);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/hooks/usePlatformInfo.js
var usePlatformInfo = __webpack_require__(79592);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/api/hooks/topology/useSelectedGoal.js
var useSelectedGoal = __webpack_require__(96487);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button_Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/components/Container/EducatorProfile/constants.jsx
var EducatorProfile_constants = __webpack_require__(88775);
// EXTERNAL MODULE: ./src/components/Container/Compete/useCompeteConfig.js
var useCompeteConfig = __webpack_require__(94253);
// EXTERNAL MODULE: ./src/components/Container/Compete/constants.ts
var Compete_constants = __webpack_require__(28549);
;// CONCATENATED MODULE: ./src/components/Container/Compete/CompeteHeaderStrip.jsx













var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo8jn6n0",
    label: "Container"
})("overflow:hidden;position:relative;width:100%;background:var(--color-i-violet-22);height:", styleConstants/* Spacings.SPACING_16B */.t8.hN, ";display:flex;align-items:center;justify-content:center;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{height:150px;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";}");
var ContentDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo8jn6n1",
    label: "ContentDiv"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;", styleConstants/* mediaQuery.aboveMobile */.cy.aboveMobile, "{width:1136px;height:", styleConstants/* Spacings.SPACING_16B */.t8.hN, ";margin:auto;position:relative;z-index:1;flex-direction:row;}");
var LeftImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo8jn6n2",
    label: "LeftImage"
})("position:absolute;left:0;top:0;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{top:25px;left:-35px;}");
var RightImage = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo8jn6n3",
    label: "RightImage"
})("position:absolute;right:0;top:0;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{top:25px;right:-35px;}");
var Header = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo8jn6n4",
    label: "Header"
})("font-weight:600;font-size:", styleConstants/* Fonts.H5 */.F3.H5, ";line-height:24px;color:var(--color-i-white);margin:0 ", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";display:flex;align-items:center;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{font-size:", styleConstants/* Fonts.H7 */.F3.H7, ";line-height:16px;margin-top:0;margin-bottom:12px;}");
var StyledBtn = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button_Button/* default */.Z, {
    target: "eo8jn6n5",
    label: "StyledBtn"
})("background-color:var(--color-i-white);color:var(--color-i-icon-dark-tertiary);min-width:97px;height:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";min-height:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";font-size:", styleConstants/* Fonts.H7 */.F3.H7, ";line-height:16px;width:fit-content;&:hover{box-shadow:0px 6px 20px var(--color-i-black-8);}&:active{box-shadow:0px 6px 20px var(--color-i-black-8);background:var(--color-i-gray-29);}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{min-width:102px;padding:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";}");
var sendEventOnClick = function(ctaLabel, goalUID) {
    analytics/* segment.track */.EX.track(EducatorProfile_constants/* BANNER_CLICKED */.YD, {
        cta_button: ctaLabel,
        banner_title: "Post Launch",
        goal_uid: goalUID,
        banner_type: "Compete Awareness"
    });
};
var CompeteHeaderStrip = function() {
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var ref = (0,useCompeteConfig/* default */.Z)(), isCompete = ref.isCompete, state = ref.state;
    var ref1 = (0,next_router.useRouter)(), goalUID = ref1.query.goalUID;
    var isPostLaunch = state === Compete_constants/* COMPETE_STATES.POST_LAUNCH */.mu.POST_LAUNCH;
    (0,react.useEffect)(function() {
        if (isCompete && isPostLaunch) {
            analytics/* segment.track */.EX.track(segment/* Banner_Banner_Viewed */.X4e, {
                banner_title: "Post Launch",
                banner_type: "Compete Awareness",
                goal_uid: goalUID
            });
        }
    }, [
        goalUID,
        isCompete,
        isPostLaunch
    ]);
    if (!isCompete || !isPostLaunch) {
        return null;
    }
    var handleCTA = function() {
        sendEventOnClick("Check it out", goalUID);
        window.open(Compete_constants/* COMPETE_LANDING_PAGE */.km);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentDiv, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftImage, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                        src: isMobile ? "/compete/icon-left.svg" : "/compete/post-launch-left.svg",
                        width: isMobile ? 105 : 224,
                        height: isMobile ? 100 : 64,
                        alt: "clip-left"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightImage, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                        src: isMobile ? "/compete/icon-right.svg" : "/compete/post-launch-right.svg",
                        width: isMobile ? 105 : 224,
                        height: isMobile ? 100 : 64,
                        alt: "clip-right"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                    src: Compete_constants/* COMPETE_IMAGES.LOGO_NO_RINGS */.hS.LOGO_NO_RINGS,
                    width: isMobile ? 150 : 140,
                    height: isMobile ? 58 : 64,
                    alt: "icon",
                    objectFit: isMobile ? "cover" : "contain"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                    children: "Battle and know where you stand"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBtn, {
                    label: "Check it out",
                    onClick: handleCTA
                })
            ]
        })
    });
};
/* harmony default export */ var Compete_CompeteHeaderStrip = (CompeteHeaderStrip);

// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/layout/Components/HeaderParent.jsx
var HeaderParent = __webpack_require__(47731);
// EXTERNAL MODULE: ./src/layout/Components/HeaderContainer.jsx
var HeaderContainer = __webpack_require__(40101);
;// CONCATENATED MODULE: ./src/layout/Header/Header.jsx






























var GoalSelector = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(35303), __webpack_require__.e(82492), __webpack_require__.e(96523), __webpack_require__.e(21322), __webpack_require__.e(84872), __webpack_require__.e(95908), __webpack_require__.e(1314), __webpack_require__.e(9720), __webpack_require__.e(46571), __webpack_require__.e(94336), __webpack_require__.e(90458), __webpack_require__.e(85226)]).then(__webpack_require__.bind(__webpack_require__, 90458));
});
var SearchTab = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74061), __webpack_require__.e(36169)]).then(__webpack_require__.bind(__webpack_require__, 36169));
});
var HeaderUser = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(21322), __webpack_require__.e(69210), __webpack_require__.e(31991), __webpack_require__.e(13024), __webpack_require__.e(85758)]).then(__webpack_require__.bind(__webpack_require__, 13024));
});
var ProfileOptions = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(21322), __webpack_require__.e(31991), __webpack_require__.e(35998)]).then(__webpack_require__.bind(__webpack_require__, 31991));
});
var RenderLoginAction = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 45611).then(__webpack_require__.bind(__webpack_require__, 45611));
});
var PaymentNudge = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(34040), __webpack_require__.e(28747)]).then(__webpack_require__.bind(__webpack_require__, 34040));
});
var HeaderNotification = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 6799).then(__webpack_require__.bind(__webpack_require__, 67854));
});
var AutoDppDismissibleCard = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(35303), __webpack_require__.e(82492), __webpack_require__.e(52420), __webpack_require__.e(81527), __webpack_require__.e(71198)]).then(__webpack_require__.bind(__webpack_require__, 71198));
});
var NotificationToPwa = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 28701).then(__webpack_require__.bind(__webpack_require__, 28701));
});
var Header_HeaderContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(HeaderContainer/* default */.Z, {
    target: "e1tj955r0",
    label: "HeaderContainer"
})("background:", function(param) {
    var transparent = param.transparent, hideBgColor = param.hideBgColor;
    return transparent || hideBgColor ? "none" : "var(--color-base-1)";
}, ";box-shadow:", function(param) {
    var transparent = param.transparent, hideBgColor = param.hideBgColor, hideBoxShadow = param.hideBoxShadow;
    return transparent || hideBgColor || hideBoxShadow ? "initial" : (0,boxShadowGenerator/* default */.Z)();
}, ";position:", function(param) {
    var transparent = param.transparent;
    return transparent ? "absolute" : "sticky";
}, ";height:", function(param) {
    var $isCompetePostLaunch = param.$isCompetePostLaunch;
    return $isCompetePostLaunch ? "136px" : "72px";
}, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{height:", function(param) {
    var $isCompetePostLaunch = param.$isCompetePostLaunch;
    return $isCompetePostLaunch ? "136px" : "72px";
}, ";}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{box-shadow:inset 0px -1px 0px var(--color-shadow);display:block;width:100%;height:", function(param) {
    var $isCompetePostLaunch = param.$isCompetePostLaunch;
    return $isCompetePostLaunch ? "198px" : "48px";
}, ";background-color:var(\n      ", function(param) {
    var $showCompeteBackground = param.$showCompeteBackground;
    return $showCompeteBackground ? "--color-i-violet-22" : "--color-base-1";
}, "    );}background-color:var(\n    ", function(param) {
    var showCompeteBackground = param.showCompeteBackground;
    return showCompeteBackground ? "--color-i-violet-22" : "";
}, "  );");
var Header_HeaderParent = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(HeaderParent/* default */.Z, {
    target: "e1tj955r1",
    label: "HeaderParent"
})("height:72px;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{width:100%;padding:0 16px;}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:flex;width:100%;height:48px;padding:16px;justify-content:space-between;}");
var StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "e1tj955r2",
    label: "StyledDivider"
})("&.MuiDivider-root{margin:0 ", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";height:24px;width:2px;border-radius:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, ";}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:none;}background-color:var(\n    ", function(param) {
    var $showCompeteBackground = param.$showCompeteBackground;
    return $showCompeteBackground ? "--color-i-divider" : "";
}, "  );");
var RightContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tj955r3",
    label: "RightContentWrapper"
})("display:flex;align-items:center;margin-left:auto;");
var HeaderReferralWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "e1tj955r4",
    label: "HeaderReferralWrapper"
})("box-sizing:border-box;margin-right:", function(param) {
    var $isLoggedIn = param.$isLoggedIn;
    return $isLoggedIn ? styleConstants/* Spacings.SPACING_0B */.t8.NE : styleConstants/* Spacings.SPACING_4B */.t8.BM;
}, ";padding:", styleConstants/* Spacings.SPACING_1B */.t8.MK, " ", styleConstants/* Spacings.SPACING_3B */.t8.N, ";height:", function(param) {
    var $isLoggedIn = param.$isLoggedIn;
    return $isLoggedIn ? styleConstants/* Spacings.SPACING_8B */.t8.B3 : styleConstants/* Spacings.SPACING_10B */.t8.FC;
}, ";border:1px solid var(--color-i-divider);border-radius:", function(param) {
    var $isLoggedIn = param.$isLoggedIn;
    return $isLoggedIn ? styleConstants/* Spacings.SPACING_12B */.t8.SL : styleConstants/* Spacings.SPACING_1B */.t8.MK;
}, ";&.MuiButton-root{text-transform:unset;border-radius:50%;", function(param) {
    var $isLoggedIn = param.$isLoggedIn;
    return $isLoggedIn ? "min-width:".concat(styleConstants/* Spacings.SPACING_8B */.t8.B3, "; width:").concat(styleConstants/* Spacings.SPACING_8B */.t8.B3, "; height:").concat(styleConstants/* Spacings.SPACING_8B */.t8.B3, ";") : "min-width:".concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, "; width:").concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, "; height:").concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
}, "}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{margin-right:", function(param) {
    var $isLoggedIn = param.$isLoggedIn;
    return $isLoggedIn ? styleConstants/* Spacings.SPACING_0B */.t8.NE : styleConstants/* Spacings.SPACING_2B */.t8.Rw;
}, ";&.MuiButton-root{min-width:32px;height:32px;width:32px;}}");
var ReferralContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tj955r5",
    label: "ReferralContainer"
})("display:flex;flex-direction:row;align-items:center;gap:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";flex:none;");
var HeaderUserContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tj955r6",
    label: "HeaderUserContainer"
})("min-width:", function(param) {
    var $hideWatchMinForPlatform = param.$hideWatchMinForPlatform;
    return $hideWatchMinForPlatform ? "unset" : "185px";
}, ";display:flex;align-items:center;justify-content:flex-end;");
var GoalSelectorWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tj955r7",
    label: "GoalSelectorWrapper"
})("display:flex;align-items:center;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{flex:1;margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";button{padding-left:0px;}}");
var LogoContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tj955r8",
    label: "LogoContainer"
})(styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:none;}");
var isSubscriptionPricingsUrl = function(route) {
    return route === "/goal/[goalSlug]/[goalUID]/subscribe";
};
var onlyLogo = [
    "/careers/public-notice"
];
var hideLoginButtonOnMobileUrls = [
    "/goal/[goalSlug]/[goalUID]",
    "/course/[slug]/[courseUID]",
    "/lesson/[lessonSlug]/[lessonUID]"
];
var Header_Header = function(param) {
    var transparent = param.transparent, hideSearch = param.hideSearch, hideGoalSelector = param.hideGoalSelector, isCheckoutUrl = param.isCheckoutUrl, isLoginUrl = param.isLoginUrl;
    var isEducatorSide = (0,useEducatorContext/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var route = router.route;
    var isNotificationsRoute = route === "/notifications";
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var selectedGoalUID = (0,useSelectedGoal/* useSelectedGoalUID */.Xm)();
    var showOnlyLogo = onlyLogo.includes(route);
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    (0,useTimeout/* default */.Z)(function() {
        return setMounted(true);
    }, 0);
    var hideGoalSelectorInHeader = (0,useLayoutOptions/* useFlagSelector */.v)("hideGoalSelector");
    hideGoalSelectorInHeader = hideGoalSelector || hideGoalSelectorInHeader;
    var ref1 = (0,usePlatformInfo/* default */.Z)(), isPlatform = ref1.isPlatform, hideWatchMinForPlatform = ref1.hideWatchMinForPlatform;
    var isProdigyUrl = route === "/prodigy" || route === "/event/UCL" || route === "/event/testseries/aspire" || route === "/event/testseries/[testSeriesKey]";
    var isGoalOnBoardingPreferenceUrl = route === "/goal/[goalSlug]/[goalUID]/preferences";
    var isGTP = (0,useConstants/* default */.Z)((0,constants/* getIsGTPGoal */.vf)(selectedGoalUID));
    var displayNotification = isLoggedIn && mounted && !isNotificationsRoute && !isEducatorSide && !isCheckoutUrl && !isProdigyUrl && !isGoalOnBoardingPreferenceUrl && !isGTP;
    var displayGoalSelector = !isCheckoutUrl && !hideGoalSelectorInHeader && !isEducatorSide && !(isMobile && isLoginUrl) && !isGoalOnBoardingPreferenceUrl;
    var displaySearch = !isPlatform && !hideSearch && !isCheckoutUrl && !isEducatorSide && mounted && !(isMobile && isLoginUrl) && !isGoalOnBoardingPreferenceUrl && !isGTP;
    var ref2 = (0,useCompeteConfig/* default */.Z)(), showCompeteBackground = ref2.showCompeteBackground, state = ref2.state;
    var isCompetePostLaunch = state === Compete_constants/* COMPETE_STATES.POST_LAUNCH */.mu.POST_LAUNCH;
    var handleReferralRedirect = function() {
        analytics/* segment.track */.EX.track(segment/* REFERRAL_TOUCHPOINT_CLICKED */.Dzh, {
            last_primary_source_section: segment/* REFERRAL_TOPBAR_TOUCHPOINT */.Y8G
        });
        var path = isLoggedIn ? "/settings/referral" : "/referral";
        (0,pushRoute/* default */.Z)(path, path);
    };
    var isMWUrl = route === "/login" || route === "/about";
    if (isMobile && isMWUrl) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_HeaderContainer, {
            transparent: transparent,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_HeaderParent, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {
                    isReload: true
                })
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header_HeaderContainer, {
        transparent: transparent,
        hideBoxShadow: isGoalOnBoardingPreferenceUrl,
        $showCompeteBackground: showCompeteBackground,
        $isCompetePostLaunch: isCompetePostLaunch,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Compete_CompeteHeaderStrip, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header_HeaderParent, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoContainer, {
                        children: isCheckoutUrl && !isSubscriptionPricingsUrl(route) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {
                            isClassroom: route.includes("classroom"),
                            disabled: true
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* default */.Z, {
                            isClassroom: route.includes("classroom"),
                            isReload: (isProdigyUrl || isLoginUrl) && isMobile
                        })
                    }),
                    !showOnlyLogo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            displayGoalSelector && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GoalSelectorWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {
                                        orientation: "vertical",
                                        $showCompeteBackground: showCompeteBackground
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalSelector, {})
                                ]
                            }),
                            isLoggedIn && isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileOptions, {
                                excludeOptions: [
                                    "darkMode"
                                ]
                            }),
                            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RightContentWrapper, {
                                children: [
                                    displaySearch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchTab, {}),
                                    displayNotification && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderNotification, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentNudge, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotificationToPwa, {}),
                                    isEducatorSide && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutoDppDismissibleCard, {}),
                                    !isCheckoutUrl && !isLoginUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderReferralWrapper, {
                                                onClick: handleReferralRedirect,
                                                $isLoggedIn: isLoggedIn,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralContainer, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                                        src: "giftHomePage.svg",
                                                        height: "18px",
                                                        width: "18px",
                                                        alt: "avatar"
                                                    })
                                                })
                                            }),
                                            isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderUserContainer, {
                                                $hideWatchMinForPlatform: hideWatchMinForPlatform,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderUser, {
                                                    isEducatorUrl: isEducatorSide,
                                                    isHeaderTransparent: transparent
                                                })
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderLoginAction, {
                                                isJoinForFreeCtaExperiment: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isMobile && !isLoggedIn && !isCheckoutUrl && !isLoginUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderLoginAction, {
                                show: !hideLoginButtonOnMobileUrls.includes(route),
                                isJoinForFreeCtaExperiment: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout_Header_Header = (Header_Header);
Header_Header.propTypes = {
    isCheckoutUrl: (prop_types_default()).bool,
    hideSearch: (prop_types_default()).bool,
    hideGoalSelector: (prop_types_default()).bool,
    transparent: (prop_types_default()).bool,
    isLoginUrl: (prop_types_default()).bool
};
Header_Header.defaultProps = {
    isCheckoutUrl: false,
    hideSearch: false,
    hideGoalSelector: false,
    transparent: false,
    isLoginUrl: false
};


/***/ }),

/***/ 62588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73060);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85780);





var usePendingPaymentStatus = function(goalUID) {
    var isLoggedIn = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getIsLoggedIn */ .M7);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID && isLoggedIn ? "v1/subscriptions/pending_method/status/?goal_uid=".concat(goalUID) : null), pendingPaymentStatus = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        pendingPaymentStatus: pendingPaymentStatus
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePendingPaymentStatus);


/***/ }),

/***/ 99742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H_": function() { return /* binding */ fetchPricings; },
/* harmony export */   "JF": function() { return /* binding */ fetchEMIPlans; },
/* harmony export */   "KW": function() { return /* binding */ purchaseSubscription; },
/* harmony export */   "LT": function() { return /* binding */ fetchPartPaymentStatus; },
/* harmony export */   "MI": function() { return /* binding */ validateReferralAll; },
/* harmony export */   "NQ": function() { return /* binding */ savePurchasedSubscription; },
/* harmony export */   "OG": function() { return /* binding */ fetchBatchGroupSubscriptionInfo; },
/* harmony export */   "UW": function() { return /* binding */ enrollOrderStripe; },
/* harmony export */   "Yl": function() { return /* binding */ fetchOfferList; },
/* harmony export */   "Z6": function() { return /* binding */ stopPartPaymentNudges; },
/* harmony export */   "iL": function() { return /* binding */ activateExternalSubscription; },
/* harmony export */   "j1": function() { return /* binding */ subscribeToExternalApp; },
/* harmony export */   "nS": function() { return /* binding */ fetchCashPaymentStatus; },
/* harmony export */   "qS": function() { return /* binding */ fetchComboFeatures; },
/* harmony export */   "qe": function() { return /* binding */ fetchBundleDetails; },
/* harmony export */   "ws": function() { return /* binding */ fetchOfferFaqs; },
/* harmony export */   "xB": function() { return /* binding */ checkForPaymentStatusJuspay; },
/* harmony export */   "z6": function() { return /* binding */ fetchCheckoutStaticData; }
/* harmony export */ });
/* unused harmony export validateReferral */
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54051);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94336);
/* eslint-disable max-lines */ 


var fetchPricings = function(uid) {
    var isIconic = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, // eslint-disable-next-line no-unused-vars
    isUpgrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, noCache = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return function(dispatch) {
        var timeParam = noCache ? "&time=".concat(Date.now()) : "";
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_PRICINGS */ .Lw.FETCH_PRICINGS,
            endpoint: "v3/subscriptions/?goal=".concat(uid, "&v=3&iconic=").concat(isIconic, "&upgrade=true").concat(timeParam),
            method: "get",
            uid: uid
        });
    };
};
var validateReferralAll = function(referral, goal) {
    var scheme = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2, isIconic = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, // eslint-disable-next-line no-unused-vars
    isUpgrade = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.VALIDATE_REFERRAL */ .Lw.VALIDATE_REFERRAL,
            endpoint: "v2/subscriptions/validate_referral_all_subscriptions/?referral=".concat(encodeURIComponent(referral), "&goal=").concat(goal, "&iconic=").concat(isIconic, "&upgrade=true&scheme=").concat(scheme, "&v=3"),
            method: "get",
            uid: goal,
            referral: referral
        });
    };
};
var validateReferral = function(referral, subscriptionId, goalId) {
    var scheme = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2, isIconic = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, // eslint-disable-next-line no-unused-vars
    isUpgrade = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    return function(dispatch) {
        return dispatch({
            type: subscriptionTypes.VALIDATE_REFERRAL_SUBSCRIPTION,
            endpoint: "v2/subscriptions/validate_referral/?&iconic=".concat(isIconic, "&upgrade=true"),
            method: "post",
            data: {
                referral: referral,
                subscription: subscriptionId,
                scheme: scheme
            },
            uid: goalId,
            referral: referral
        });
    };
};
var fetchEMIPlans = function() {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_EMI_PLANS */ .Lw.FETCH_EMI_PLANS,
            endpoint: "v1/payments/emi_plans/?version=2",
            method: "get"
        });
    };
};
var fetchPartPaymentStatus = function(goalUid) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_PART_PAYMENT_STATUS */ .Lw.FETCH_PART_PAYMENT_STATUS,
            key: goalUid,
            endpoint: "v1/subscriptions/pay_in_parts_subscription_details?goal_uid=".concat(goalUid),
            method: "get"
        });
    };
};
var enrollOrderStripe = function(subscriptionId, creditsApplied, phoneNumber, referralCode, paymentMethod, paymentMethodType, emiData) {
    var gateway = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 2, isPartial = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false, parts = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : 0, subscription = arguments.length > 10 ? arguments[10] : void 0, cancelUrl = arguments.length > 11 ? arguments[11] : void 0, isCombo = arguments.length > 12 ? arguments[12] : void 0, comboId = arguments.length > 13 ? arguments[13] : void 0, comboName = arguments.length > 14 ? arguments[14] : void 0, referralError = arguments.length > 15 ? arguments[15] : void 0, selectedMethod = arguments.length > 16 ? arguments[16] : void 0, purchaseType = arguments.length > 17 ? arguments[17] : void 0, cashBank = arguments.length > 18 ? arguments[18] : void 0, cardType = arguments.length > 19 ? arguments[19] : void 0, paramsForReturnUrl = arguments.length > 20 ? arguments[20] : void 0;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.ENROLL_ORDER */ .Lw.ENROLL_ORDER,
            endpoint: "v1/subscriptions/order/".concat(subscriptionId, "/"),
            method: "post",
            data: {
                renew: false,
                referral: referralCode || null,
                phone: phoneNumber,
                scheme: 2,
                use_credits: creditsApplied,
                payment_method: paymentMethod,
                payment_method_type: paymentMethodType,
                emi_data: emiData,
                gateway: gateway,
                upgrade: true,
                is_partial: isPartial,
                no_of_installments: parts,
                params_for_return_url: paramsForReturnUrl,
                return_url: "https://unacademy.com/payment/response?session_id={CHECKOUT_SESSION_ID}",
                cancel_url: cancelUrl,
                bank_name: cashBank
            },
            isCashPayment: gateway === 8
        });
    };
};
var purchaseSubscription = function(orderId) {
    var gateway = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return function(dispatch) {
        var payload = {
            order_id: orderId,
            renew: false,
            gateway: gateway
        };
        if (gateway === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .STRIPE_GATEWAY_ID */ .CN) {
            payload.session_id = orderId;
            payload.order_id = undefined;
        }
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.PURCHASE_SUBSCRIPTION */ .Lw.PURCHASE_SUBSCRIPTION,
            endpoint: "v1/subscriptions/purchase/",
            method: "post",
            data: payload
        });
    };
};
var checkForPaymentStatusJuspay = function(orderId) {
    var gateway = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "juspay", isStripe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.PAYMENT_STATUS_JUSPAY */ .Lw.PAYMENT_STATUS_JUSPAY,
            endpoint: "v1/payments/".concat(gateway, "/payment_status/?").concat(isStripe ? "session_id" : "order_id", "=").concat(orderId),
            method: "get"
        });
    };
};
var savePurchasedSubscription = function(goalOrComboId, orderId, purchasedSubscription) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.SAVE_PURCHASED_SUBSCRIPTION */ .Lw.SAVE_PURCHASED_SUBSCRIPTION,
            goalOrComboId: goalOrComboId,
            orderId: orderId,
            purchasedSubscription: purchasedSubscription
        });
    };
};
var subscribeToExternalApp = function(url, goalUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.ACTIVATE_EXTERNAL_APP */ .Lw.ACTIVATE_EXTERNAL_APP,
            endpoint: url,
            key: goalUID,
            method: "post"
        });
    };
};
var stopPartPaymentNudges = function(subscriptionId) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.STOP_PART_PAYMENT_NUDGE */ .Lw.STOP_PART_PAYMENT_NUDGE,
            endpoint: "v1/users/visit_screen/part_payment_refund_screen/".concat(subscriptionId, "/"),
            method: "post"
        });
    };
};
var activateExternalSubscription = function(code, state, app_name) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.SYNC_CODE_CHEF */ .Lw.SYNC_CODE_CHEF,
            endpoint: "v1/subscriptions/activate_external_subscription",
            data: {
                code: code,
                state: state,
                app_name: app_name
            },
            method: "post"
        });
    };
};
var fetchBundleDetails = function(uid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_BUNDLE_DETAILS */ .Lw.FETCH_BUNDLE_DETAILS,
        uid: uid,
        method: "get",
        endpoint: "v1/subscriptions/bundle/".concat(uid, "/details")
    };
};
var fetchOfferList = function(uid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_OFFER_LIST */ .Lw.FETCH_OFFER_LIST,
        uid: uid,
        endpoint: "v2/subscriptions/offer/list/?goal_uid=".concat(uid),
        method: "get"
    };
};
var fetchOfferFaqs = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_OFFER_FAQS */ .Lw.FETCH_OFFER_FAQS,
        endpoint: "subscription-faqs/Offers-FAQ",
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
    };
};
var fetchCheckoutStaticData = function(key) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_SUBSCRIPTION_STATIC_DATA */ .Lw.FETCH_SUBSCRIPTION_STATIC_DATA,
            endpoint: "checkout-static-data/".concat(key),
            key: key,
            method: "get",
            hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
        });
    };
};
var fetchComboFeatures = function() {
    var goalUIDs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var goal_uid_string = goalUIDs.map(function(goal) {
        return "goalUID_in=".concat(goal, "&");
    }).join("");
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_COMBO_FEATURE_POINTS */ .Lw.FETCH_COMBO_FEATURE_POINTS,
        endpoint: "api/combo-goal-properties?".concat(goal_uid_string),
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .HOST_TYPE.CMS */ .Bk.CMS
    };
};
var fetchCashPaymentStatus = function(goalUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_CASH_PAYMENT_DATA */ .Lw.FETCH_CASH_PAYMENT_DATA,
        endpoint: "v1/subscriptions/cash_payment_subscription_details/?goal_uid=".concat(goalUID),
        method: "get"
    };
};
var fetchBatchGroupSubscriptionInfo = function(orderId, contentTypeId, objectId) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionTypes.FETCH_BATCH_GROUP_SUBSCRIPTION_INFO */ .Lw.FETCH_BATCH_GROUP_SUBSCRIPTION_INFO,
        endpoint: "v1/user/confirm_payment/?content_type_id=".concat(contentTypeId, "&object_id=").concat(objectId, "&order_id=").concat(orderId),
        method: "get"
    };
};


/***/ }),

/***/ 5861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bn": function() { return /* binding */ addReply; },
/* harmony export */   "Fq": function() { return /* binding */ fetchCourseData; },
/* harmony export */   "Gy": function() { return /* binding */ fetchMoreCourses; },
/* harmony export */   "IV": function() { return /* binding */ fetchPreviousEnrolledCourses; },
/* harmony export */   "Ir": function() { return /* binding */ addComment; },
/* harmony export */   "Nu": function() { return /* binding */ fetchCompletedCourses; },
/* harmony export */   "Ut": function() { return /* binding */ toggleBookmarkItem; },
/* harmony export */   "Ux": function() { return /* binding */ adjustCommentNumber; },
/* harmony export */   "VO": function() { return /* binding */ toggleLike; },
/* harmony export */   "Vm": function() { return /* binding */ fetchCourseUpdates; },
/* harmony export */   "Xy": function() { return /* binding */ addCourseToPlanner; },
/* harmony export */   "Y7": function() { return /* binding */ fetchCourseReviews; },
/* harmony export */   "_7": function() { return /* binding */ fetchLessonList; },
/* harmony export */   "b8": function() { return /* binding */ fetchLibrary; },
/* harmony export */   "eL": function() { return /* binding */ toggleEnrolledCourse; },
/* harmony export */   "fB": function() { return /* binding */ removeCourseFromPlanner; },
/* harmony export */   "g2": function() { return /* binding */ fetchEnrolledCoursesFilters; },
/* harmony export */   "hP": function() { return /* binding */ checkCoursesEnrollStatus; },
/* harmony export */   "hU": function() { return /* binding */ fetchTopologyEnrolledCourses; },
/* harmony export */   "jl": function() { return /* binding */ updateFilters; },
/* harmony export */   "kM": function() { return /* binding */ getSubscriptionOnboardingRecommendedCourses; },
/* harmony export */   "lw": function() { return /* binding */ fetchRecommendedCourses; },
/* harmony export */   "nQ": function() { return /* binding */ fetchEnrolledCourses; },
/* harmony export */   "nl": function() { return /* binding */ submitCourseReview; },
/* harmony export */   "og": function() { return /* binding */ toggleCommentLike; },
/* harmony export */   "pA": function() { return /* binding */ fetchUpdateFilters; },
/* harmony export */   "ri": function() { return /* binding */ getPlannerSchedule; },
/* harmony export */   "tH": function() { return /* binding */ fetchComments; },
/* harmony export */   "vn": function() { return /* binding */ fetchMoreCoursesFilters; },
/* harmony export */   "wn": function() { return /* binding */ fetchFreeContinueLearningCourses; }
/* harmony export */ });
/* unused harmony exports fetchFreeGoalCourses, fetchWatchHistory, toggleSaved, getFreeLessonDetails, getFreeLessonListFromLessonUID, fetchRelevantCourses, fetchFreeCoursesOfAGoal */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var normalizr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82677);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72894);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38037);


/* eslint-disable max-lines */ 




var getFreeGoalCourses = function(goalUid, resetWithoutEmpty) {
    return function(next) {
        return {
            type: courseTypes.FETCH_FREE_GOAL_COURSES,
            endpoint: next,
            method: "get",
            key: goalUid,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchFreeGoalCourses = function(goalUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v1/topology/users/".concat(goalUid, "/courses/?&limit=25"), getFreeGoalCourses(goalUid, resetWithoutEmpty), "freeGoalCourses", goalUid, resetWithoutEmpty)(nextPage);
};
var fetchCourseData = function(courseUid) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_COURSE_INFO */ .Dl.FETCH_COURSE_INFO,
            endpoint: "v1/collection/".concat(courseUid, "/"),
            method: "get",
            courseUid: courseUid,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({
                course: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .courseSchema */ .Ih
            }),
            entityType: "course",
            // this processData will be called in the createApiMiddleWare with the above courseSchema
            processData: function(data) {
                var tmp = data.languages, newLanguages = tmp === void 0 ? [] : tmp;
                var voiceLanguages = newLanguages.filter(function(lang) {
                    return lang.language_type === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .languageTypes.SPOKEN */ .c4.SPOKEN;
                });
                var contentSlideLanguages = newLanguages.filter(function(lang) {
                    return lang.language_type === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .languageTypes.CONTENT_SLIDE_LANGUAGE */ .c4.CONTENT_SLIDE_LANGUAGE;
                });
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data, data.programme), {
                    voiceLanguages: voiceLanguages,
                    contentSlideLanguages: contentSlideLanguages
                });
            }
        });
    };
};
var getFreeContinueLearningCourses = function(resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_FREE_CONTINUE_LEARNING */ .Dl.FETCH_FREE_CONTINUE_LEARNING,
            endpoint: next,
            method: "get",
            key: "continue_learning",
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchFreeContinueLearningCourses = function(nextPage) {
    var resetWithoutEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/user/me/continue_watching/", getFreeContinueLearningCourses(resetWithoutEmpty), "continueLearning", "continue_learning", resetWithoutEmpty)(nextPage);
};
var getLibrary = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_MY_LIBRARY */ .Dl.FETCH_MY_LIBRARY,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: key === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .myLibrarySourceType.COURSE */ .sA.COURSE ? "course" : "item"
        };
    };
};
var fetchLibrary = function(key, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/users/bookmark/?limit=10&target_type=".concat(key), getLibrary(key, resetWithoutEmpty), "library", key, resetWithoutEmpty)(nextPage);
};
var getWatchHistory = function(username, resetWithoutEmpty) {
    return function(next) {
        return {
            type: itemTypes.FETCH_WATCH_HISTORY,
            endpoint: next,
            method: "get",
            key: username,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "item"
        };
    };
};
var fetchWatchHistory = function(username, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v1/post/watch_history/?limit=10", getWatchHistory(username, resetWithoutEmpty), "watchHistory", username, resetWithoutEmpty)(nextPage);
};
var toggleSaved = function(courseUid, save) {
    return {
        type: courseTypes.TOGGLE_COURSE_SAVED,
        courseUid: courseUid,
        save: save
    };
};
var fetchEnrolledCoursesFilters = function(goalId) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_ENROLLED_COURSES_FILTERS */ .Dl.FETCH_ENROLLED_COURSES_FILTERS,
            endpoint: "v1/uplus/subscription/user_enroll_filters/?goal_uid=".concat(goalId),
            method: "get"
        });
    };
};
var getEnrolledCourses = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_ENROLLED_COURSES */ .Dl.FETCH_ENROLLED_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchEnrolledCourses = function(goalUid) {
    var filterObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, nextPage = arguments.length > 2 ? arguments[2] : void 0, resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var state = filterObj.state, language = filterObj.language, educator = filterObj.educator, topic = filterObj.topic;
    var key = "".concat(goalUid, "-enrolled-").concat(state, "-").concat(language, "-").concat(educator, "-").concat(topic);
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/uplus/subscription/enrolled_courses/?goal_uid=".concat(goalUid, "&v=2&limit=12&test_series=0&filters=").concat(encodeURIComponent(JSON.stringify({
        state: state,
        language: language === "all" || !language ? [] : [
            language
        ],
        educator: educator === "all" || !educator ? [] : [
            educator
        ],
        topic: topic === "all" || !topic ? [] : [
            topic
        ]
    }))), getEnrolledCourses(key, resetWithoutEmpty), "enrolledCourses", key, resetWithoutEmpty)(nextPage);
};
var toggleEnrolledCourse = function(courseUID, enroll) {
    var send_email = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, eventKey = arguments.length > 3 ? arguments[3] : void 0;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.TOGGLE_COURSE_ENROLLED */ .Dl.TOGGLE_COURSE_ENROLLED,
            endpoint: "v2/uplus/programmes/".concat(courseUID, "/save/"),
            method: "post",
            courseUID: courseUID,
            enroll: enroll,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({}),
            data: {
                enroll: enroll,
                send_email: send_email,
                prodigy_key: eventKey
            }
        });
    };
};
var addCourseToPlanner = function(courseUID, daily_item_schedule_at) {
    var include_completed_lessons = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, days = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ], start_date = arguments.length > 4 ? arguments[4] : void 0;
    return function(dispatch) {
        var today = new Date();
        today.setHours(0, 0, 0);
        var startDateInstance = start_date ? new Date(start_date) : new Date();
        startDateInstance.setHours(0, 0, 0);
        startDateInstance.setHours(0, 0, 0);
        var startDate = startDateInstance.getTime();
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.ADD_COMPLETED_COURSE_TO_PLANNER */ .Dl.ADD_COMPLETED_COURSE_TO_PLANNER,
            endpoint: "v1/planner/courses/".concat(courseUID, "/"),
            method: "post",
            courseUID: courseUID,
            plannerSchedule: {
                daily_item_schedule_at: daily_item_schedule_at,
                start_date: startDate,
                is_scheduled: true,
                include_completed_lessons: include_completed_lessons,
                week_days: days
            },
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({}),
            data: {
                daily_item_schedule_at: daily_item_schedule_at,
                include_completed_lessons: include_completed_lessons,
                start_date: startDate,
                days: days
            }
        });
    };
};
var removeCourseFromPlanner = function(courseUID) {
    return function(dispatch) {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.REMOVE_COURSE_FROM_PLANNER */ .Dl.REMOVE_COURSE_FROM_PLANNER,
            endpoint: "v1/planner/courses/".concat(courseUID, "/"),
            method: "delete",
            courseUID: courseUID,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({})
        });
    };
};
var getPlannerSchedule = function(courseUID) {
    return function(dispatch) {
        dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.GET_PLANNER_SCHEDULE */ .Dl.GET_PLANNER_SCHEDULE,
            endpoint: "v1/uplus/programmes/".concat(courseUID, "/details/?v=2"),
            method: "get",
            courseUID: courseUID,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({})
        });
    };
};
var getFreeLessonDetails = function(lessonUID) {
    return function(dispatch) {
        return dispatch({
            type: itemTypes.FETCH_FREE_LESSON_INFO,
            endpoint: "v1/post/".concat(lessonUID, "/"),
            method: "get",
            schema: new schema.Object({
                item: itemSchema
            }),
            entityType: "item",
            uid: lessonUID
        });
    };
};
var getFreeLessonListFromLessonUID = function(lessonUID) {
    return function(dispatch) {
        return dispatch({
            type: itemTypes.FETCH_FREE_LESSON_LIST,
            endpoint: "v2/post/".concat(lessonUID, "/related_items/"),
            method: "get",
            directPaginatedEntity: true,
            schema: paginatorListSchema,
            entityType: "item",
            processData: function(data) {
                var newData = data;
                newData.results = newData.results.map(function(resultItem) {
                    return _object_spread_props(_object_spread({}, resultItem), {
                        properties: _object_spread_props(_object_spread({}, resultItem.value), {
                            is_bookmarked: resultItem.is_bookmarked
                        })
                    });
                });
                return newData;
            },
            uid: lessonUID
        });
    };
};
var toggleBookmarkItem = function(uid, type, toBookmark) {
    return function(dispatch) {
        var url = "v1/users/bookmark/";
        if (!toBookmark) url = "v1/users/bookmark/delete/";
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .itemTypes.BOOKMARK_ITEM */ .cs.BOOKMARK_ITEM,
            endpoint: url,
            method: "post",
            data: {
                target: uid,
                target_type: type
            },
            uid: uid,
            isBookmarked: toBookmark
        });
    };
};
var getLessonList = function(uid, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_FREE_COURSE_ITEM */ .Dl.FETCH_FREE_COURSE_ITEM,
            endpoint: next,
            method: "get",
            key: uid,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "item",
            processData: function(data) {
                var newData = data;
                newData.results = data.results.map(function(resultItem) {
                    var resultData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, resultItem.value.live_class, resultItem.value, resultItem);
                    resultData.live_class2 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, resultItem.value.live_class);
                    delete resultData.live_class;
                    delete resultData.collection;
                    delete resultData.value;
                    return resultData;
                });
                return newData;
            }
        };
    };
};
var fetchLessonList = function(uid) {
    var getExtraInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, nextPage = arguments.length > 2 ? arguments[2] : void 0, resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v2/collection/".concat(uid, "/items/?limit=600").concat(getExtraInfo ? "&extra_info=True" : ""), getLessonList(uid, resetWithoutEmpty), "courseItems", uid, resetWithoutEmpty)(nextPage);
};
var fetchRelevantCourses = function(courseUID) {
    return function(dispatch) {
        return dispatch({
            type: courseTypes.FETCH_RELEVANT_COURSES,
            endpoint: "v1/collection/".concat(courseUID, "/relevant_courses/"),
            method: "get",
            courseUID: courseUID,
            schema: new schema.Array({
                course: courseSchema
            }),
            entityType: "course",
            processData: function(data) {
                return data.slice(0, 4);
            }
        });
    };
};
var getCourseReviews = function(courseUID, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_COURSE_REVIEWS */ .Dl.FETCH_COURSE_REVIEWS,
            endpoint: next,
            method: "get",
            key: courseUID,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({}),
            processData: function(data) {
                var newData = data;
                newData.results = newData.results.map(function(resultItem) {
                    return {
                        review: resultItem.review,
                        rating: resultItem.rating,
                        createdAt: resultItem.created_at,
                        username: resultItem.user.username,
                        name: "".concat(resultItem.user.first_name, " ").concat(resultItem.user.last_name),
                        avatar: resultItem.user.avatar
                    };
                });
                return newData;
            }
        };
    };
};
var fetchCourseReviews = function(courseUID, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/collection/".concat(courseUID, "/reviews/?limit=3"), getCourseReviews(courseUID, resetWithoutEmpty), "courseReviews", courseUID, resetWithoutEmpty)(nextPage);
};
var submitCourseReview = function(review, rating, courseUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.SUBMIT_REVIEW */ .Dl.SUBMIT_REVIEW,
            endpoint: "v1/collection/".concat(courseUID, "/review/"),
            method: "put",
            data: {
                review: review,
                rating: rating
            }
        });
    };
};
var getFreeCoursesOfAGoal = function(goalUid, resetWithoutEmpty) {
    return function(next) {
        return {
            type: courseTypes.FETCH_FREE_COURSES_OF_A_GOAL,
            endpoint: next,
            method: "get",
            key: goalUid,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "feedrow",
            processData: function(data) {
                var newData = data;
                newData.results = newData.results.map(function(resultItem) {
                    return _object_spread_props(_object_spread({}, resultItem), {
                        key: "".concat(goalUid, "_free")
                    });
                });
                return newData;
            }
        };
    };
};
var fetchFreeCoursesOfAGoal = function(goalUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v1/feeds/user/home_v2/?goal_uid=".concat(goalUid), getFreeCoursesOfAGoal(goalUid, resetWithoutEmpty), "freeCoursesFeed", goalUid, resetWithoutEmpty)(nextPage);
};
var getSubscriptionOnboardingRecommendedCourses = function(goalUid, goalSlug, source) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_ONBOARDING_RECOMMENDED_COURSES */ .Dl.FETCH_ONBOARDING_RECOMMENDED_COURSES,
            endpoint: "v1/uplus/subscription/course-card/?goal_uid=".concat(goalUid, "&source=").concat(source),
            method: "get",
            goalUid: goalUid,
            schema: {
                data: [
                    {
                        course: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .courseSchema */ .Ih
                    }
                ]
            },
            processData: function(data) {
                var newData = data;
                newData.data = newData.data.map(function(dataItem) {
                    return {
                        course: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, dataItem), {
                            goal: {
                                uid: goalUid,
                                goalSlug: goalSlug
                            }
                        })
                    };
                });
                return newData;
            }
        });
    };
};
var getPreviousEnrolledCourses = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_PREVIOUS_ENROLLED_COURSES */ .Dl.FETCH_PREVIOUS_ENROLLED_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchPreviousEnrolledCourses = function(nextPage) {
    var resetWithoutEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/uplus/live_programmes_v3/enrolled/?limit=12&send_special_test_series=0&subscriptions=0&special=0", getPreviousEnrolledCourses("prevEnrolledCourses", resetWithoutEmpty), "prevEnrolledCourses", "prevEnrolledCourses", resetWithoutEmpty)(nextPage);
};
var getCourseUpdates = function(channelId, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .plusCoursesTypes.FETCH_COURSE_UPDATES */ .oj.FETCH_COURSE_UPDATES,
            endpoint: next,
            method: "get",
            key: channelId,
            resetWithoutEmpty: resetWithoutEmpty
        };
    };
};
var fetchCourseUpdates = function(channelId, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isBatch = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, filters = arguments.length > 4 ? arguments[4] : void 0;
    var url = "v2/channel/".concat(channelId, "/stories/?limit=7");
    if (isBatch) {
        url = "v2/channel/batch/".concat(channelId, "/batch_stories/?limit=7");
    }
    if (filters) url += "&filters=".concat(encodeURIComponent(JSON.stringify(filters)));
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(url, getCourseUpdates(channelId, resetWithoutEmpty), "courseUpdates", channelId, resetWithoutEmpty)(nextPage);
};
var getComments = function(id, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_COMMENTS */ .Dl.FETCH_COMMENTS,
            endpoint: next,
            method: "get",
            key: id,
            resetWithoutEmpty: resetWithoutEmpty
        };
    };
};
var fetchComments = function(id, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/story/".concat(id, "/comments/?limit=10"), getComments(id, resetWithoutEmpty), "courseUpdateComments", id, resetWithoutEmpty)(nextPage);
};
var toggleLike = function(channelId, id, isLiked) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.TOGGLE_LIKE */ .Dl.TOGGLE_LIKE,
            endpoint: isLiked ? "v1/story/".concat(id, "/unreact/") : "v1/story/".concat(id, "/react/"),
            method: "post",
            key: channelId,
            id: id,
            isLiked: isLiked,
            data: {
                type: isLiked ? 0 : 1
            }
        });
    };
};
var toggleCommentLike = function(key, id, isLiked) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.TOGGLE_COMMENT_LIKE */ .Dl.TOGGLE_COMMENT_LIKE,
            endpoint: isLiked ? "v1/story/comment/".concat(id, "/delete_upvote/") : "v1/story/comment/".concat(id, "/upvote/"),
            method: "post",
            key: key,
            id: id,
            isLiked: isLiked,
            data: {
                type: isLiked ? 0 : 1
            }
        });
    };
};
var addComment = function(id, text) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.ADD_COMMENT */ .Dl.ADD_COMMENT,
            endpoint: "v1/story/".concat(id, "/comment/"),
            method: "post",
            key: id,
            id: id,
            data: {
                text: text
            }
        });
    };
};
var addReply = function(key, id, text) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.ADD_REPLY */ .Dl.ADD_REPLY,
            endpoint: "v1/story/comment/".concat(id, "/comment/"),
            method: "post",
            key: key,
            id: id,
            data: {
                text: text
            }
        });
    };
};
var adjustCommentNumber = function(channelId, id) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.INCREASE_COMMENT */ .Dl.INCREASE_COMMENT,
        key: channelId,
        id: id
    };
};
var fetchUpdateFilters = function(channelId) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_FILTERS */ .Dl.FETCH_FILTERS,
            endpoint: "v1/channel/".concat(channelId, "/filters/"),
            method: "get"
        });
    };
};
var updateFilters = function(filter, kind, reset) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.UPDATE_FILTER */ .Dl.UPDATE_FILTER,
        filter: filter,
        reset: reset,
        kind: kind
    };
};
var fetchMoreCoursesFilters = function(goalUID) {
    return function(dispatch) {
        var url = "v1/uplus/syllabus/course_filters/?goal_uid=".concat(goalUID);
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_MORE_COURSES_FILTERS */ .Dl.FETCH_MORE_COURSES_FILTERS,
            endpoint: url,
            method: "get",
            goalUID: goalUID
        });
    };
};
var getMoreCourses = function(param) {
    var key = param.key, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty;
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_MORE_COURSES */ .Dl.FETCH_MORE_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course",
            processData: function processData(data) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: (ref = data.results) === null || ref === void 0 ? void 0 : ref.map(function(course) {
                        return course.programme || course;
                    })
                });
            }
        };
    };
};
var fetchMoreCourses = function(param) {
    var topicUid = param.topicUid, _nextPage = param.nextPage, nextPage = _nextPage === void 0 ? false : _nextPage, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty, _filterParams = param.filterParams, filterParams = _filterParams === void 0 ? "" : _filterParams, key = param.key;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/uplus/syllabus/more_courses/?topology_uid=".concat(topicUid, "&limit=9").concat(filterParams), getMoreCourses({
        key: key,
        resetWithoutEmpty: resetWithoutEmpty
    }), "moreCourses", key, resetWithoutEmpty)(nextPage);
};
var getCompletedCourses = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_COMPLETED_COURSES */ .Dl.FETCH_COMPLETED_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course",
            processData: function processData(data) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: (ref = data.results) === null || ref === void 0 ? void 0 : ref.map(function(course) {
                        return course.programme || course;
                    })
                });
            }
        };
    };
};
var fetchCompletedCourses = function(topicUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, params = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/uplus/syllabus/completed_courses/?topology_uid=".concat(topicUid, "&limit=6").concat(params), getCompletedCourses(topicUid, resetWithoutEmpty), "completedCourses", topicUid, resetWithoutEmpty)(nextPage);
};
var getRecommendedCourses = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_RECOMMENDED_COURSES */ .Dl.FETCH_RECOMMENDED_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course",
            processData: function processData(data) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: (ref = data.results) === null || ref === void 0 ? void 0 : ref.map(function(course) {
                        return course.programme || course;
                    })
                });
            }
        };
    };
};
var fetchRecommendedCourses = function(topicUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, params = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/uplus/syllabus/courses_for_you/?topology_uid=".concat(topicUid).concat(params), getRecommendedCourses(topicUid, resetWithoutEmpty), "recommendedCourses", topicUid, resetWithoutEmpty)(nextPage);
};
var getTopologyEnrolledCourses = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.FETCH_ENROLLED_COURSES */ .Dl.FETCH_ENROLLED_COURSES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course",
            processData: function processData(data) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: (ref = data.results) === null || ref === void 0 ? void 0 : ref.map(function(course) {
                        return course.programme || course;
                    })
                });
            }
        };
    };
};
var fetchTopologyEnrolledCourses = function(topicUid, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, params = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", limit = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 3;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/uplus/syllabus/enrolled_courses/?topology_uid=".concat(topicUid, "&limit=").concat(limit).concat(params), getTopologyEnrolledCourses(topicUid, resetWithoutEmpty), "enrolledCourses", topicUid, resetWithoutEmpty)(nextPage);
};
var checkCoursesEnrollStatus = function(courses) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .courseTypes.CHECK_COURSE_ENROLL */ .Dl.CHECK_COURSE_ENROLL,
            method: "get",
            endpoint: "v1/uplus/enroll/status?programme_uids=".concat(courses.toString())
        });
    };
};


/***/ }),

/***/ 94336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ playerTypes; },
/* harmony export */   "AM": function() { return /* binding */ oneToOneLivementoring; },
/* harmony export */   "Bl": function() { return /* binding */ plannerTypes; },
/* harmony export */   "CK": function() { return /* binding */ authTypes; },
/* harmony export */   "CV": function() { return /* binding */ notesTypes; },
/* harmony export */   "Cs": function() { return /* binding */ topologyTypes; },
/* harmony export */   "De": function() { return /* binding */ questionTypes; },
/* harmony export */   "Dl": function() { return /* binding */ courseTypes; },
/* harmony export */   "EH": function() { return /* binding */ classTypes; },
/* harmony export */   "EJ": function() { return /* binding */ iconicOnboardingTypes; },
/* harmony export */   "F": function() { return /* binding */ preSubscribedGoal; },
/* harmony export */   "Gs": function() { return /* binding */ createQuizTypes; },
/* harmony export */   "IQ": function() { return /* binding */ quizTypes; },
/* harmony export */   "JP": function() { return /* binding */ doubtsOnWeb2; },
/* harmony export */   "Kx": function() { return /* binding */ classroomTypes; },
/* harmony export */   "Lw": function() { return /* binding */ subscriptionTypes; },
/* harmony export */   "O2": function() { return /* binding */ salesTypes; },
/* harmony export */   "RJ": function() { return /* binding */ learnerDoubtsAndSolutionsTypes; },
/* harmony export */   "TN": function() { return /* binding */ combatTypes; },
/* harmony export */   "TR": function() { return /* binding */ practiceSessionTypes; },
/* harmony export */   "Wm": function() { return /* binding */ educatorLiveMentoringTypes; },
/* harmony export */   "Z9": function() { return /* binding */ careersTypes; },
/* harmony export */   "ZQ": function() { return /* binding */ freePracticeSessionTypes; },
/* harmony export */   "ZV": function() { return /* binding */ batchGroupTypes; },
/* harmony export */   "cO": function() { return /* binding */ savedTypes; },
/* harmony export */   "co": function() { return /* binding */ analytics; },
/* harmony export */   "cs": function() { return /* binding */ itemTypes; },
/* harmony export */   "ff": function() { return /* binding */ educatorOnboardingTypes; },
/* harmony export */   "gC": function() { return /* binding */ helpCenterTypes; },
/* harmony export */   "il": function() { return /* binding */ evaluateQuizTypes; },
/* harmony export */   "kg": function() { return /* binding */ educatorTypes; },
/* harmony export */   "kx": function() { return /* binding */ driveTypes; },
/* harmony export */   "mv": function() { return /* binding */ notificationTypes; },
/* harmony export */   "oj": function() { return /* binding */ plusCoursesTypes; },
/* harmony export */   "qg": function() { return /* binding */ searchTypes; },
/* harmony export */   "s4": function() { return /* binding */ moderatorTypes; },
/* harmony export */   "tu": function() { return /* binding */ doubtTypes; },
/* harmony export */   "vH": function() { return /* binding */ rankPredictor; },
/* harmony export */   "vK": function() { return /* binding */ otherTypes; },
/* harmony export */   "xP": function() { return /* binding */ summitTypes; },
/* harmony export */   "yt": function() { return /* binding */ batchTypes; },
/* harmony export */   "z1": function() { return /* binding */ templatesTypes; }
/* harmony export */ });
/* unused harmony exports specialClassTypes, groupTypes */
/* eslint-disable max-lines */ var authTypes = {
    AUTHENTICATE: "AUTHENTICATE",
    DEAUTHENTICATE: "DEAUTHENTICATE",
    ME: "ME",
    FOLLOWED_GOALS: "FOLLOWED_GOALS",
    FETCH_COUNTRY_STATES: "FETCH_COUNTRY_STATES",
    FETCH_STATES: "FETCH_STATES",
    FETCH_CREDENTIALS: "FETCH_CREDENTIALS",
    FETCH_BIO_RECOMMENDATION: "FETCH_BIO_RECOMMENDATION",
    SELECTED_GOAL: "SELECTED_GOAL",
    RESEND_OTP: "RESEND_OTP",
    LOGIN: "LOGIN",
    RESET_OTP_RESPONSE: "RESET_OTP_RESPONSE",
    RESET_VERIFY_OTP_RESPONSE: "RESET_VERIFY_OTP_RESPONSE",
    UPDATE_USER: "UPDATE_USER",
    UPDATE_CREDENTIALS: "UPDATE_CREDENTIALS",
    UNLOCK_FREE_PLAN: "UNLOCK_FREE_PLAN",
    RESET_NETWORK_CALLS_ERROR: "RESET_NETWORK_CALLS_ERROR",
    SEND_MAIL_OTP: "SEND_MAIL_OTP",
    VERIFY_MAIL_OTP: "VERIFY_MAIL_OTP",
    SEND_MOBILE_OTP: "SEND_MOBILE_OTP",
    VERIFY_MOBILE_OTP: "VERIFY_MOBILE_OTP",
    FETCH_FEEDBACK_OPTIONS: "FETCH_FEEDBACK_OPTIONS",
    SUBMIT_FEEDBACK: "SUBMIT_FEEDBACK",
    LATEST_STREAK: "LATEST_STREAK",
    UPDATE_AVATAR: "UPDATE_AVATAR",
    FETCH_RENEWAL_TOUCHPOINT_DATA: "FETCH_RENEWAL_TOUCHPOINT_DATA",
    FETCH_SETTINGS_MANAGE_UPDATES: "FETCH_SETTINGS_MANAGE_UPDATES",
    FETCH_REFERRAL_DETAILS: "FETCH_REFERRAL_DETAILS",
    FETCH_REFERRAL_LIST: "FETCH_REFERRAL_LIST",
    CHANGE_MANAGE_UPDATE_PREFERENCES: "CHANGE_MANAGE_UPDATE_PREFERENCES",
    FETCH_INTERCOM_TOKEN: "FETCH_INTERCOM_TOKEN",
    PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS: "PRE_PAYMENT_PLUS_SUBSCRIPTION_UIDS",
    GENERATE_CUSTOM_CODE: "GENERATE_CUSTOM_CODE",
    GET_CUSTOM_CODE_DATA: "GET_CUSTOM_CODE_DATA",
    SET_LOCAL_PHONE: "SET_LOCAL_PHONE",
    SET_LOCAL_EMAIL_NAME: "SET_LOCAL_EMAIL_NAME",
    FETCH_PURCHASED_ITEMS: "FETCH_PURCHASED_ITEMS",
    FETCH_STORE_MY_PURCHASE_DETAILS: "FETCH_STORE_MY_PURCHASE_DETAILS"
};
var careersTypes = {
    GET_JOB_DETAILS: "GET_JOB_DETAILS",
    GET_CMS_DATA: "GET_CMS_DATA"
};
var courseTypes = {
    UPDATE_COURSES: "UPDATE_COURSES",
    UPDATE_FEEDROWS: "UPDATE_FEEDROWS",
    FETCH_FREE_COURSES: "FETCH_FREE_COURSES",
    FETCH_FREE_GOAL_COURSES: "FETCH_FREE_GOAL_COURSES",
    FETCH_COURSE_INFO: "FETCH_COURSE_INFO",
    FETCH_SPECIAL_CLASSES: "FETCH_SPECIAL_CLASSES",
    FETCH_SPECIAL_CLASSES_TYPE: "FETCH_SPECIAL_CLASSES_TYPE",
    FETCH_FREE_CONTINUE_LEARNING: "FETCH_CONTINUE_LEARNING",
    FETCH_MY_LIBRARY: "FETCH_MY_LIBRARY",
    TOGGLE_COURSE_SAVED: "TOGGLE_COURSE_SAVED",
    FETCH_ENROLLED_COURSES: "FETCH_ENROLLED_COURSES",
    FETCH_RECOMMENDED_COURSES: "FETCH_RECOMMENDED_COURSES",
    FETCH_COMPLETED_COURSES: "FETCH_COMPLETED_COURSES",
    FETCH_MORE_COURSES: "FETCH_MORE_COURSES",
    FETCH_MORE_COURSES_FILTERS: "FETCH_MORE_COURSES_FILTERS",
    FETCH_ENROLLED_COURSES_FILTERS: "FETCH_ENROLLED_COURSES_FILTERS",
    FETCH_SEE_ALL_FEED: "FETCH_SEE_ALL_FEED",
    TOGGLE_COURSE_ENROLLED: "TOGGLE_COURSE_ENROLLED",
    FETCH_FREE_COURSE_ITEM: "FETCH_FREE_COURSE_ITEM",
    FETCH_RELEVANT_COURSES: "FETCH_RELEVANT_COURSES",
    FETCH_COURSE_REVIEWS: "FETCH_COURSE_REVIEWS",
    SUBMIT_REVIEW: "SUBMIT_REVIEW",
    FETCH_FREE_COURSES_OF_A_GOAL: "FETCH_FREE_COURSES_OF_A_GOAL",
    FETCH_ONBOARDING_RECOMMENDED_COURSES: "FETCH_ONBOARDING_RECOMMENDED_COURSES",
    FETCH_PREVIOUS_ENROLLED_COURSES: "FETCH_PREVIOUS_ENROLLED_COURSES",
    TOGGLE_LIKE: "TOGGLE_LIKE",
    ADD_COMMENT: "ADD_COMMENT",
    FETCH_COMMENTS: "FETCH_COMMENTS",
    INCREASE_COMMENT: "INCREASE_COMMENT",
    TOGGLE_COMMENT_LIKE: "TOGGLE_COMMENT_LIKE",
    ADD_REPLY: "ADD_REPLY",
    FETCH_FILTERS: "FETCH_FILTERS",
    UPDATE_FILTER: "UPDATE_FILTER",
    CHECK_COURSE_ENROLL: "CHECK_COURSE_ENROLL",
    GET_FILTERS_FOR_EDUCATORS_LIST: "GET_FILTERS_FOR_EDUCATORS_LIST",
    ADD_COMPLETED_COURSE_TO_PLANNER: "ADD_COMPLETED_COURSE_TO_PLANNER",
    REMOVE_COURSE_FROM_PLANNER: "REMOVE_COURSE_FROM_PLANNER",
    GET_PLANNER_SCHEDULE: "GET_PLANNER_SCHEDULE",
    GET_ALL_POPULAR_SUBJECTS: "GET_ALL_POPULAR_SUBJECTS",
    GET_ALL_SPECIAL_CLASSES: "GET_ALL_SPECIAL_CLASSES"
};
var educatorTypes = {
    UPDATE_USERS: "UPDATE_USERS",
    FETCH_EDUCATOR_LEADERBOARD: "FETCH_EDUCATOR_LEADERBOARD",
    FETCH_PROFILE_INFO: "FETCH_PROFILE_INFO",
    FETCH_PROFILE_STATS: "FETCH_PROFILE_STATS",
    FETCH_PROFILE_FEED: "FETCH_PROFILE_FEED",
    FETCH_FILTERED_COURSES: "FETCH_FILTERED_COURSES",
    FETCH_EDUCATOR_COURSES_FILTERS: "FETCH_EDUCATOR_COURSES_FILTERS",
    FETCH_EDUCATOR_TESTIMONIALS: "FETCH_EDUCATOR_TESTIMONIALS",
    TOGGLE_FOLLOWING_STATUS: "TOGGLE_FOLLOWING_STATUS",
    FETCH_LEARNER_COURSES: "FETCH_LEARNER_COURSES",
    FETCH_LEARNER_MILESTONES: "FETCH_LEARNER_MILESTONES",
    FETCH_LEARNER_FOLLOWING_LIST: "FETCH_LEARNER_FOLLOWING_LIST",
    FETCH_LEARNER_LEADERBOARD: "FETCH_LEARNER_LEADERBOARD",
    FETCH_FAVOURITE_EDUCATORS: "FETCH_FAVOURITE_EDUCATORS",
    WRITE_DEDICATION: "WRITE_DEDICATION",
    FETCH_EDUCATOR_DASHBOARD_COURSES: "FETCH_EDUCATOR_DASHBOARD_COURSES",
    FETCH_EDUCATOR_SCHEDULED_CLASSES: "FETCH_EDUCATOR_SCHEDULED_CLASSES",
    UPDATE_COURSE_DETAILS: "UPDATE_COURSE_DETAILS",
    UPDATE_COURSE_DETAILS_DATA: "UPDATE_COURSE_DETAILS_DATA",
    UPDATE_COURSE_DROPDOWN_FIELDS: "UPDATE_COURSE_DROPDOWN_FIELDS",
    FETCH_ALL_LANGUAGES: "FETCH_ALL_LANGUAGES",
    SEARCH_GOAL: "SEARCH_GOAL",
    UPDATE_COURSE_AUTOCOMPLETE_FIELDS: "UPDATE_COURSE_AUTOCOMPLETE_FIELDS",
    SEARCH_TOPIC: "SEARCH_TOPIC",
    SEARCH_EXAM: "SEARCH_EXAM",
    SEARCH_EDUCATOR: "SEARCH_EDUCATOR",
    CREATE_PLUS_COURSE: "CREATE_PLUS_COURSE",
    EDIT_PLUS_COURSE: "EDIT_PLUS_COURSE",
    REMOVE_TAG: "REMOVE_TAG",
    UPDATE_CHECK_BOX: "UPDATE_CHECK_BOX",
    CREATE_SPECIAL_CLASS: "CREATE_SPECIAL_CLASS",
    EDIT_SPECIAL_CLASS: "EDIT_SPECIAL_CLASS",
    UPLOAD_THUMBNAIL: "UPLOAD_THUMBNAIL",
    SET_BROCHURE: "SET_BROCHURE",
    REMOVE_BROCHURE: "REMOVE_BROCHURE",
    FETCH_COURSE_TYPES: "FETCH_COURSE_TYPES",
    SET_COURSE_TYPE: "SET_COURSE_TYPE",
    SEACRH_CONCEPT: "SEACRH_CONCEPT",
    UPDATE_SESSION_VALUE: "UPDATE_SESSION_VALUE",
    UPDATE_SESSION_CONCEPTS: "UPDATE_SESSION_CONCEPTS",
    REMOVE_CONCEPT: "REMOVE_CONCEPT",
    FETCH_CO_AUTHOR: "FETCH_CO_AUTHOR",
    ADD_ITEM: "ADD_ITEM",
    EDIT_SESSION: "EDIT_SESSION",
    DELETE_ITEM: "DELETE_ITEM",
    SET_SESSION_EDUCATOR: "SET_SESSION_EDUCATOR",
    SET_TA_EDUCATOR_SC: "SET_TA_EDUCATOR_SC",
    SETUP_EDIT_SESSION: "SETUP_EDIT_SESSION",
    CREATE_TEST_SERIES_COURSE: "CREATE_TEST_SERIES_COURSE",
    EDIT_TEST_SERIES_COURSE: "EDIT_TEST_SERIES_COURSE",
    STATE_CHANGE: "STATE_CHANGE",
    FETCH_EDUCATOR_DEDICATIONS: "FETCH_EDUCATOR_DEDICATIONS",
    FETCH_EDUCATOR_WATCH_MINUTES: "FETCH_EDUCATOR_WATCH_MINUTES",
    FETCH_EDUCATOR_VIEWS_STATS: "FETCH_EDUCATOR_VIEWS_STATS",
    FETCH_EDUCATOR_ALERTS: "FETCH_EDUCATOR_ALERTS",
    FETCH_NSCLL_DATA: "FETCH_NSCLL_DATA",
    FETCH_EDUCATOR_REFERRALS: "FETCH_EDUCATOR_REFERRALS",
    FETCH_EDUCATOR_LIVE_HOURS: "FETCH_EDUCATOR_LIVE_HOURS",
    FETCH_EDUCATOR_STATISTICS: "FETCH_EDUCATOR_STATISTICS",
    FETCH_EDUCATOR_LIVE_CLASSES: "FETCH_EDUCATOR_LIVE_CLASSES",
    SET_CREATE_EDIT_SESSION_ERROR_FLAG: "SET_CREATE_EDIT_SESSION_ERROR_FLAG",
    CLEAR_ADD_ITEM_FORM: "CLEAR_ADD_ITEM_FORM",
    CLEAR_COURSE_FIELDS: "CLEAR_COURSE_FIELDS",
    FETCH_EDU_LIVE_CLASS_URL: "FETCH_EDU_LIVE_CLASS_URL",
    FETCH_COURSE_STATS: "FETCH_COURSE_STATS",
    FETCH_COURSE_RATINGS: "FETCH_COURSE_RATINGS",
    FETCH_COURSE_FEEDBACK: "FETCH_COURSE_FEEDBACK",
    FETCH_LESSON_METRICS: "FETCH_LESSON_METRICS",
    FETCH_EDU_LESSON_FEEDBACK: "FETCH_EDU_LESSON_FEEDBACK",
    UPDATE_RESCHEDULE_TEXT_FIELD: "UPDATE_RESCHEDULE_TEXT_FIELD",
    UPDATE_RESCHEDULE_DROPDOWN_FIELDS: "UPDATE_RESCHEDULE_DROPDOWN_FIELDS",
    RESCHEDULE_CLASS: "RESCHEDULE_CLASS",
    FETCH_COURSE_DETAILS: "FETCH_COURSE_DETAILS",
    UPDATE_DISCUSSION_FORUM_TEXT: "UPDATE_DISCUSSION_FORUM_TEXT",
    UPDATE_DISCUSSION_FORUM_STORY: "UPDATE_DISCUSSION_FORUM_STORY",
    SET_FILTER: "SET_FILTER",
    FETCH_GOLIVE_DETAILS: "FETCH_GOLIVE_DETAILS",
    FETCH_TEMPLATES_OF_A_COURSE: "FETCH_TEMPLATES_OF_A_COURSE",
    UPDATE_TEMPLATES: "UPDATE_TEMPLATES",
    FETCH_TEMPLATE_DETAILS: "FETCH_TEMPLATE_DETAILS",
    SEARCH_TOPIC_GROUP: "SEARCH_TOPIC_GROUP",
    ADD_TEMPLATE_LESSON: "ADD_TEMPLATE_LESSON",
    SETUP_TEMPLATE_EDIT_SESSION: "SETUP_TEMPLATE_EDIT_SESSION",
    SAVE_TEMPLATE: "SAVE_TEMPLATE",
    DELETE_TEMPLATE_LESSONS: "DELETE_TEMPLATE_LESSON",
    FETCH_COURSE_TEMPLATE_FILTERS: "FETCH_COURSE_TEMPLATE_FILTERS",
    SETUP_TEMPLATE_DATA_FOR_COURSE: "SETUP_TEMPLATE_DATA_FOR_COURSE",
    ADD_TEMPLATE_COURSE: "ADD_TEMPLATE_COURSE",
    EDIT_TEMPLATE_COURSE: "EDIT_TEMPLATE_COURSE",
    UPDATE_TEMPLATE_COURSE_FIELDS: "UPDATE_TEMPLATE_COURSE_FIELDS",
    UPDATE_SCHEDULE_WEEK_DAY: "UPDATE_SCHEDULE_WEEK_DAY",
    FETCH_TEMPLATE_COURSE_DETAILS: "FETCH_TEMPLATE_COURSE_DETAILS",
    SET_SCHEDULE_OF_TEMPLATE_COURSE: "SET_SCHEDULE_OF_TEMPLATE_COURSE",
    SETUP_TEMPLATE_DATA_IN_EDU_COURSE: "SETUP_TEMPLATE_DATA_IN_EDU_COURSE",
    EDIT_TEMPLATE_COURSE_LESSON_WITHOUT_UID: "EDIT_TEMPLATE_COURSE_LESSON_WITHOUT_UID",
    FILL_DURATION_IN_SCHEDULE: "FILL_DURATION_IN_SCHEDULE",
    DELETE_COURSE_TEMPLATE: "DELETE_COURSE_TEMPLATE",
    CLEAR_TEMPLATE_SESSION: "CLEAR_TEMPLATE_SESSION",
    CLEAR_TEMPLATES_STATE: "CLEAR_TEMPLATES_STATE",
    SET_TEMPLATE_LESSON_DURATION: "SET_TEMPLATE_LESSON_DURATION",
    CLEAR_TEMPLATE_DATA: "CLEAR_TEMPLATE_DATA",
    DELETE_TEMPLATE_LESSONS_FROM_COURSE: "DELETE_TEMPLATE_LESSONS_FROM_COURSE",
    GET_FEEDBACK_FOR_COURSE_TEMPLATE: "GET_FEEDBACK_FOR_COURSE_TEMPLATE",
    SUBMIT_FEEDBACK_FOR_COURSE_TEMPLATE: "SUBMIT_FEEDBACK_FOR_COURSE_TEMPLATE",
    SET_CLASH_SESSIONS_OF_A_COURSE: "SET_CLASH_SESSIONS_OF_A_COURSE",
    SET_LESSON_REFS: "SET_LESSON_REFS",
    SET_DRAG_INFO: "SET_DRAG_INFO",
    SET_TEMPLATE_REORDERED_QUIZ_LESSONS: "SET_TEMPLATE_REORDERED_QUIZ_LESSONS",
    GET_FEEDBACK_FOR_EDUCATOR_DASHBOARD: "GET_FEEDBACK_FOR_EDUCATOR_DASHBOARD",
    SUBMIT_FEEDBACK_FOR_EDUCATOR_DASHBOARD: "SUBMIT_FEEDBACK_FOR_EDUCATOR_DASHBOARD",
    SET_AUTO_DPP_KNOW_MORE_CARD_STATUS: "SET_AUTO_DPP_KNOW_MORE_CARD_STATUS",
    CLEAR_COURSE_UID: "CLEAR_COURSE_UID",
    REMOVE_CLASH_SESSIONS: "REMOVE_CLASH_SESSIONS",
    FETCH_CONTENT_SLIDE_LANGUAGES: "FETCH_CONTENT_SLIDE_LANGUAGES",
    GET_ON_BOARDING_PREFERENCES: "GET_ON_BOARDING_PREFERENCES",
    CREATE_LIVE_SUPPORT_TICKET: "CREATE_LIVE_SUPPORT_TICKET",
    GET_RESCHEDULE_INFO: "GET_RESCHEDULE_INFO",
    RESCHEDULE_REQUEST_WARNING: "RESCHEDULE_REQUEST_WARNING",
    RESET_RESCHEDULE_REQUEST_WARNING: "RESET_RESCHEDULE_REQUEST_WARNING",
    GET_FAQ_LEVELS: "GET_FAQ_LEVELS",
    GET_LEVELS_INTRO: "GET_LEVELS_INTRO",
    GET_META_INFO: "GET_META_INFO",
    GET_LEVEL_INFO: "GET_LEVEL_INFO",
    UPDATE_LEVEL_INFO: "UPDATE_LEVEL_INFO",
    GET_LEVEL_STATS: "GET_LEVEL_STATS",
    GET_LEVEL_WISE_EDUCATOR: "GET_LEVEL_WISE_EDUCATOR",
    MARK_LEVEL_INFO_VISITED: "MARK_LEVEL_INFO_VISITED",
    MARK_LEVEL_PROMOTION_VISITED: "MARK_LEVEL_PROMOTION_VISITED",
    GET_GOALS_FOR_STATS: "GET_GOALS_FOR_STATS",
    UPDATE_GOALS_FOR_STATS: "UPDATE_GOALS_FOR_STATS",
    FETCH_COMMUNITY_SHARE_CARD_INFO: "FETCH_COMMUNITY_SHARE_CARD_INFO",
    FETCH_COMMUNITY_DETAILS: "FETCH_COMMUNITY_DETAILS",
    FETCH_COMMUNITY_UPDATE_INTRO: "FETCH_COMMUNITY_UPDATE_INTRO",
    FETCH_OPEN_HOUSE_AWARENESS_INFO: "FETCH_OPEN_HOUSE_AWARENESS_INFO",
    FETCH_COMMUNITY_QUIZ_AWARENESS_INFO: "FETCH_COMMUNITY_QUIZ_AWARENESS_INFO",
    REORDER_COURSE_SESSIONS: "REORDER_COURSE_SESSIONS",
    AUTO_SCHEDULE_COURSE_SESSIONS: "AUTO_SCHEDULE_COURSE_SESSIONS",
    SET_AUTO_SCHEDULE_CLASHES: "SET_AUTO_SCHEDULE_CLASHES",
    FETCH_EDUCATOR_SCHEDULER_AWARENESS_INFO: "FETCH_EDUCATOR_SCHEDULER_AWARENESS_INFO",
    FETCH_COMMUNITY_ONBOARDING: "FETCH_COMMUNITY_ONBOARDING",
    SEND_MESSAGE_TO_COMMUNITY: "SEND_MESSAGE_TO_COMMUNITY",
    MARK_SCHEDULER_INFO_VISITED: "MARK_SCHEDULER_INFO_VISITED",
    REMOVE_SESSION_EDIT_ERROR: "REMOVE_SESSION_EDIT_ERROR",
    GET_DPP_REMINDER_CARD_STATUS: "GET_DPP_REMINDER_CARD_STATUS",
    FETCH_DPP_QUESTIONS: "FETCH_DPP_QUESTIONS",
    UPDATE_DPP_QUESTION_ON_SHUFFLE: "UPDATE_DPP_QUESTION_ON_SHUFFLE",
    UPDATE_DPP_FILTER_QUESTION_NUMBER: "UPDATE_DPP_FILTER_QUESTION_NUMBER",
    UPDATE_DPP_FILTER_SELECTED_SUBCONCEPTS: "UPDATE_DPP_FILTER_SELECTED_SUBCONCEPTS",
    ADD_DPP_FILTER_DIFFICULTY: "ADD_DPP_FILTER_DIFFICULTY",
    REMOVE_DPP_FILTER_DIFFICULTY: "REMOVE_DPP_FILTER_DIFFICULTY",
    SELECT_ALL_DIFFICULTIES: "SELECT_ALL_DIFFICULTIES",
    REMOVE_ALL_DIFFICULTIES: "REMOVE_ALL_DIFFICULTIES",
    ADD_DPP_SUBCONCEPT: "ADD_DPP_SUBCONCEPT",
    REMOVE_DPP_SUBCONCEPT: "REMOVE_DPP_SUBCONCEPT",
    RESET_FILTER: "RESET_FILTER",
    DELETE_PRACTICE: "DELETE_PRACTICE",
    SET_PRACTICE_CTA: "SET_PRACTICE_CTA",
    FETCH_DPP_QUIZ_INFO: "FETCH_DPP_QUIZ_INFO",
    SAVE_DRAFT_DPP_QUESTION: "SAVE_DRAFT_DPP_QUESTION",
    UPDATE_DPP_QUESTION_ORDER: "UPDATE_DPP_QUESTION_ORDER",
    RESET_DPP_QUESTION_ORDER: "RESET_DPP_QUESTION_ORDER",
    PUBLISH_DPP_QUIZ: "PUBLISH_DPP_QUIZ",
    FETCH_DPP_FEEDBACK_OPTIONS: "FETCH_DPP_FEEDBACK_OPTIONS",
    SUBMIT_DPP_PRACTICE_FEEDBACK: "SUBMIT_DPP_PRACTICE_FEEDBACK",
    FETCH_DPP_REPORT_QUESTION_INFO: "FETCH_DPP_REPORT_QUESTION_INFO",
    SUBMIT_REPORT_DPP_QUESTION: "SUBMIT_REPORT_DPP_QUESTION",
    SET_COURSE_PAGE_LINK: "SET_COURSE_PAGE_LINK",
    EDUCATOR_MODAL_TYPE: "EDUCATOR_MODAL_TYPE",
    FETCH_COURSE_TEMPLATES_AWARENESS_INFO: "FETCH_COURSE_TEMPLATES_AWARENESS_INFO",
    REMOVE_SUBCONCEPT_BY_UID: "REMOVE_SUBCONCEPT_BY_UID",
    ADD_SUBCONCEPT_BY_UID: "ADD_SUBCONCEPT_BY_UID",
    SET_SUBCONCEPT_NORMALIZED_DATA: "SET_SUBCONCEPT_NORMALIZED_DATA",
    FETCH_DPP_SUBCONCEPT_COUNT: "FETCH_DPP_SUBCONCEPT_COUNT",
    SET_SELECTED_DIFFICULTY_COUNT: "SET_SELECTED_DIFFICULTY_COUNT",
    SHARE_DPP_IN_COMMUNITY: "SHARE_DPP_IN_COMMUNITY",
    SET_TEST_TYPE: "SET_TEST_TYPE",
    SET_TEST_FREQUENCY: "SET_TEST_FREQUENCY",
    FETCH_RM_EDITS_AWARENESS_INFO: "FETCH_RM_EDITS_AWARENESS_INFO",
    FETCH_RECORDED_VIDEO_DETAILS: "FETCH_RECORDED_VIDEO_DETAILS",
    SEND_AUTO_PROMOTION_MESSAGE: "SEND_AUTO_PROMOTION_MESSAGE",
    DISMISS_AUTO_PROMOTION_MESSAGE: "DISMISS_AUTO_PROMOTION_MESSAGE",
    AUTO_PROMOTION_CAMPAIGN_INFO: "AUTO_PROMOTION_CAMPAIGN_INFO",
    UPDATE_RADIO_BOX: "UPDATE_RADIO_BOX",
    FETCH_ALL_OFFLINE_CITIES: "FETCH_ALL_OFFLINE_CITIES",
    FETCH_ALL_OFFLINE_CENTRES: "FETCH_ALL_OFFLINE_CENTRES",
    UPDATE_RADIO_BOX_SESSION: "UPDATE_RADIO_BOX_SESSION",
    FETCH_ALL_ROOMS: "FETCH_ALL_ROOMS",
    CHANGE_ROOM_OF_A_COURSE: "CHANGE_ROOM_OF_A_COURSE",
    UPDATE_SESSION_DROPDOWN_FIELDS: "UPDATE_SESSION_DROPDOWN_FIELDS",
    FETCH_TA_LIVE_CLASS_URL: "FETCH_TA_LIVE_CLASS_URL",
    UPDATE_TA_POWERED_STATE: "UPDATE_TA_POWERED_STATE",
    FETCH_SPECIAL_CLASS_TYPES: "FETCH_SPECIAL_CLASS_TYPES",
    UPDATE_SUB_CONCEPTS: "UPDATE_SUB_CONCEPTS",
    REMOVE_SUB_CONCEPTS: "REMOVE_SUB_CONCEPTS"
};
var educatorOnboardingTypes = {
    GET_ONBOARD_USER_STATUS: "GET_ONBOARD_USER_STATUS",
    GET_APPLICATION_DETAILS: "GET_APPLICATION_DETAILS",
    GET_IFSC_DETAILS: "GET_IFSC_DETAILS",
    UPDATE_APPLICATION_META: "UPDATE_APPLICATION_META",
    SUBMIT_KYC: "SUBMIT_KYC",
    SUBMIT_BILLING_INFO: "SUBMIT_BILLING_INFO",
    EDIT_BILLING_INFO: "EDIT_BILLING_INFO",
    GET_BILLING_INFO: "GET_BILLING_INFO",
    UPLOAD_KYC_IMAGES: "UPLOAD_KYC_IMAGES",
    SET_ACADEMIC_DETAILS: "SET_ACADEMIC_DETAILS",
    SET_EXPERIENCE_DETAILS: "SET_EXPERIENCE_DETAILS",
    SET_BILLING_DETAILS: "SET_BILLING_DETAILS",
    SET_IFSC_DETAILS: "SET_IFSC_DETAILS"
};
var topologyTypes = {
    UPDATE_TOPOLOGIES: "UPDATE_TOPOLOGIES",
    FETCH_TOPOLOGIES: "FETCH_TOPOLOGIES",
    FETCH_ONBOARDING_GOALS: "FETCH_ONBOARDING_GOALS",
    FETCH_GOAL_LANGUAGES: "FETCH_GOAL_LANGUAGES",
    SET_GOAL_LANGUAGE: "SET_GOAL_LANGUAGE",
    FETCH_TOPOLOGY_FEED: "FETCH_TOPOLOGY_FEED",
    FETCH_NOTES: "FETCH_NOTES",
    FETCH_TOPOLOGY_CHILDREN: "FETCH_TOPOLOGY_CHILDREN",
    FETCH_TOPOLOGY_INFO: "FETCH_TOPOLOGY_INFO",
    FETCH_TOPOLOGY_COURSE_FEED: "FETCH_TOPOLOGY_COURSE_FEED",
    FETCH_TOPOLOGY_COURSES: "FETCH_TOPOLOGY_COURSES",
    FETCH_TOPOLOGY_EXTRA_INFO: "FETCH_TOPOLOGY_EXTRA_INFO",
    FETCH_TOPOLOGY_CHILDREN_OF_FREE_COURSE: "FETCH_TOPOLOGY_CHILDREN_OF_FREE_COURSE",
    FETCH_TOPOLOGY_OF_FREE_COURSE_FEED: "FETCH_TOPOLOGY_OF_FREE_COURSE_FEED",
    FETCH_FREE_COURSES_OF_A_CONCEPT: "FETCH_FREE_COURSES_OF_A_CONCEPT",
    FETCH_POPULAR_GOALS_GROUPS: "FETCH_POPULAR_GOALS_GROUPS",
    FETCH_COURSE_STATS: "FETCH_COURSE_STATS",
    FETCH_PRESUBSCRIBED_STATIC_CONTENT: "FETCH_PRESUBSCRIBED_STATIC_CONTENT",
    FETCH_POST_SUBSCRIPTION_ONBOARDING_PREFERENCES: "FETCH_POST_SUBSCRIPTION_ONBOARDING_PREFERENCES",
    SAVE_PREFERENCE_FETCH_NEXT: "SAVE_PREFERENCE_FETCH_NEXT",
    FETCH_ALL_ONBOARDING_PREFERENCE_OF_A_USER: "FETCH_ALL_ONBOARDING_PREFERENCE_OF_A_USER",
    UPDATE_GLO_STATUS: "UPDATE_GLO_STATUS",
    FETCH_SUBSCRIPTION_GOALS: "FETCH_SUBSCRIPTION_GOALS",
    FETCH_GOAL_BENEFITS: "TOPOLOGY: FETCH_GOAL_BENEFITS",
    SET_GLO_PREFERENCES_UPDATED: "SET_GLO_PREFERENCES_UPDATED",
    FETCH_NEW_SYLLABUS_FEED: "FETCH_NEW_SYLLABUS_FEED",
    FETCH_NEET_RECORDED_CONTENT: "FETCH_NEET_RECORDED_CONTENT",
    FETCH_GOAL_SYNONYMS: "FETCH_GOAL_SYNONYMS"
};
var combatTypes = {
    UPDATE_COMBAT: "UPDATE_COMBAT",
    FETCH_CONTEST_INFO: "FETCH_CONTEST_INFO",
    FETCH_CONTEST_RATING: "FETCH_CONTEST_RATING",
    FETCH_MY_RATING: "FETCH_MY_RATING",
    FETCH_UPCOMING_COMBATS_INFO: "FETCH_UPCOMING_COMBATS_INFO",
    FETCH_COMBAT_DETAILS: "FETCH_COMBAT_DETAILS",
    FETCH_CONTEST_ONBOARDING_PREFERENCES: "FETCH_CONTEST_ONBOARDING_PREFERENCES",
    ENROLL_FOR_CONTEST: "ENROLL_FOR_CONTEST",
    UPDATE_CONTEST_ONBOARDING_PREFERENCES: "UPDATE_CONTEST_ONBOARDING_PREFERENCES",
    FETCH_PAGINATED_COMBATS: "FETCH_PAGINATED_COMBATS",
    COMBAT_MODAL_TYPE: "COMBAT_MODAL_TYPE",
    FETCH_COMBAT_INFO: "FETCH_COMBAT_INFO"
};
var plusCoursesTypes = {
    FETCH_TEST_SERIES: "FETCH_TEST_SERIES",
    FETCH_PLUS_HOME_FEED: "FETCH_PLUS_HOME_FEED",
    FETCH_EBINFO_PLUS_HOME_FEED: "FETCH_EBINFO_PLUS_HOME_FEED",
    FETCH_SEE_ALL_EBINFO: "FETCH_SEE_ALL_EBINFO",
    FETCH_SIMILAR: "FETCH_SIMILAR",
    FETCH_NEXT_TRACK: "FETCH_NEXT_TRACK",
    FETCH_COURSE_UPDATES: "FETCH_COURSE_UPDATES"
};
var itemTypes = {
    UPDATE_ITEMS: "UPDATE_ITEMS",
    FETCH_WATCH_HISTORY: "FETCH_WATCH_HISTORY",
    FETCH_FREE_LESSON_INFO: "FETCH_FREE_LESSON_INFO",
    FETCH_FREE_LESSON_LIST: "FETCH_FREE_LESSON_LIST",
    BOOKMARK_ITEM: "BOOKMARK_ITEM",
    FETCH_FREE_RELATED_SPECIAL_ITEMS: "FETCH_FREE_RELATED_SPECIAL_ITEMS"
};
var classTypes = {
    FETCH_CLASS: "FETCH_CLASS",
    FETCH_SIMILAR_AND_OTHER_COURSES: "FETCH_SIMILAR_AND_OTHER_COURSES",
    SEND_WATCHED: "SEND_WATCHED",
    UPDATE_PAGEVIEW: "UPDATE_PAGEVIEW",
    FETCH_SCHEDULED_CLASSES: "FETCH_SCHEDULED_CLASSES",
    FETCH_CALENDAR_DATA: "FETCH_CALENDAR_DATA_LEARNER"
};
var subscriptionTypes = {
    FETCH_PRICINGS: "FETCH_PRICINGS",
    VALIDATE_REFERRAL: "VALIDATE_REFERRAL",
    VALIDATE_REFERRAL_SUBSCRIPTION: "VALIDATE_REFERRAL_SUBSCRIPTION",
    FETCH_PAYMENT_METHODS: "FETCH_PAYMENT_METHODS",
    FETCH_EMI_PLANS: "FETCH_EMI_PLANS",
    FETCH_PART_PAYMENT_STATUS: "FETCH_PART_PAYMENT_STATUS",
    ENROLL_ORDER: "ENROLL_ORDER",
    ENROLL_INSTALLMENT_ORDER: "ENROLL_INSTALLMENT_ORDER",
    CLEAR_ORDER: "CLEAR_ORDER",
    CANCEL_ENROLL_ORDER: "CANCEL_ENROLL_ORDER",
    PURCHASE_SUBSCRIPTION: "PURCHASE_SUBSCRIPTION",
    PAYMENT_STATUS_JUSPAY: "PAYMENT_STATUS_JUSPAY",
    SAVE_PURCHASED_SUBSCRIPTION: "SAVE_PURCHASED_SUBSCRIPTION",
    ACTIVATE_EXTERNAL_APP: "ACTIVATE_EXTERNAL_APP",
    STOP_PART_PAYMENT_NUDGE: "STOP_PART_PAYMENT_NUDGE",
    SYNC_CODE_CHEF: "SYNC_CODE_CHEF",
    FETCH_SUBSCRIPTION_STATIC_DATA: "FETCH_SUBSCRIPTION_STATIC_DATA",
    FETCH_BUNDLE_DETAILS: "FETCH_BUNDLE_DETAILS",
    FETCH_OFFER_LIST: "FETCH_OFFER_LIST",
    FETCH_OFFER_FAQS: "FETCH_OFFER_FAQS",
    FETCH_COMBO_FEATURE_POINTS: "FETCH_COMBO_FEATURE_POINTS",
    FETCH_CASH_PAYMENT_DATA: "FETCH_CASH_PAYMENT_DATA",
    FETCH_BATCH_GROUP_SUBSCRIPTION_INFO: "FETCH_BATCH_GROUP_SUBSCRIPTION_INFO",
    FETCH_SUBSCRIPTION_FEEBACK_CARDS: "FETCH_SUBSCRIPTION_FEEBACK_CARDS"
};
var specialClassTypes = {
    FETCH_EBINFO_SEE_ALL_URL: "FETCH_EBINFO_SEE_ALL_URL",
    FETCH_SPECIAL_CLASS_SEE_ALL_BLOCK: "FETCH_SPECIAL_CLASS_SEE_ALL_BLOCK"
};
var notificationTypes = {
    FETCH_NOTIFICATIONS: "FETCH_NOTIFICATIONS",
    MARK_NOTIFICATION_READ: "MARK_NOTIFICATION_READ"
};
var searchTypes = {
    FETCH_SEARCH_RESULT: "FETCH_SEARCH_RESULT",
    FETCH_SEARCH_LIST: "FETCH_SEARCH_LIST",
    UPDATE_RECENT_SEARCH_LOG: "UPDATE_RECENT_SEARCH_LOG"
};
var otherTypes = {
    FETCH_FAQS: "FETCH_FAQS",
    FETCH_S3_SIGNIN_URL: "FETCH_S3_SIGNIN_URL",
    SUBMIT_ISSUE: "SUBMIT_ISSUE",
    FETCH_LEGENDS_BANNER: "FETCH_LEGENDS_BANNER",
    FETCH_SITEMAP: "FETCH_SITEMAP",
    FETCH_ICONIC_SUBSCRIPTION_INFO: "FETCH_ICONIC_SUBSCRIPTION_INFO",
    FETCH_SUBSCRIPTION_FEATURES: "FETCH_SUBSCRIPTION_FEATURES",
    FETCH_SUBSCRIPTION_HIGHLIGHTS: "FETCH_SUBSCRIPTION_HIGHLIGHTS",
    FETCH_SUBSCRIPTION_FAQS: "FETCH_SUBSCRIPTION_FAQS",
    FETCH_PRICE_HIKE_INFO: "FETCH_PRICE_HIKE_INFO",
    FETCH_ONE_CAROUSEL_FEED: "FETCH_ONE_CAROUSEL_FEED",
    FETCH_ROOT_PAGE_DATA: "FETCH_ROOT_PAGE_DATA",
    FETCH_GOAL_DISPLAY_NAMES: "FETCH_GOAL_DISPLAY_NAMES",
    FETCH_PRODIGY_DATA: "FETCH_PRODIGY_DATA",
    SAVE_PRODIGY_ADDITIONAL_DATA: "SAVE_PRODIGY_ADDITIONAL_DATA",
    VERIFY_PRODIGY_DETAILS: "VERIFY_PRODIGY_DETAILS",
    SET_SAVED_COURSE: "SET_SAVED_COURSE",
    SET_WEBP_SUPPORTED: "SET_WEBP_SUPPORTED",
    PREDICT_EXAM_RANK: "PREDICT_EXAM_RANK",
    FETCH_COMMUNITY_STATIC_DATA: "FETCH_COMMUNITY_STATIC_DATA",
    SET_FETCH_STATE_OF_SCHEDULE_DATA_FOR_DPP: "SET_FETCH_STATE_OF_SCHEDULE_DATA_FOR_DPP",
    SET_INITIAL_PROPS_RUN: "SET_INITIAL_PROPS_RUN"
};
var salesTypes = {
    FETCH_CALL_ASSIST_FEED: "FETCH_CALL_ASSIST_FEED",
    FETCH_COMBO_PLANS: "FETCH_COMBO_PLANS",
    FETCH_PRICINGS: "FETCH_PRICINGS",
    FETCH_AVL_PAYMENT_OPTS: "FETCH_AVL_PAYMENT_OPTS",
    FETCH_LEAD_DETAILS: "FETCH_LEAD_DETAILS",
    FETCH_STATS: "FETCH_STATS",
    FETCH_CRM_GOALS: "FETCH_CRM_GOALS",
    FETCH_HERO_DATA: "FETCH_HERO_DATA",
    FETCH_SUBSCRIBED_SUBSCRIPTIONS: "FETCH_SUBSCRIBED_SUBSCRIPTIONS",
    FETCH_FAV_EDUCATOR: "FETCH_FAV_EDUCATOR",
    FETCH_SUGGESTED_REFFERAL: "FETCH_SUGGESTED_REFFERAL",
    FETCH_RECOMMENDED_EDU: "FETCH_RECOMMENDED_EDU",
    FETCH_RECOMMENDED_BATCHES: "FETCH_RECOMMENDED_BATCHES",
    FETCH_RECOMMENDED_COURSES: "FETCH_RECOMMENDED_COURSES",
    FETCH_RECOMMENDED_TEST_SERIES: "FETCH_RECOMMENDED_TEST_SERIES",
    FETCH_REC_ACTIVATION_PITCH: "FETCH_REC_ACTIVATION_PITCH",
    SEARCH_EDUCATORS: "SEARCH_EDUCATORS",
    CLEAR_SEARCH_EDUCATORS: "CLEAR_SEARCH_EDUCATORS",
    FETCH_LANG_FILTERS: "FETCH_LANG_FILTERS",
    FETCH_AVL_OFFERS: "FETCH_AVL_OFFERS",
    ACTIVATE_OFFER: "ACTIVATE_OFFER",
    FETCH_LOAN_LEARNER_DETAILS: "FETCH_LOAN_LEARNER_DETAILS",
    FETCH_ELIGIBLE_GOALS: "FETCH_ELIGIBLE_GOALS",
    SUBMIT_LOAN_DATA: "SUBMIT_LOAN_DATA",
    SUBMIT_CASH_DEPOSIT_DATA: "SUBMIT_CASH_DEPOSIT_DATA",
    FETCH_ELIGIBLE_SUBSCRIPTIONS: "FETCH_ELIGIBLE_SUBSCRIPTIONS",
    FETCH_MENTOR_DETAILS: "FETCH_MENTOR_DETAILS",
    TOGGLE_LMP_AVAILABILITY: "TOGGLE_LMP_AVAILABILITY",
    FETCH_LMP_SESSION_DETAILS: "FETCH_LMP_SESSION_DETAILS",
    CLEAR_LMP_SESSION_DETAILS: "CLEAR_LMP_SESSION_DETAILS",
    FETCH_LMP_FEEDBACK_OPTIONS: "FETCH_LMP_FEEDBACK_OPTIONS",
    SUBMIT_LMP_FEEDBACK: "SUBMIT_LMP_FEEDBACK",
    CANCEL_LMP_SESSION: "CANCEL_LMP_SESSION",
    FETCH_ELIGIBLE_SUBSCRIPTIONS_FOR_CASH_PAYMENT: "FETCH_ELIGIBLE_SUBSCRIPTIONS_FOR_CASH_PAYMENT",
    VALIDATE_CASH_REFERRAL: "VALIDATE_CASH_REFERRAL"
};
var quizTypes = {
    UPDATE_QUESTIONS: "UPDATE_QUESTIONS",
    FETCH_MY_QUIZ_ATTEMPTS: "FETCH_MY_QUIZ_ATTEMPTS",
    UPDATE_SESSION_LANGUAGE: "UPDATE_SESSION_LANGUAGE",
    FETCH_SESSION_DETAILS: "FETCH_SESSION_DETAILS",
    CHECK_ACCESS: "CHECK_ACCESS",
    UPLOAD_CSV: "UPLOAD_CSV",
    FETCH_REVIEW_STATS: "FETCH_REVIEW_STATS",
    EDIT_QUIZ: "EDIT_QUIZ",
    FETCH_REVIEWS: "FETCH_REVIEWS",
    FETCH_DASHBOARD_GOALS: "FETCH_DASHBOARD_GOALS",
    UPDATE_DASHBOARD_FILTERS: "UPDATE_DASHBOARD_FILTERS",
    FETCH_POSTREVIEW_NOTIFICATIONS: "FETCH_POSTREVIEW_NOTIFICATIONS",
    ASSIGN_REVIEW: "ASSIGN_REVIEW",
    FETCH_TEST_SERIES_DATA: "FETCH_TEST_SERIES_DATA",
    FETCH_GTP_TEST_SERIES_DATA: "FETCH_GTP_TEST_SERIES_DATA",
    UPLOAD_SUJECTIVE_ANSWERS: "UPLOAD_SUJECTIVE_ANSWERS",
    FETCH_EVAL_DASH_STATS: "FETCH_EVAL_DASH_STATS",
    FETCH_MY_EVALS: "FETCH_MY_EVALS",
    FETCH_EVALUATED_COPIES: "FETCH_EVALUATED_COPIES",
    FETCH_EVAL_DASH_GOALS: "FETCH_EVAL_DASH_GOALS",
    ASSIGN_EVALUATION: "ASSIGN_EVALUATION",
    SUBMIT_EVALUATION_SCORE: "SUBMIT_EVALUATION_SCORE",
    ASSIGN_EVALUATOR: "ASSIGN_EVALUATOR",
    ASSIGN_UPLOADER: "ASSIGN_UPLOADER",
    FETCH_MY_UPLOADS: "FETCH_MY_UPLOADS",
    FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS: "FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS"
};
var preSubscribedGoal = {
    FETCH_PRESUBSCRIBED_BLOCKS: "FETCH_PRESUBSCRIBED_BLOCKS"
};
var playerTypes = {
    OPEN_PLAYER: "OPEN_PLAYER",
    CLOSE_PLAYER: "CLOSE_PLAYER",
    SET_PLAYER_DATA: "SET_PLAYER_DATA",
    SET_PLAYER_LOADED: "SET_PLAYER_LOADED",
    FETCH_CLASS: "FETCH_CLASS_FOR_PLAYER",
    TOGGLE_URL_MISMATCH: "TOGGLE_URL_MISMATCH",
    RESET_PLAYER_LOADED: "RESET_PLAYER_LOADED",
    SET_OBJECT_TYPE: "SET_OBJECT_TYPE"
};
var batchTypes = {
    UPDATE_BATCHES: "UPDATE_BATCHES",
    FETCH_BATCH_INFO: "FETCH_BATCH_INFO",
    FETCH_TOPICS_COVERED: "FETCH_TOPICS_COVERED",
    FETCH_TEST_SERIES: "FETCH_TEST_SERIES",
    FETCH_TOPICS_WITH_CHILDREN: "FETCH_TOPICS_WITH_CHILDREN",
    FETCH_COURSES_IN_CONCEPT: "FETCH_COURSES_IN_CONCEPT",
    FETCH_ITEMS_IN_COURSE: "FETCH_ITEMS_IN_COURSE",
    ENROLL_IN_BATCH: "ENROLL_IN_BATCH",
    FETCH_SCHEDULE: "FETCH_SCHEDULE",
    FETCH_CALENDAR_DATA: "FETCH_CALENDAR_DATA",
    FETCH_SCHEDULED_CLASSES: "FETCH_SCHEDULED_CLASSES",
    FETCH_BATCHES: "FETCH_BATCHES",
    FETCH_BATCH_UPDATES: "FETCH_BATCH_UPDATES",
    FETCH_SIMILAR_BATCHES: "FETCH_SIMILAR_BATCHES",
    FETCH_TRIAL_CLASSES: "FETCH_TRIAL_CLASSES",
    FETCH_FAQS: "FETCH_FAQS",
    FETCH_FEEDBACKS: "FETCH_FEEDBACKS",
    ENROLL_TRIAL_CLASSES: "ENROLL_TRIAL_CLASSES",
    FETCH_BATCH_SCHEDULE_WEEKS: "FETCH_BATCH_SCHEDULE_WEEKS",
    UPDATE_BATCH_SCHEDULE_WEEKS: "UPDATE_BATCH_SCHEDULE_WEEKS"
};
var batchGroupTypes = {
    UPDATE_BATCHGROUPS: "UPDATE_BATCHGROUPS",
    FETCH_BATCHGROUPS_INFO: "FETCH_BATCHGROUPS_INFO",
    FETCH_BATCHGROUPS_TRIAL_CLASSES: "FETCH_BATCHGROUPS_TRIAL_CLASSES",
    FETCH_BATCHES_GROUP: "FETCH_BATCHES_GROUP",
    FETCH_BATCH_GROUP_INFO: "FETCH_BATCH_GROUP_INFO",
    FETCH_ENROLLED_BATCHES: "FETCH_ENROLLED_BATCHES",
    FETCH_BATCH_GROUP_CLASSES: "FETCH_BATCH_GROUP_CLASSES"
};
var classroomTypes = {
    CREATE_CLASS: "CREATE_CLASS",
    GET_CLASS: "GET_CLASS",
    DELETE_CLASS: "DELETE_CLASS"
};
var questionTypes = {
    FETCH_QUESTION_DATA: "FETCH_QUESTION_DATA",
    FETCH_QUESTION_INFO: "FETCH_QUESTION_INFO",
    FETCH_CONCEPT: "FETCH_CONCEPT",
    FETCH_SUB_CONCEPTS: "FETCH_SUB_CONCEPTS",
    TOGGLE_QUESTION_STATUS: "TOGGLE_QUESTION_STATUS",
    EDIT_OPTION: "EDIT_OPTION",
    SAVE_QUESTION: "SAVE_QUESTION",
    EDIT_CONTENT: "EDIT_CONTENT",
    EDIT_ANSWER: "EDIT_ANSWER",
    EDIT_HINT: "EDIT_HINT",
    EDIT_LANGUAGE: "EDIT_LANGUAGE",
    MARK_CORRECT: "MARK_CORRECT",
    MARK_IS_COMMON: "MARK_IS_COMMON",
    ADD_OPTION: "ADD_OPTION",
    REMOVE_LANGUAGE: "REMOVE_LANGUAGE",
    SET_NUMBER_OPTIONS: "SET_NUMBER_OPTIONS",
    SETUP_DATA: "SETUP_DATA",
    FETCH_QUESTION_DATA_V2: "FETCH_QUESTION_DATA_V2",
    SUBMIT_QUESTION_DETAILS: "SUBMIT_QUESTION_DETAILS",
    SUBMIT_SOLUTION_RECORDING: "SUBMIT_SOLUTION_RECORDING",
    SETUP_CONFIG_FOR_EDITING: "SETUP_CONFIG_FOR_EDITING",
    SETUP_QUESTION_FOR_EDITING: "SETUP_QUESTION_FOR_EDITING",
    FULL_RESET_QUESTION_DATA: "FULL_RESET_QUESTION_DATA",
    RESET_QUESTION_DATA: "RESET_QUESTION_DATA",
    UPDATE_QUESTION_DATA: "UPDATE_QUESTION_DATA",
    UPDATE_QUESTION_CONFIG: "UPDATE_QUESTION_CONFIG",
    FETCH_PASSAGE_RELATED_QUESTIONS: "FETCH_PASSAGE_RELATED_QUESTIONS",
    ADD_QUESTION_SUB_TYPE: "ADD_QUESTION_SUB_TYPE"
};
var doubtTypes = {
    UPDATE_DOUBTS: "UPDATE_DOUBTS",
    UPDATE_DOUBTSOLUTIONS: "UPDATE_DOUBTSOLUTIONS",
    FETCH_DOUBT_DETAILS: "FETCH_DOUBT_DETAILS",
    FETCH_SOLUTION_DETAILS: "FETCH_SOLUTION_DETAILS",
    FETCH_MY_SOLUTIONS: "FETCH_MY_SOLUTIONS",
    ASSIGN_DOUBT: "ASSIGN_DOUBT",
    FETCH_CHOICES: "FETCH_CHOICES",
    SKIP_DOUBT: "SKIP_DOUBT",
    FETCH_STATS: "FETCH_STATS",
    FETCH_HOME_TOPOLOGY: "FETCH_HOME_TOPOLOGY",
    FETCH_TOPOLOGY_LIST: "FETCH_TOPOLOGY_LIST",
    SET_HOME_TOPOLOGY: "SET_HOME_TOPOLOGY",
    SUBMIT_SOLUTION: "SUBMIT_SOLUTION",
    FEEDBACK_TO_LEARNER: "FEEDBACK_TO_LEARNER",
    UNASSIGN_DOUBT: "UNASSIGN_DOUBT",
    START_RECORDING: "START_RECORDING",
    FETCH_CAMPAIGN_RULES: "FETCH_CAMPAIGN_RULES",
    FETCH_CYCLE_EARNINGS: "FETCH_CYCLE_EARNINGS",
    FETCH_INCENTIVE_RULES: "FETCH_INCENTIVE_RULES",
    UPDATE_SOLUTION_DETAILS: "UPDATE_SOLUTION_DETAILS",
    RECORDING_STARTED: "RECORDING_STARTED",
    UPDATE_SUBMIT_TIMER: "UPDATE_SUBMIT_TIMER"
};
var moderatorTypes = {
    FETCH_EDUCATORS: "FETCH_EDUCATORS",
    EDIT_ACCESS: "EDIT_ACCESS",
    FETCH_COURSES: "FETCH_COURSES",
    FETCH_LESSONS: "FETCH_LESSONS",
    FETCH_POST: "FETCH_POST"
};
var summitTypes = {
    FETCH_EVENTS_INFO: "FETCH_EVENTS_INFO",
    REGISTER: "REGISTER",
    CHECK_REGISTER: "CHECK_REGISTER",
    FETCH_SCHEDULE: "FETCH_SCHEDULE",
    FETCH_CONTENT: "FETCH_CONTENT"
};
var savedTypes = {
    FETCH_SAVED_COUNT: "FETCH_SAVED_COUNT",
    FETCH_SAVED_ENTITY: "FETCH_SAVED_ENTITY",
    REMOVE_SAVED_ENTITY: "REMOVE_SAVED_ENTITY",
    SAVE_ENTITY: "SAVE_ENTITY"
};
var helpCenterTypes = {
    FETCH_CATEGORIES: "FETCH_CATEGORIES",
    FETCH_ARTICLES: "FETCH_ARTICLES",
    FETCH_ARTICLE_INFO: "FETCH_ARTICLE_INFO",
    FETCH_TICKETS_HISTORY: "FETCH_TICKETS_HISTORY",
    FETCH_ME_DATA: "FETCH_ME_DATA",
    ON_CHAT_OPEN: "ON_CHAT_OPEN"
};
var analytics = {
    ANALYTICS: "ANALYTICS"
};
var templatesTypes = {
    FETCH_TEMPLATES: "FETCH_TEMPLATES",
    FETCH_TEMPLATE: "FETCH_TEMPLATE",
    RESET_TEMPLATE_FORM: "RESET_TEMPLATE_FORM",
    FETCH_GOAL_TEMPLATES: "FETCH_GOAL_TEMPLATES",
    UPDATE_TEMPLATE_SETTINGS: "UPDATE_TEMPLATE_SETTINGS",
    UPDATE_TEMPLATE_DETAILS: "UPDATE_TEMPLATE_DETAILS",
    UPDATE_TEMPLATE_EVALUATION_CRITERIA: "UPDATE_TEMPLATE_EVALUATION_CRITERIA",
    ADD_OR_UPDATE_TEMPLATE_SECTION: "ADD_OR_UPDATE_TEMPLATE_SECTION",
    UPDATE_TEMPLATE_INSTRUCTIONS: "UPDATE_TEMPLATE_INSTRUCTIONS",
    SET_TEMPLATE_ERRORS: "SET_TEMPLATE_ERRORS",
    DELETE_TEMPLATE: "DELETE_TEMPLATE",
    UPDATE_OR_CREATE_TEMPLATE: "UPDATE_OR_CREATE_TEMPLATE",
    CREATE_TEST_FOR_TEMPLATE: "CREATE_TEST_FOR_TEMPLATE",
    FETCH_TEST_TEMPLATE_DETAILS: "FETCH_TEST_TEMPLATE_DETAILS",
    CREATE_QUIZ_IN_TEMPLATE: "CREATE_QUIZ_IN_TEMPLATE",
    EDIT_QUIZ_IN_TEMPLATE: "EDIT_QUIZ_IN_TEMPLATE",
    FETCH_TEST_STATE: "FETCH_TEST_STATE",
    CLEAR_TEMPLATE_FIELDS: "CLEAR_TEMPLATE_FIELDS",
    UPDATE_EDUCATOR_SLIDES: "UPDATE_EDUCATOR_SLIDES"
};
var driveTypes = {
    FETCH_DRIVE_CONTENT: "FETCH_DRIVE_CONTENT",
    CREATE_FOLDER: "CREATE_FOLDER",
    DELETE_DRIVE_ITEM: "DELETE_DRIVE_ITEM",
    FETCH_ANCESTERS: "FETCH_ANCESTERS",
    FETCH_ITEM_DETAILS: "FETCH_ITEM_DETAILS",
    UPDATE_DRIVE_ITEM: "UPDATE_DRIVE_ITEM",
    SEARCH_FILES: "SEARCH_FILES",
    FETCH_DRIVE_ITEM_DETAILS: "FETCH_DRIVE_ITEM_DETAILS"
};
var practiceSessionTypes = {
    PRACTICE_MODAL_TYPE: "PRACTICE: PRACTICE_MODAL_TYPE",
    FETCH_PRACTICE_TOPOLOGIES: "FETCH_PRACTICE_TOPOLOGIES",
    FETCH_LEARNER_LEVEL_DETAILS: "FETCH_LEARNER_LEVEL_DETAILS",
    FETCH_PRACTICE_SESSION: "FETCH_PRACTICE_SESSION",
    CREATE_PRACTICE_SESSION: "CREATE_PRACTICE_SESSION",
    FINISH_PRACTICE_SESSION: "FINISH_PRACTICE_SESSION",
    FINISH_PRACTICE_QUESTION_REVIEW: "FINISH_PRACTICE_QUESTION_REVIEW",
    SUBMIT_PRACTICE_SESSION_ANSWER: "SUBMIT_PRACTICE_SESSION_ANSWER",
    GET_NEXT_PRACTICE_QUESTION: "GET_NEXT_PRACTICE_QUESTION",
    SET_SELECTED_PRACTICE: "SET_SELECTED_PRACTICE",
    SET_PRACTICE_ANSWERS: "SET_PRACTICE_ANSWERS",
    SET_PRACTICE_QUESTION_COUNT: "SET_PRACTICE_QUESTION_COUNT",
    SET_PRACTICE_SEEN_HINT: "SET_PRACTICE_SEEN_HINT",
    SETUP_NEXT_PRACTICE_QUESTION: "SETUP_NEXT_PRACTICE_QUESTION",
    RESET_PRACTICE_SESSION: "RESET_PRACTICE_SESSION",
    FETCH_PRACTICE_FEEDBACK_OPTIONS: "FETCH_PRACTICE_FEEDBACK_OPTIONS",
    SUBMIT_PRACTICE_FEEDBACK: "SUBMIT_PRACTICE_FEEDBACK",
    FETCH_PRACTICE_PYQ_FILTERS: "FETCH_PRACTICE_PYQ_FILTERS",
    FETCH_CLASS_PRACTICE_SESSION: "PRACTICE: FETCH_CLASS_PRACTICE_SESSION",
    SET_REMINDER_DEFAULT_DATA: "SET_REMINDER_DEFAULT_DATA",
    FETCH_PRACTICE_REMINDER: "PRACTICE: FETCH_PRACTICE_REMINDER",
    SUBMIT_PRACTICE_REMINDER: "PRACTICE: SUBMIT_PRACTICE_REMINDER",
    DELETE_PRACTICE_REMINDER: "PRACTICE: DELETE_PRACTICE_REMINDER",
    DISMISS_PRACTICE_REMINDER: "PRACTICE: DISMISS_PRACTICE_REMINDER",
    FETCH_PRACTICE_AVAILABLE_LANGUAGES: "FETCH_PRACTICE_AVAILABLE_LANGUAGES",
    SET_LANGUAGE_PREFERENCE: "SET_LANGUAGE_PREFERENCE"
};
var educatorLiveMentoringTypes = {
    SLOT_PREFERENCES: "LIVE_MENTORING: SLOT_PREFERENCES",
    FETCH_SESSIONS: "LIVE_MENTORING: FETCH_SESSIONS",
    FETCH_PREFERENCES: "LIVE_MENTORING: FETCH_PREFERENCES",
    FETCH_SESSION_DETAILS: "LIVE_MENTORING: FETCH_SESSION_DETAILS",
    FETCH_FEEDBACK_SUMMARY: "LIVE_MENTORING: FETCH_FEEDBACK_SUMMARY",
    CANCEL_SESSION: "CANCEL_SESSION",
    FETCH_MAKE_CALL: "LIVE_MENTORING: FETCH_MAKE_CALL",
    FETCH_CALL_STATUS: "LIVE_MENTORING: FETCH_CALL_STATUS",
    FETCH_LEARNER_CALL_LIST: "LIVE_MENTORING: FETCH_LEARNER_CALL_LIST",
    FETCH_LEARNER_WATCH_TIME: "LIVE_MENTORING: FETCH_LEARNER_WATCH_TIME",
    FETCH_LEARNER_PRACTICE_INFO: "LIVE_MENTORING:FETCH_LEARNER_PRACTICE_INFO",
    FETCH_LEARNER_TEST_INFO: "LIVE_MENTORING:FETCH_LEARNER_TEST_INFO",
    FETCH_LEARNER_LIVE_CLASS_INFO: "LIVE_MENTORING:FETCH_LEARNER_LIVE_CLASS_INFO",
    FETCH_PREVIOUS_NOTES: "LIVE_MENTORING:FETCH_PREVIOUS_NOTES",
    FETCH_ADDABLE_NOTES_INFO: "LIVE_MENTORING:FETCH_ADDABLE_NOTES_INFO",
    FETCH_MENTOR_NOTES: "LIVE_MENTORING:FETCH_MENTOR_NOTES"
};
var freePracticeSessionTypes = {
    FETCH_FREE_PRACTICE_TOPOLOGIES: "FETCH_FREE_PRACTICE_TOPOLOGIES",
    FETCH_FREE_PRACTICE_TOPOLOGY_LIST: "FETCH_FREE_PRACTICE_TOPOLOGY_LIST",
    FETCH_FREE_PRACTICE_QUESTIONS: "FETCH_FREE_PRACTICE_QUESTIONS",
    UPDATE_FREE_PRACTICE_QUESTION_COUNT: "UPDATE_FREE_PRACTICE_QUESTION_COUNT"
};
var learnerDoubtsAndSolutionsTypes = {
    FETCH_CATALOG_ENTITY_DATA: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_CATALOG_ENTITY_DATA",
    FETCH_CATALOGUE_TYPES: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_CATALOGUES_TYPES",
    FETCH_CATALOGUE_DETAILS: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_CATALOGUE_DETAILS",
    FETCH_CATALOGUE_ENTITY_DETAILS: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_CATALOGUE_ENTITY_DETAILS",
    FETCH_QUESTIONS_LIST: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_QUESTIONS_LIST",
    FETCH_QUESTION_META_DATA: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_QUESTION_META_DATA",
    FETCH_QUESTION_PAPER_LIST: "LEARNER_DOUBTS_AND_SOLUTIONS: FETCH_QUESTION_PAPER_LIST"
};
var createQuizTypes = {
    CREATE_QUIZ_CHECK_ACCESS: "CREATE_QUIZ_CHECK_ACCESS",
    CREATE_QUIZ_FETCH_QUIZ_DEATILS: "CREATE_QUIZ_FETCH_QUIZ_DEATILS",
    CREATE_QUIZ_FETCH_QUIZ_QUESTIONS: "CREATE_QUIZ_FETCH_QUIZ_QUESTIONS",
    CREATE_QUIZ_FETCH_REVIEW_DETAILS: "CREATE_QUIZ_FETCH_REVIEW_DETAILS",
    CREATE_QUIZ_FINISH_REVIEW: "CREATE_QUIZ_FINISH_REVIEW",
    CREATE_QUIZ_UPDATE_SECTIONAL_QUESTION: "CREATE_QUIZ_UPDATE_SECTIONAL_QUESTION",
    CREATE_QUIZ_UPDATE_QUIZ_INSTRUCTIONS: "CREATE_QUIZ_UPDATE_QUIZ_INSTRUCTIONS",
    CREATE_QUIZ_MARK_PDF_UPLOADED: "CREATE_QUIZ_MARK_PDF_UPLOADED",
    CREATE_QUIZ_DELETE_SUBJECTIVE_PDF: "CREATE_QUIZ_DELETE_SUBJECTIVE_PDF",
    CREATE_QUIZ_CREATE_OR_UPDATE_ISSUES: "CREATE_QUIZ_CREATE_OR_UPDATE_ISSUES",
    CREATE_QUIZ_FETCH_REVIEW_NOTIFICATIONS: "CREATE_QUIZ_FETCH_REVIEW_NOTIFICATIONS",
    CREATE_QUIZ_RESOLVE_ISSUES: "CREATE_QUIZ_RESOLVE_ISSUES",
    CREATE_QUIZ_LEARNER_RESOLVE_ISSUES: "CREATE_QUIZ_LEARNER_RESOLVE_ISSUES",
    CREATE_QUIZ_FETCH_QUIZ_AUTO_CONFIGS: "CREATE_QUIZ_FETCH_QUIZ_AUTO_CONFIGS",
    CREATE_QUIZ_SAVE_QUIZ_AUTO_CONFIGS: "CREATE_QUIZ_SAVE_QUIZ_AUTO_CONFIGS",
    CREATE_QUIZ_FETCH_TOPOLOGY: "CREATE_QUIZ_FETCH_TOPOLOGY",
    CREATE_QUIZ_SETUP_INITIAL_AUTO_CONFIGS: "CREATE_QUIZ_SETUP_INITIAL_AUTO_CONFIGS",
    CREATE_QUIZ_UPDATE_QUIZ_AUTO_CONFIGS: "CREATE_QUIZ_UPDATE_QUIZ_AUTO_CONFIGS",
    CREATE_QUIZ_DELETE_QUIZ_AUTO_CONFIGS: "CREATE_QUIZ_DELETE_QUIZ_AUTO_CONFIGS",
    CREATE_QUIZ_UPDATE_SELECTED_TOPICS: "CREATE_QUIZ_UPDATE_SELECTED_TOPICS",
    CREATE_QUIZ_UPDATE_SELECTED_CONCEPTS: "CREATE_QUIZ_UPDATE_SELECTED_CONCEPTS",
    CREATE_QUIZ_UPDATE_SYLLABUS_QUESTION_COUNT: "CREATE_QUIZ_UPDATE_SYLLABUS_QUESTION_COUNT",
    CREATE_QUIZ_UPDATE_TOPIC_QUESTION_COUNT: "CREATE_QUIZ_UPDATE_TOPIC_QUESTION_COUNT",
    CREATE_QUIZ_MODAL_TYPES: "CREATE_QUIZ_MODAL_TYPES",
    CREATE_QUIZ_DELETE_QUESTION: "CREATE_QUIZ_DELETE_QUESTION",
    CREATE_QUIZ_REPLACE_QUESTION: "CREATE_QUIZ_REPLACE_QUESTION",
    CREATE_QUIZ_REORDER_QUESTION: "CREATE_QUIZ_REORDER_QUESTION",
    CREATE_QUIZ_FETCH_QUESTION_FEEDBACK_OPTIONS: "CREATE_QUIZ_FETCH_QUESTION_FEEDBACK_OPTIONS",
    CREATE_QUIZ_REPORT_CREATED_QUESTION: "CREATE_QUIZ_REPORT_CREATED_QUESTION"
};
var notesTypes = {
    FETCH_LOCALITY: "FETCH_LOCALITY",
    CREATE_NOTES_ORDER: "CREATE_NOTES_ORDER",
    GET_USER_STATUS: "GET_USER_STATUS"
};
var evaluateQuizTypes = {
    EVALUATE_QUIZ_FETCH_DETAILS: "EVALUATE_QUIZ_FETCH_DETAILS",
    EVALUATE_QUIZ_FETCH_QUESTIONS: "EVALUATE_QUIZ_FETCH_QUESTIONS",
    EVALUATE_QUIZ_FETCH_CRITERIA: "EVALUATE_QUIZ_FETCH_CRITERIA",
    EVALUATE_QUIZ_FETCH_FEEDBACK_CHOICES: "EVALUATE_QUIZ_FETCH_FEEDBACK_CHOICES",
    EVALUATE_QUIZ_SKIP_EVALUATION_FEEDBACK: "EVALUATE_QUIZ_SKIP_EVALUATION_FEEDBACK",
    EVALUATE_QUIZ_ADD_ADVICE_TO_LEARNER: "EVALUATE_QUIZ_ADD_ADVICE_TO_LEARNER",
    EVALUATE_QUIZ_ADD_CRITERIA_SCORE: "EVALUATE_QUIZ_ADD_CRITERIA_SCORE",
    EVALUATE_QUIZ_ADD_MARKS_TO_QUESTION: "EVALUATE_QUIZ_ADD_MARKS_TO_QUESTION",
    EVALUATE_QUIZ_MARK_QUESTION_AS_SKIPPED: "EVALUATE_QUIZ_MARK_QUESTION_AS_SKIPPED",
    EVALUATE_QUIZ_SUBMIT_SCORE: "EVALUATE_QUIZ_SUBMIT_SCORE",
    EVALUATE_QUIZ_REMOVE_EVALUATION: "EVALUATE_QUIZ_REMOVE_EVALUATION"
};
var iconicOnboardingTypes = {
    FETCH_ICONIC_ONBOARDING_INFO: "FETCH_ICONIC_ONBOARDING_INFO",
    FETCH_USER_DETAILS: "FETCH_USER_DETAILS",
    BOOK_WELCOME_SESSION: "BOOK_WELCOME_SESSION",
    UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS"
};
var oneToOneLivementoring = {
    FETCH_SESSIONS_META: "FETCH_SESSIONS_META",
    FETCH_SESSION_DETAILS: "oneToOneLivementoring:FETCH_SESSION_DETAILS",
    CANCEL_SESSION_WITH_REASON: "oneToOneLivementoring:CANCEL_SESSION_WITH_REASON",
    BOOK_WELCOME_SESSION: "oneToOneLivementoring:BOOK_WELCOME_SESSION",
    FETCH_LMP_ONBOARDING_PREFERENCES: "FETCH_LMP_ONBOARDING_PREFERENCES",
    SET_ONBOARDING_PREFERNCES: "SET_ONBOARDING_PREFERNCES",
    CHECK_SESSION_CONFLICT: "CHECK_SESSION_CONFLICT",
    CONFIRM_SESSION: "CONFIRM_SESSION"
};
var plannerTypes = {
    SET_CURRENT_DATE: "PLANNER: SET_CURRENT_DATE",
    RESET_EVENT_DATA: "PLANNER: RESET_EVENT_DATA",
    SET_EVENT_DATA: "PLANNER: SET_EVENT_DATA",
    SET_MULTIPLE_EVENT_DATA: "PLANNER: SET_MULTIPLE_EVENT_DATA",
    SET_IS_FIRST_RUN: "PLANNER: SET_IS_FIRST_RUN",
    SET_DATA: "PLANNER: SET_DATA",
    RESET: "PLANNER: RESET",
    SET_IS_INITIAL_SETUP_COMPLETE: "PLANNER: SET_IS_INITIAL_SETUP_COMPLETE",
    SET_IS_FINAL_SETUP_COMPLETE: "PLANNER: SET_IS_FINAL_SETUP_COMPLETE",
    SET_IS_EVERY_TIME_TASKS_SETUP_COMPLETE: "PLANNER: SET_IS_EVERY_TIME_TASKS_SETUP_COMPLETE",
    FETCH_DATA_IN_BACKGROUND_IN_PROGRESS: "FETCH_DATA_IN_BACKGROUND_IN_PROGRESS",
    CORRUPTED_PLANNER_DATA: "CORRUPTED_PLANNER_DATA",
    CANCEL_LMP_SESSION: "PLANNER: CANCEL_LMP_SESSION",
    UPDATE_BROWSE_CARD: "PLANNER: UPDATE_BROWSE_CARD",
    UPDATE_FEATURE_CARDS: "PLANNER: UPDATE_FEATURE_CARDS",
    UPDATE_FEATURE_AWARENESS_CARD_CLICK: "PLANNER: FEATURE AWARENESS CARD CLICK"
};
var groupTypes = {
    FETCH_GROUPS_INFO: "FETCH_GROUPS_INFO",
    FETCH_GROUPS_LEADERBOARD: "FETCH_GROUPS_LEADERBOARD",
    FETCH_GROUP_MEMBER_STATUS: "FETCH_GROUP_MEMBER_STATUS",
    FETCH_GROUP_MEMBER_DETAILS: "FETCH_GROUP_MEMBER_DETAILS",
    FETCH_INVITEE_INFO: "FETCH_INVITEE_INFO",
    JOIN_INVITE: "JOIN_INVITE",
    TOGGLE_INVITATION_RECEIVED: "TOGGLE_INVITATION_RECEIVED",
    TOGGLE_GROUP_ONBOARDING_MESSAGE: "TOGGLE_GROUP_ONBOARDING_MESSAGE",
    FETCH_GROUPS_ITEM_INFO: "FETCH_GROUPS_ITEM_INFO"
};
var doubtsOnWeb2 = {
    GET_MY_DOUBTS: "DOW2: GET_MY_DOUBTS",
    GET_DOUBT_CONFIGS: "DOW2: GET_DOUBT_CONFIGS",
    GET_DOUBT_DETAILS: "DOW2: GET_DOUBT_DETAILS",
    GET_ALL_DOUBTS: "DOW2: GET_ALL_DOUBTS",
    FETCH_ALL_FILTERS: "DOW2: FETCH_ALL_FILTERS",
    SET_SELECTED_FILTER: "SET_SELECTED_FILTER",
    SET_SUBMIT_DOUBT_DETAILS: "DOW2: SUBMIT_DOUBT_DETAILS",
    FETCH_SUBJECTS_AND_LANGUAGES: "DOW2: FETCH_SUBJECTS_AND_LANGUAGES",
    SUBMIT_DOUBT: "DOW2: SUBMIT_DOUBT",
    SET_LIMIT_FLAG: "SET_LIMIT_FLAG",
    GET_FEEDBACK_CHOICES: "DOW2: GET_FEEDBACK_CHOICES",
    SET_SELECTED_FEEDBACK_CHOICE: "DOW2: SET_SELECTED_FEEDBACK_CHOICE",
    SET_SELECTED_DOUBT_SOLUTION: "DOW2: SET_SELECTED_DOUBT_SOLUTION",
    SUBMIT_FEEDBACK: "DOW2: SUBMIT_FEEDBACK",
    SET_FEEDBACK_DRAWER_FLAG: "DOW: SET_FEEDBACK_DRAWER_FLAG",
    SET_FEEDBACK_SUBMITED: "DOW: SET_FEEDBACK_SUBMITED",
    SUBMIT_FOR_REVIEW: "DOW2: SUBMIT FOR REVIEW",
    SET_INSTANT_MATCH_FLAG: "DOW2: SET INSTANT MATCH",
    SET_IS_SOLUTION_WATCHED: "DOW2: SET IS SOLUTION WATCHED",
    SET_DOUBT_CONFIG: "SET_DOUBT_CONFIG",
    SAVE_LANGUAGE_PREFERENCE: "SAVE_LANGUAGE_PREFERENCE",
    UPDATE_DOUBT_SUBJECT: "UPDATE_DOUBT_SUBJECT",
    UPDATE_SUBJECT_SELECTED_FLOW: "UPDATE_SUBJECT_SELECTED_FLOW",
    FETCH_BLUE_DOT_FOR_NAV_ITEMS: "FETCH_BLUE_DOT_FOR_NAV_ITEMS"
};
var rankPredictor = {
    GET_RANK_PREDICTOR_SUGGESTIONS: "GET_RANK_PREDICTOR_SUGGESTIONS",
    GET_RANK_PREDICTOR_HTML: "GET_RANK_PREDICTOR_HTML",
    GET_RANK_PREDICTOR_RANK: "GET_RANK_PREDICTOR_RANK"
};


/***/ }),

/***/ 80572:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var shareToFB = function(param) {
    var url = param.url, _title = param.title, title = _title === void 0 ? "" : _title;
    if (window) {
        var encodedURL = encodeURIComponent(url);
        var encodedTEXT = encodeURIComponent(title || "");
        var ShareUrl = "http://www.facebook.com/share.php?u=".concat(encodedURL, "&title=").concat(encodedTEXT);
        window.open(ShareUrl);
    }
};
var shareToTwitter = function(param) {
    var url = param.url, _text = param.text, text = _text === void 0 ? "" : _text;
    if (window) {
        var suffixText = " ".concat(url, " @unacademy");
        var encodedText = text ? "".concat(encodeURIComponent(text), " ").concat(encodeURIComponent(suffixText)) : encodeURIComponent(suffixText);
        var ShareUrl = "http://twitter.com/share?text=".concat(encodedText);
        window.open(ShareUrl);
    }
};
var handleWhatsappShare = function(param) {
    var _url = param.url, url = _url === void 0 ? "" : _url, _text = param.text, text = _text === void 0 ? "" : _text;
    if (window) {
        var encodedText = encodeURIComponent("".concat(text, "\n ").concat(url));
        var ShareUrl = "whatsapp://send?text=".concat(encodedText);
        window.open(ShareUrl);
    }
};
var shareToWhatsappwWeb = function(param) {
    var url = param.url, _text = param.text, text = _text === void 0 ? "" : _text;
    if (window) {
        var ShareUrl = "https://web.whatsapp.com/send?url=".concat(url, "&text=").concat(text);
        window.open(ShareUrl);
    }
};
var shareToTelegram = function(param) {
    var url = param.url, _text = param.text, text = _text === void 0 ? "" : _text;
    if (window) {
        var ShareUrl = "https://telegram.me/share/url?url=".concat(url, "&text=").concat(text);
        window.open(ShareUrl);
    }
};
var socialShare = {
    shareToFB: shareToFB,
    shareToTwitter: shareToTwitter,
    shareToWhatsappwWeb: shareToWhatsappwWeb,
    shareToTelegram: shareToTelegram,
    handleWhatsappShare: handleWhatsappShare
};
/* harmony default export */ __webpack_exports__["Z"] = (socialShare);


/***/ }),

/***/ 78162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ updateQuery; }
/* harmony export */ });
/* eslint-disable prefer-template */ function updateQuery(uri, key, value) {
    if (uri) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) return uri.replace(re, "$1" + key + "=" + value + "$2");
        return uri + separator + key + "=" + value;
    }
    return "";
};


/***/ })

}]);